import React, { useCallback, useContext, useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import "../../src/assets/AdminCss/cricket.css";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { AuthContext, base_url ,userdata} from "../context/Authcontext";
import toast from "react-hot-toast";
import LoginReg from "./LoginReg";
import CricketScoreboard from "./CricketScoreboard";
import MarqueeBottom from "./components/MarqueeBottom";
import { useTheme } from "../context/ThemeContext";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import {
  ConsoleSqlOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { Button, Modal, Space } from "antd";
import Offcanvas from "react-bootstrap/Offcanvas";
import GameButtons from "./components/GameButtons";

const Cricket = () => {
  const [isSidebar, setSidebar] = useState(false);
  const location = useLocation();
  const [back1, setBack1] = useState([]);
  const [lay1, setLay1] = useState([]);
  const [back2, setBack2] = useState([]);
  const [lay2, setLay2] = useState([]);
  const [backActive, setbackActive] = useState(0);
  const [layActive, setlayActive] = useState(3);
  const [profit, setProfit] = useState(0);
  const [pr, setPr] = useState(0);
  const [active, setActive] = useState(false);
  const [selectFancy, setSelectFancy] = useState("");
  const [status, setStatus] = useState(0);
  const [side, setSide] = useState("");
  const [fancyValue, setFancyValue] = useState(0);
  const [newactive, setNewActive] = useState(0);
  const [isExpanded, setIsExpanded] = useState(1);
  const [isExpanded1, setIsExpanded1] = useState(1);
  const [isExpanded2, setIsExpanded2] = useState(1);
  const [isExpanded3, setIsExpanded3] = useState(1);
  const [isExpanded4, setIsExpanded4] = useState(1);
  const [isExpanded5, setIsExpanded5] = useState(1);
  const [isExpanded6, setIsExpanded6] = useState(1);
  const [fancyData, setFancyData] = useState();
   const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [fancyName, setFancyName] = useState("");
    const [fancy1Loading, setFancy1Loading] = useState(false);
  const [fancy2Loading, setFancy2Loading] = useState(false);
   const [rate, setRate] = useState("");

  const [oddsDelay, setOddsDelay] = useState();
  const [bookMakerDelay, setBookMakerDelay] = useState();
  const [miniBookMakerDelay, setMiniBookMakerDelay] = useState();
  const [fancyDelay, setFancyDelay] = useState();
  const [tossDelay, setTossDelay] = useState();
  const { userdata } = useContext(AuthContext);

  const [selectedPrice, setSelectedPrice] = useState();
  const [money, setMoney] = useState(0);
  const { isAuthenticated } = useContext(AuthContext);
  const [matchLiabilities, setMatchLiabilities] = useState();
  const [oddMatchLiablity, setOddMatchLiablity] = useState();

  const [marketId, setMarketId] = useState(() => {
    return sessionStorage.getItem("marketId") || "";
  });

  const [runner1, setRunner1] = useState(() => {
    return sessionStorage.getItem("runner1") || "";
  });

  const [runner2, setRunner2] = useState(() => {
    return sessionStorage.getItem("runner2") || "";
  });

  const [selectedId, setSelectedId] = useState(0);
  const [runner, setRunner] = useState("");

  const competiton = sessionStorage.getItem("competitionname");
  const event = sessionStorage.getItem("eventname");
  const selectionid1 = sessionStorage.getItem("selectionid1");
  const selectionid2 = sessionStorage.getItem("selectionid2");

  const eventId = sessionStorage.getItem("eventid");

  console.log(eventId, "eventid");

  useEffect(() => {
    if (eventId) {
      setChannel(eventId);
    }
  }, []); // run once on mount

  const [fancy, setFancy] = useState([]);

  const [selectedMarket, setSelectedMarket] = useState();
  const [fancyBet, setFancyBet] = useState(0);
  const [fancymarket, setFancyMarket] = useState(0);
  const [fancyOdd, setFancyOdd] = useState(0);
  const [fancyXtra, setFancyXtra] = useState(0);
  const [selectedBet, setSelectedBet] = useState(0);
  const [stake, setStake] = useState(0);
  const [startTime, setStartTime] = useState();
  const [book1, setBook1] = useState([]);
  const [book2, setBook2] = useState([]);
  const [channel, setChannel] = useState();
  const [betData, setBetData] = useState([]);
  const [fancyBetData, setFancyBetData] = useState([]);
  const [bookmakerProfit, setBookMakerProfit] = useState(0);
  const [toss1, setToss1] = useState();
  const [toss2, setToss2] = useState();
  const [play, setPlay] = useState(false);
  const [mini1, setMini1] = useState([]);
  const [mini2, setMini2] = useState([]);
  const [oddEven, setOddEven] = useState([]);
  const [session, setSession] = useState([]);
  const [wpMarket, setWPMarket] = useState([]);
  const [fancySrno, setFancySrno] = useState(0);
  const [minOdds, setMinOdds] = useState(100);
  const [minBookmaker, setMinBookmaker] = useState(100);
  const [minMiniBook, setMinMiniBook] = useState(100);
  const [minFancy, setMinFancy] = useState(100);
  const [maxOdds, setMaxOdds] = useState(25000);
  const [maxBookmaker, setMaxBookmaker] = useState(25000);
  const [maxMiniBook, setMaxMiniBook] = useState(25000);
  const [maxFancy, setMaxFancy] = useState(25000);
  const [unmatch, setUnmatch] = useState([]);
  const { themeColors } = useTheme();

  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 991);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showV, setShowV] = useState(false);
  const handleCloseV = () => setShowV(false);
  const handleShowV = () => setShowV(true);
  const [oddb1, setOddb1] = useState("");
  const [oddb2, setOddb2] = useState("");
  const [oddm1, setOddm1] = useState("");
  const [oddm2, setOddm2] = useState("");

  const [gameButtons, setGameButtons] = useState([]);
  const handleButtonsChange = (updatedButtons) => {
    setGameButtons(updatedButtons);
    console.log("Buttons in Cricket.js:", updatedButtons);
  };

  const [showCanvas, setShowCanvas] = useState(false);

  const handleCanvasShow = () => setShowCanvas(true);
  const handleCanvasClose = () => setShowCanvas(false);

  const [open, setOpen] = useState(false);
  const showModal = () => {
    setOpen(true);
  };
  const hideModal = () => {
    setOpen(false);
  };

  console.log("money is ", money, selectedPrice);

  // bet form data
  const [formData, setFormData] = useState({
    competiton: competiton,
    eventname: event,
    eventid: 0,
    marketId: marketId,
    selectionId: 0,
    runnername: "",
    betPrice: 0,
    type: "odds",
    betAmount: 0,
    profit: 0,
    side: "",
    status: 0,
    sportName: "cricket",
    team1: runner1,
    team2: runner2,
  });

  // fancy bet form data
  const [formData1, setFormData1] = useState({
    competiton: competiton,
    eventname: event,
    eventid: 0,
    marketId: marketId,
    selectionId: 0,
    runnername: "",
    betPrice: 0,
    type: "fancy",
    betAmount: 0,
    srno: "",
    value: 0,
    rate: 0,
    side: "",
    status: 0,
    sportName: "cricket",
  });

  // book maker bet form
  const [formData2, setFormData2] = useState({
    competiton: competiton,
    eventname: event,
    eventid: 0,
    marketId: marketId,
    selectionId: 0,
    runnername: "",
    betPrice: 0,
    type: "book maker",
    betAmount: 0,
    profit: 0,
    side: "",
    sportName: "cricket",
    team1: runner1,
    team2: runner2,
  });

  // toss bet
  const [formData3, setFormData3] = useState({
    competiton: competiton,
    eventname: event,
    eventid: 0,
    marketId: marketId,
    selectionId: 0,
    runnername: "",
    betPrice: 0,
    type: "toss",
    betAmount: 0,
    profit: 0,
    side: "",
    sportName: "cricket",
    team1: runner1,
    team2: runner2,
  });

  // mini book maker
  const [formData4, setFormData4] = useState({
    competiton: competiton,
    eventname: event,
    eventid: 0,
    marketId: marketId,
    selectionId: 0,
    runnername: "",
    betPrice: 0,
    type: "mini_bookmaker",
    betAmount: 0,
    profit: 0,
    side: "",
    sportName: "cricket",
    team1: runner1,
    team2: runner2,
  });
  // console.log('selec',selectedMarket);

  // console.log('iidd',marketId);

  function formatDate(isoString) {
    const date = new Date(isoString);
    return date.toLocaleString("en-US", {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  }

  function isTenMinutesRemaining(isoString) {
    const targetTime = new Date(isoString).getTime(); // Convert given time
    const currentTime = new Date().getTime(); // Get current time

    // Calculate the difference in milliseconds
    const timeDifference = targetTime - currentTime;

    // Convert milliseconds to minutes
    const minutesRemaining = timeDifference / (1000 * 60);

    return minutesRemaining > 10;
  }

  function convertDecimalToInteger(decimalValue) {
    // Get the integer part
    const integerPart = Math.floor(decimalValue);

    // Get the decimal part
    const decimalPart = decimalValue - integerPart;

    // Apply the rule
    if (decimalPart >= 0.5) {
      return integerPart + 1; // Round up
    } else {
      return integerPart; // Round down
    }
  }

  const handleChange = (action) => {
    // console.log('act',action);

    setMoney((prevMoney) => {
      let newMoney = prevMoney < 0 ? 0 : prevMoney;

      if (action === 0) {
        return Math.max(0, parseFloat(newMoney) - 100);
      } else {
        return parseFloat(newMoney) + 100;
      }
    });
  };

  const handleChangeStake = (action) => {
    setStake((prev) => {
      let newMoney = prev <= 0 ? 0 : prev;

      if (action === 0) {
        return parseFloat(newMoney) + 100;
      } else {
        return parseFloat(newMoney) - 100;
      }
    });
  };

  const handlelayChange = (action) => {
    setSelectedPrice((prev) => {
      let newMoney = prev < 1.01 ? 1.01 : prev;

      if (action === 0) {
        return Math.max(0, (parseFloat(newMoney) - 0.01).toFixed(2));
      } else {
        return (parseFloat(newMoney) + 0.01).toFixed(2);
      }
    });
  };

  const handlefancyChange = (action) => {
    setSelectedMarket((prev) => {
      let newMoney = prev <= 1 ? 1 : prev;

      if (action === 0) {
        return Math.max(0, parseFloat(newMoney) - 1);
      } else {
        return parseFloat(newMoney) + 1;
      }
    });
  };

  useEffect(() => {
    const getTimeDelay = async () => {
      try {
        const response = await axios.get(
          base_url + "/get/api/webapi/sportsData/timeDelay",
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json",
            },
          }
        );

        // console.log(response.data.betDelay[0].book_maker_cricket, "responseeefe");
        if (response?.data.success) {
          if (response?.data.betDelay.length > 0) {
            let timeDelayData = response?.data.betDelay;
            const delays = timeDelayData[0] || "";

            const oddss = JSON.parse(delays?.match_odds_cricket);
            const oddsDelay = oddss?.bet_delay || 0;
            const minBet = oddss?.min_bet || 0;
            const maxBet = oddss?.max_bet || 0;
            // console.log(minBet);
            setMinOdds(minBet);
            setMaxOdds(maxBet);
            setOddsDelay(oddsDelay * 1000);

            const bookMaker = JSON.parse(delays?.book_maker_cricket);
            const bookMakerDelay = bookMaker?.bet_delay || 0;
            const minBook = bookMaker?.min_bet || 0;
            const maxBook = bookMaker?.max_bet || 0;
            setMinBookmaker(minBook);
            setMaxBookmaker(maxBook);
            setBookMakerDelay(bookMakerDelay * 1000);

            const miniBookMaker = JSON.parse(delays?.mini_book_maker_cricket);
            const miniBookMakerDelay = miniBookMaker?.bet_delay || 0;
            const miniMin = miniBookMaker?.min_bet || 0;
            const miniMax = miniBookMaker?.max_bet || 0;
            setMinMiniBook(miniMin);
            setMaxMiniBook(miniMax);
            setMiniBookMakerDelay(miniBookMakerDelay * 1000);

            const fancy = JSON.parse(delays?.fancy_cricket);
            const fancyDelay = fancy?.bet_delay || 0;
            const miniFancy = fancy?.mini_bet || 0;
            const maxFancy = fancy?.max_bet || 0;
            setMinFancy(miniFancy);
            setMaxFancy(maxFancy);
            setFancyDelay(fancyDelay * 1000);

            const toss = JSON.parse(delays?.to_win_the_toss_cricket);
            const tossDelay = toss?.bet_delay || 0;
            setTossDelay(tossDelay * 1000);

            // const minBet= JSON.parse(delays?.to_win_the_toss_cricket);
          }
        }
      } catch (err) {
        console.log(err);
      }
    };

    getTimeDelay();
  }, []);

  const betDataa = async () => {
    try {
      const response = await axios.post(
        base_url + "/api/webapi/betData",
        { eventId },
        {
          withCredentials: true,
          headers: {
            "content-type": "application/json",
          },
        }
      );

      if (response?.data.success) {
        const sportsBets = response?.data.sportsBets;
        const fancyBets = response?.data.fancyBets;
        const unmach = response?.data.unmatch;
        // console.log('ddd',data);
        setBetData(sportsBets);
        setFancyBetData(fancyBets);
        setUnmatch(unmach);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // formdata odds
  const handleSubmit = async () => {
    if (!isAuthenticated) {
      setActive(true);
      return;
    }

    if (money < minOdds) {
      toast.error("Bet can't be placed for less than min value");
      return;
    }

    if (money > maxOdds) {
      toast.error("Bet can't be placed for greater than max value");
      return;
    }

    if (selectedPrice < 1) {
      toast.error("Bet selected price is too low");
      return;
    }

    // ✅ Ensure `oddsDelay` has a valid value
    const delay = oddsDelay || 0;

    setTimeout(async () => {
      if (side === "Back") {
        const allBackPrices = [...back1, ...back2];
        const valueExists = allBackPrices.some(
          (bac) => bac.price === selectedPrice
        );
        if (!valueExists) {
          try {
            const response = await axios.post(
              base_url + "/api/webapi/unmatched",
              formData,
              {
                withCredentials: true,
                headers: {
                  "content-type": "application/json",
                },
              }
            );

            if (response?.data.success) {
              toast.error("Bet placed to unmatched due to value change");
              betDataa();
              getMatchLiabilities();

            }
          } catch (err) {
            console.log(err);
          }

          return;
        }
      }

      if (side === "Lay") {
        const allLayPrices = [...lay1, ...lay2];
        const valueExists = allLayPrices.some(
          (lay) => lay.price === selectedPrice
        );
        if (!valueExists) {
          try {
            const response = await axios.post(
              base_url + "/api/webapi/unmatched",
              formData,
              {
                withCredentials: true,
                headers: {
                  "content-type": "application/json",
                },
              }
            );

            if (response?.data.success) {
              toast.error("Bet placed to unmatched due to value change");
              betDataa();
              getMatchLiabilities();
            }
          } catch (err) {
            console.log(err);
          }

          return;
        }
      }

      console.log("formdata", formData);

      try {
        const response = await axios.post(
          `${base_url}/api/webapi/sportsData`,
          formData,
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json",
            },
          }
        );

        if (response?.data.success) {
          toast.success(response?.data.message);
          betDataa();
          getMatchLiabilities();
          userdata();
        } else {
          toast.error(response?.data.message);
        }
      } catch (err) {
        console.error(err);
        toast.error("Failed to place bet");
      }
    }, delay);
  };

  // formdata2 bookmaker
  const handleSubmit2 = async () => {
    if (!isAuthenticated) {
      setActive(true);
      return;
    }
    // if (isTenMinutesRemaining(startTime)) {
    //   toast.error("Off Bets! Bets placed only before ten minutes");
    //   return;
    // }

    if (money < minBookmaker) {
      toast.error("Bet cant be placed less min value");
      return;
    }
    if (money > maxBookmaker) {
      toast.error("Bet cant be placed greater than max value");
      return;
    }

    if (selectedPrice < 1) {
      toast.error("Bet selectedprice is less");
      return;
    }

    // ✅ Ensure `bookMakerDelay` has a valid value
    const delay = bookMakerDelay || 0;

    setTimeout(async () => {
      const combinedData = [
        book1.back_price,
        book1.lay_price,
        book2.back_price,
        book2.lay_price,
      ];

      if (!combinedData.includes(selectedPrice)) {
        try {
          const response = await axios.post(
            base_url + "/api/webapi/unmatched",
            formData2,
            {
              withCredentials: true,
              headers: {
                "content-type": "application/json",
              },
            }
          );

          if (response?.data.success) {
            toast.error("Bet placed to unmatched due to value change");
            betDataa();
          }
        } catch (err) {
          console.log(err);
        }

        return;
      }

      try {
        const response = await axios.post(
          base_url + "/api/webapi/sportsData",
          formData2,
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json",
            },
          }
        );

        // console.log('formmatch',response);

        if (response?.data.success) {
          toast.success(response?.data.message);
          betDataa();
        } else {
          toast.error(response?.data.message);
        }
      } catch (err) {
        console.log(err);
        toast.error("Failed to place bet");
      }
    }, delay);
  };

  // formdata1 fancy
  const handleSubmit3 = async () => {
    if (!isAuthenticated) {
      setActive(true);
      return;
    }

    if (stake < minFancy) {
      toast.error("Bet cant be placed less than min value");
      return;
    }
    if (stake > maxFancy) {
      toast.error("Bet cant be placed greater than max value");
      return;
    }

    if (selectedPrice < 1) {
      toast.error("Bet selectedprice is less");
      return;
    }
    // console.log(fancyData);
    // ✅ Ensure fancyDelay has a valid value
    const delay = fancyDelay || 0;
    console.log(formData1);
    console.log("delay", delay);

    console.log("this s bjndjhbdkjbndb", fancyData);

    setTimeout(async () => {
      // const allRates = fancyData
      //   ?.map((fancy) => {
      //     return Object.values(fancy?.rate.rates[0]);
      //   })
      //   .flat(); // Flatten the array in case of nested arrays

      // // console.log(allRates);

      // if (!allRates.includes(selectedMarket)) {

      //   try {
      //     const response = await axios.post(base_url + '/api/webapi/unmatched',
      //       formData1,
      //       {
      //         withCredentials: true,
      //         headers: {
      //           'content-type': 'application/json',
      //         }
      //       }
      //     );

      //     if (response?.data.success) {
      //       toast.error("Bet placed to unmatched due to value change");
      //       betDataa();
      //     }

      //   } catch (err) {
      //     console.log(err);
      //   }

      //   return;
      // }

      try {
        const response = await axios.post(
          base_url + "/api/webapi/sportsFancyData",
          formData1,
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json",
            },
          }
        );
        // console.log(response,"response")
        if (response?.data.success) {
          toast.success(response?.data.message);
          betDataa();
        getMatchLiabilities();
        } else {
          toast.error(response?.data.message);
        }
      } catch (err) {
        console.log(err);
        toast.error("Failed to place bet");
      }
    }, delay);
  };

  // formdata4 toss
  const handleSubmit4 = async () => {
    if (!isAuthenticated) {
      setActive(true);
      return;
    }

    if (money < 100) {
      toast.error("Bet cant be placed less than Rs.100");
      return;
    }

    if (selectedPrice < 1) {
      toast.error("Bet selectedprice is less");
      return;
    }

    // ✅ Ensure `tossDelay` has a valid value
    const delay = tossDelay || 0;

    setTimeout(async () => {
      // const combinedData = [
      //   toss1.back_price, toss1.lay_price,
      //   toss2.back_price, toss2.lay_price
      // ];

      // if (!combinedData.includes(selectedPrice)) {
      //   toast.error("Bet can't be placed due to value change");
      //   return;
      // }

      try {
        const response = await axios.post(
          base_url + "/api/webapi/sportsData",
          formData3,
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json",
            },
          }
        );

        // console.log('formmatch',response);

        if (response?.data.success) {
          toast.success(response?.data.message);
          betDataa();
        } else {
          toast.error(response?.data.message);
        }
      } catch (err) {
        console.log(err);
        toast.error("Failed to place bet");
      }
    }, delay);
  };

  // minibookmaker
  const handleSubmit5 = async () => {
    if (!isAuthenticated) {
      setActive(true);
      return;
    }
    // if (isTenMinutesRemaining(startTime)) {
    //   toast.error("Off Bets! Bets placed only before ten minutes");
    //   return;
    // }

    if (money < minMiniBook) {
      toast.error("Bet cant be placed less than min value");
      return;
    }
    if (money > maxMiniBook) {
      toast.error("Bet cant be placed greater than max value");
      return;
    }

    if (selectedPrice < 1) {
      toast.error("Bet selectedprice is less");
      return;
    }

    // ✅ Ensure `miniBookMakerDelay` has a valid value
    const delay = miniBookMakerDelay || 0;

    setTimeout(async () => {
      const combinedData = [
        mini1.back_price,
        mini1.lay_price,
        mini2.back_price,
        mini2.lay_price,
      ];

      if (!combinedData.includes(selectedPrice)) {
        try {
          const response = await axios.post(
            base_url + "/api/webapi/unmatched",
            formData4,
            {
              withCredentials: true,
              headers: {
                "content-type": "application/json",
              },
            }
          );

          if (response?.data.success) {
            toast.error("Bet placed to unmatched due to value change");
            betDataa();
          }
        } catch (err) {
          console.log(err);
        }

        return;
      }

      try {
        const response = await axios.post(
          base_url + "/api/webapi/sportsData",
          formData4,
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json",
            },
          }
        );

        // console.log('formmatch',response);

        if (response?.data.success) {
          toast.success(response?.data.message);
          betDataa();
        } else {
          toast.error(response?.data.message);
        }
      } catch (err) {
        console.log(err);
        toast.error("Failed to place bet");
      }
    }, delay);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setSidebar(true);
      } else {
        setSidebar(false);
      }
    };

    if (location.state?.marketId) {
      sessionStorage.setItem("marketId", location.state.marketId);
      setRunner1(location.state.marketId);
    }

    if (location.state?.runner1) {
      sessionStorage.setItem("runner1", location.state.runner1);
      setRunner2(location.state.runner1);
    }

    if (location.state?.runner2) {
      sessionStorage.setItem("runner2", location.state.runner2);
      setMarketId(location.state.runner2);
    }

    const proft =
      parseFloat(selectedPrice) * parseFloat(money) - parseFloat(money);
    setProfit(proft.toFixed(1));

    const fancyprofit = () => {
      const prff = (parseFloat(selectedPrice) * parseFloat(money)) / 100;

      // console.log('fancc',prff);
      const value = convertDecimalToInteger(prff);

      setBookMakerProfit(value);
    };

    // console.log('prff',proft);
    // Add event listener for resize
    window.addEventListener("resize", handleResize);
    handleResize();
    fancyprofit();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
      // sessionStorage.clear();
    };
  }, [location.state, money, selectedPrice]);

  // console.log(channel)

  useEffect(() => {
    window.scrollTo(0, 0);

     const fancyData = async () => {
      try {
        const response = await axios.get(base_url + "/api/webapi/getFancy");

        if (response?.data?.data && Array.isArray(response?.data.data)) {
          const fetchedData = response.data.data;

          // console.log(fetchedData,"fetchdata")

          const competitionId = sessionStorage.getItem("eventid");
          const matchedData = fetchedData.filter(
            (item) => item.eventId === competitionId
          );


          const oddData = matchedData.filter((item) => {
            return (
              (item.marketName.includes("Odd") ||
                item.marketName.includes("even")) &&
              !item.marketName.includes("Wicket") &&
              !item.marketName.includes("Fall") &&
              !item.marketName.includes("Boundaries")
            );
          });

          // console.log(oddData, "nejjcncj");
          const sess = matchedData.filter((item) => {
            return (
              (item.marketName.includes("Over") ||
                item.marketName.includes("Match")) &&
              !item.marketName.includes("Lambi") &&
              !item.marketName.includes("Fall") &&
              !item.marketName.includes("Boundaries")
            );
          });
          const wp = matchedData.filter(
            (item) =>
              item.marketName.includes("Fall") ||
              item.marketName.includes("fall") ||
              item.marketName.includes("Boundaries") ||
              item.marketName.includes("Wicket")
          );
          const mtch = matchedData.filter((item) => {
            return (
              !item.marketName.includes("Odd") &&
              !item.marketName.includes("Even") &&
              !item.marketName.includes("Over") &&
              !item.marketName.includes("Match") &&
              !item.marketName.includes("Fall") &&
              !item.marketName.includes("Wicket") &&
              !item.marketName.includes("Boundaries")
            );
          });

          // console.log(sess,"cdvvver")

          setFancyData(matchedData);
          setSession(sess);
          setOddEven(oddData);
          setWPMarket(wp);
          setFancy(mtch);
        } else {
          setFancy([]);
        }
      } catch (err) {
        console.error("Error fetching fancy data:", err);
        setFancy([]);
      }
    };

    const bookMakerData = async () => {
      try {
        const response = await axios.get(base_url + "/api/webapi/getBookMaker");
        // console.log("Full API Response:", response.data);

        if (response?.data?.data && Array.isArray(response.data.data)) {
          const fetchedData = response?.data.data;
          // console.log('fetch mini',fetchedData);

          const competitionId = sessionStorage.getItem("eventid");

          const tossMatchedData = fetchedData.filter(
            (item) =>
              item.eventId === competitionId &&
              item.marketName === "To Win The Toss"
          );

          const bookmakerData = fetchedData.filter(
            (item) =>
              item.eventId === competitionId && item.marketName === "BOOKMAKER"
          );

          const miniBookmaker = fetchedData.filter(
            (item) =>
              item.eventId === competitionId &&
              item.marketName === "MINI BOOKMAKER"
          );

          // console.log("mini book maker Data:", miniBookmaker);

          const mini2 = miniBookmaker[0]?.runner[0];
          const mini1 = miniBookmaker[0]?.runner[1];

          // console.log(mini1, mini2);

          const toss1 = tossMatchedData[0]?.runner[0];
          const toss2 = tossMatchedData[0]?.runner[1];
          // console.log(toss1, toss2);

          const bookmaker1 = bookmakerData[0]?.runner[0];
          const bookmaker2 = bookmakerData[0]?.runner[1];

          // console.log(bookmaker1, bookmaker2);

          setBook1(bookmaker2);
          setBook2(bookmaker1);
          setToss1(toss1);
          setToss2(toss2);
          setMini1(mini1);
          setMini2(mini2);
        } else {
          setFancy([]);
        }
      } catch (err) {
        console.error("Error fetching fancy data:", err);
        setFancy([]);
      }
    };


    // const minibookMakerData = async () => {
    //   try {
    //     const competitionId = sessionStorage.getItem("eventid");

    //     const response = await axios.get(
    //       base_url + "/api/webapi/getBookMaker",
    //       {
    //         params: { competitionId: competitionId },
    //       }
    //     );

    //     // console.log("API Response:", response?.data);

    //     const bookmaker = response?.data?.data?.data;

    //     if (Array.isArray(bookmaker) && bookmaker.length > 0) {
    //       // Find "Bookmaker" market
    //       const bookMarket = bookmaker.find(
    //         (m) => m.mname === "Mini_Bookmaker"
    //       );

    //       if (bookMarket) {
    //         // console.log("miniBookmaker Market:", bookMarket);

    //         // Example: extract first team odds from section[0]
    //         const team1 = bookMarket.section?.[0];
    //         const team2 = bookMarket.section?.[1];

    //         const team1Back = team1?.odds?.find((o) => o.oname === "back1");
    //         const team1Lay = team1?.odds?.find((o) => o.oname === "lay1");

    //         const team2Back = team2?.odds?.find((o) => o.oname === "back1");
    //         const team2Lay = team2?.odds?.find((o) => o.oname === "lay1");
    //         // console.log(team1.status, "cnen");
    //         // console.log("Team1 Back:", team1Back?.odds, "Lay:", team1Lay?.odds);
    //         // console.log("Team2 Back:", team2Back?.odds, "Lay:", team2Lay?.odds);

    //         // Now set in state
    //         setMiniBook1(team1); // team name
    //         setMiniBook2(team2);
    //         setMiniBok1back(team1Back?.odds);
    //         setMiniBok1lay(team1Lay?.odds);
    //         setMiniBok2back(team2Back?.odds);
    //         setMiniBok2lay(team2Lay?.odds);
    //       }
    //     } else {
    //       setFancy([]);
    //     }

    //     // Optionally set fancy if available
    //     if (Array.isArray(fancy)) {
    //       setFancy(fancy);
    //     }
    //   } catch (err) {
    //     console.error("Error fetching bookmaker data:", err);
    //     setFancy([]);
    //   }
    // };

    // const tossData = async () => {
    //   try {
    //     const competitionId = sessionStorage.getItem("eventid");

    //     const response = await axios.get(
    //       base_url + "/api/webapi/getBookMaker",
    //       {
    //         params: { competitionId: competitionId },
    //       }
    //     );

    //     // console.log("API Response:", response?.data);

    //     const bookmaker = response?.data?.data?.data;

    //     if (Array.isArray(bookmaker) && bookmaker.length > 0) {
    //       // Find "Bookmaker" market
    //       const bookMarket = bookmaker.find((m) => m.mname === "");

    //       if (bookMarket) {
    //         // console.log("miniBookmaker Market:", bookMarket);

    //         // Example: extract first team odds from section[0]
    //         const team1 = bookMarket.section?.[0];
    //         const team2 = bookMarket.section?.[1];

    //         const team1Back = team1?.odds?.find((o) => o.oname === "back1");
    //         const team1Lay = team1?.odds?.find((o) => o.oname === "lay1");

    //         const team2Back = team2?.odds?.find((o) => o.oname === "back1");
    //         const team2Lay = team2?.odds?.find((o) => o.oname === "lay1");
    //         // console.log(team1.status,"cnen")
    //         // console.log("Team1 Back:", team1Back?.odds, "Lay:", team1Lay?.odds);
    //         // console.log("Team2 Back:", team2Back?.odds, "Lay:", team2Lay?.odds);

    //         // Now set in state
    //         setMiniBook1(team1); // team name
    //         setMiniBook2(team2);
    //         setMiniBok1back(team1Back?.odds);
    //         setMiniBok1lay(team1Lay?.odds);
    //         setMiniBok2back(team2Back?.odds);
    //         setMiniBok2lay(team2Lay?.odds);
    //       }
    //     } else {
    //       setFancy([]);
    //     }

    //     // Optionally set fancy if available
    //     if (Array.isArray(fancy)) {
    //       setFancy(fancy);
    //     }
    //   } catch (err) {
    //     console.error("Error fetching bookmaker data:", err);
    //     setFancy([]);
    //   }
    // };
    const backLay = async () => {
      try {
        const response = await axios.get(
          base_url + `/api/webapi/market/${marketId}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const status1 = response?.data.result[0]?.status;
        const status2 = response?.data.result[1]?.status;
        console.log("wkjenkfjebnrjg", status1);
        console.log("2kjrk,befgrhkgyuf", status2);

        if (status1 === "ACTIVE") {
          const backk1 = response?.data.result[0]?.ex?.availableToBack;
          const layy1 = response?.data.result[0]?.ex?.availableToLay;

          setBack1(backk1);
          setLay1(layy1);
        }

        if (status2 === "ACTIVE") {
          const backk2 = response?.data.result[1]?.ex?.availableToBack;
          const layy2 = response?.data.result[1]?.ex?.availableToLay;

          setBack2(backk2);
          setLay2(layy2);
        }
      } catch (err) {
        console.log("Error fetching in odds data", err);
      }
    };

    const sessiontime = sessionStorage.getItem("time");
    const time = formatDate(sessiontime);
    // console.log('time',time);
    setStartTime(time);

    const updateData = () => {
      fancyData();
      bookMakerData();
      backLay();
    };

    betDataa();
    getMatchLiabilities();

    const intervalId = setInterval(updateData, 500);

    return () => clearInterval(intervalId);
  }, []);

  const calculatePnLByMarket = (bets, team1, team2) => {
    const marketTypes = ["odds", "bookmaker", "mini_bookmaker"];
    const result = {};

    marketTypes.forEach((market) => {
      const marketBets = bets?.filter((b) => {
        const betType = b?.type
          ?.toString()
          .trim()
          .toLowerCase()
          .replace(/\s+/g, "");
        return betType === market;
      });

      // console.log(market, marketBets, "fev");

      const runnerPnl = {};

      // Collect unique runners
      const runners = new Set(marketBets.map((b) => b.runnerName));
      runners.add(team1);
      runners.add(team2);
      // Check if runner3 (i.e., "The Draw") exists in sessionStorage
      const runner3 = sessionStorage.getItem("runner3");
      if (runner3 && runner3.toLowerCase() === "the draw") {
        runners.add("The Draw");
      }

      // Initialize PnL
      for (const runner of runners) {
        runnerPnl[runner] = 0;
      }

      // Calculate PnL
      marketBets?.forEach(({ runnerName, side, betprice, betAmount }) => {
        const odds = parseFloat(betprice);
        const stake = parseFloat(betAmount);

        for (const currentRunner of runners) {
          if (marketBets[0].type === "book maker") {
            if (currentRunner === runnerName) {
              if (side === "Back") {
                runnerPnl[currentRunner] += (stake * odds) / 100;
              } else if (side === "Lay") {
                runnerPnl[currentRunner] -= (stake * odds) / 100;
              }
            } else {
              if (side === "Back") {
                runnerPnl[currentRunner] -= stake;
              } else if (side === "Lay") {
                runnerPnl[currentRunner] += stake;
              }
            }
          } else {
            if (currentRunner === runnerName) {
              if (side === "Back") {
                runnerPnl[currentRunner] += (odds - 1) * stake;
              } else if (side === "Lay") {
                runnerPnl[currentRunner] -= (odds - 1) * stake;
              }
            } else {
              if (side === "Back") {
                runnerPnl[currentRunner] -= stake;
              } else if (side === "Lay") {
                runnerPnl[currentRunner] += stake;
              }
            }
          }
        }
      });

      // Round to 2 decimal places
      Object.keys(runnerPnl).forEach((runner) => {
        runnerPnl[runner] = parseFloat(runnerPnl[runner].toFixed(2));
      });

      // Calculate liability (worst case)
      const liability = Object.values(runnerPnl).length
        ? Math.min(...Object.values(runnerPnl))
        : 0;

      result[market] = {
        pnl: runnerPnl,
        liability: parseFloat(liability.toFixed(2)),
      };
    });

    return result;
  };

  const getMatchLiabilities = async () => {
    try {
      const response = await axios.get(
        `${base_url}/api/webapi/getMatchLiablity/${eventId}`,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      const bets = response.data.liabilities || []; // ✅ fix here

      // console.log(bets, "bets after fix");

      const { team1, team2 } = bets[0] || {};

      const result = calculatePnLByMarket(bets, team1, team2);

      setMatchLiabilities(result);
    } catch (error) {
      console.error("Error fetching match liabilities:", error);
    }
  };

  // useEffect(() => {
  //   getMatchLiabilities();
  // });

    const calculateFancyPositions = (bets, targetRate) => {
    let position = 0;

    bets.forEach((bet) => {
      const betRate = parseFloat(bet?.betprice);
      const betAmount = parseFloat(bet?.betAmount);
      const rate = Math.abs(parseFloat(bet?.rate)); // always positive
      // const rate = oldRate > 0 ? -oldRate : oldRate;

      // const rate = oldRate < 0 ? -oldRate : oldRate;



      if (bet.side === "no") {
        // lay bet
        if (targetRate >= betRate) {
          // Lay bet loses - we pay out the liability (stake amount)
          position -= rate;
        } else {
          // Lay bet wins - we keep the stake
          position += betAmount;
        }
      } else if (bet.side === "yes") {
        // back bet
        if (targetRate >= betRate) {
          // Back bet wins - we get profit (stake amount for fancy bets)
          position += rate;
        } else {
          // Back bet loses - we lose the stake
          position -= betAmount;
        }
      }
    });

    return position;
  };


   const calculateOverallPosition = (fancyName, fancyBetData) => {
    const betsForFancy = fancyBetData.filter(
      (bet) => bet.runnerName === fancyName
    );
    if (betsForFancy.length === 0) return { profit: 0, loss: 0 };

    // Get the current rate for this fancy (assuming it's available)
    const currentRate = betsForFancy[0]?.betprice || 0;

    // console.log(currentRate, "currentRate");

    // Calculate best case and worst case scenarios
    let bestCase = -Infinity;
    let worstCase = Infinity;

    // Check positions for a range of possible outcomes
    for (
      let rate = parseFloat(currentRate) - 10;
      rate <= parseFloat(currentRate) + 10;
      rate++
    ) {
      // console.log(rate, "rate");

      const position = calculateFancyPositions(betsForFancy, rate);

      // console.log(position,"postion")

      bestCase = Math.max(bestCase, position);
      worstCase = Math.min(worstCase, position);
    }

    return {
      profit: bestCase > 0 ? bestCase : 0,
      loss: worstCase < 0 ? worstCase : 0,
    };
  };

  // console.log('matchess',wpMarket);
  // console.log('odd1',odd1[2]?.odds);

  // betformdata
  formData.selectionId = selectedId;
  formData.runnername = runner;
  formData.betAmount = money;
  formData.profit = profit;
  formData.eventid = eventId;
  formData.betPrice = selectedPrice;
  formData.side = side;

  // foemdata1
  formData1.eventid = eventId;
  formData1.runnername = selectFancy;
  formData1.betAmount = money;
  formData1.betPrice = fancyValue;
  formData1.side = side;
  formData1.value = fancyValue;
  formData1.rate = selectedMarket;
  formData1.srno = fancySrno;

  // formdata2
  formData2.eventid = eventId;
  formData2.runnername = runner;
  formData2.betAmount = money;
  formData2.profit = bookmakerProfit;
  formData2.betPrice = selectedPrice;
  formData2.selectionId = selectedId;
  formData2.side = side;

  // formdata3
  formData3.eventid = eventId;
  formData3.runnername = runner;
  formData3.betAmount = money;
  formData3.profit = bookmakerProfit;
  formData3.betPrice = selectedPrice;
  formData3.selectionId = selectedId;
  formData3.side = side;

  return (
    <>
      <app-root _nghost-jrx-c101="" ng-version="12.2.16">
        <div _ngcontent-jrx-c101="" className="rightbar">
          <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
            <div _ngcontent-jrx-c95="" className="head-container">
              <Header
                isSidebar={isSidebar}
                setSidebar={setSidebar}
                show={showCanvas}
                handleShow={handleCanvasShow}
                handleClose={handleCanvasClose}
              />
              <div _ngcontent-jrx-c95="" className="body-container mb-5">
                <div className="d-none d-md-flex d-xl-flex">
                  <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
                </div>

                <div
                  _ngcontent-jrx-c95=""
                  className="rightbar d-flex flex-column"
                  style={{
                    paddingLeft: isLargeScreen ? "0px" : "0px",
                    paddingRight: isLargeScreen ? "3px" : "0px",
                    width: isSidebar ? "" : "2500%",
                    transition: "width 0.3s ease-in-out",
                  }}
                >
                  {/* <div className="news-bar">
                    <marquee style={{ width: "100%" }}>
                      <p className="m-0 w-100">
                        👉IPL MONTH DHAMAKA OFFER..GET 3% REFILL BONUS ON EVERY
                        DEPOSIT... USDT DEPOSIT OPTION IS ALSO AVAILABLE ON OUR
                        SITE👈👈...TO CONFIRM DEPOSIT BRANCH NUMBER CONTACT
                        HELPDESK NO +265899881378
                      </p>
                    </marquee>
                  </div> */}

                  <div className=" d-flex flex-column flex-lg-row justify-content-between mainn w-100 ">
                    <div
                      className="match-content"
                      style={{
                        backgroundColor: themeColors["--dark-theme-data-bg"],
                      }}
                    >
                      <div className="d-flex gap-5 align-items-center">
                        {/* <span>Time Remaining: </span> */}
                      </div>

                      <div className="scoreboard-header d-dlex">
                        <div>
                          {competiton} {event}
                        </div>
                        <div className="ms-auto">{startTime}</div>
                      </div>

                      {new Date() >= new Date(startTime) && (
                        <CricketScoreboard />
                      )}

                      <div
                        className="match-section mb-1 mt-xl-2 mt-0"
                        style={{
                          color: themeColors["--dark-theme-color-navbar"],
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: themeColors["--bg-secondary85"],
                            marginTop: "0px",
                            padding: "5px 10px",
                          }}
                          className="d-flex mb-0 flex-lg-row flex-row me-1 flex-md-row align-items-baseline"
                        >
                          <p
                            style={{
                              color: themeColors["--dark-theme-color-navbar"],
                            }}
                            className=" me-3 d-flex fw-bold mb-0 rad bett"
                          >
                            Match odds
                          </p>
                        </div>
                        <div
                          className="match-header align-items-end h-auto"
                          style={{ borderBottom: "1px solid #d3cece" }}
                        >
                          <div
                            className="d-flex"
                            style={{
                              height: "2.1rem",
                              marginRight: isLargeScreen ? "8rem" : "0rem",
                            }}
                          >
                            <p
                              className="d-flex gap-1 fs-7 ps-2 me-5 my-auto mb-0 fszz fw-bold"
                              style={{ color: themeColors["--text-info"] }}
                            >
                              <span
                                className="fw-bold"
                                style={{ color: themeColors["--text-info"] }}
                              >
                                Min:{minOdds} <span>|</span>{" "}
                              </span>{" "}
                              Max:{maxOdds}
                            </p>
                            <p className="fs-6 mb-0 px-0 ms-auto bgInfo text-center">
                              Back
                            </p>
                            <p
                              className="fs-6 px-3 mb-0 bg-pink1"
                              style={{ border: "1px solid #c1bdbd" }}
                            >
                              Lay
                            </p>
                          </div>
                        </div>

                        <div className="betting-options d-flex flex-column">
                          {/* <div className="row">
                            <div className="col-lg-7 col-md-5 col-4 mb-0">
                            <p className="d-flex gap-1 fs-7 ps-2 me-5 my-auto mb-0 fszz fw-bold" style={{ color: themeColors['--text-info'] }}>
                              <span className="fw-bold" style={{ color: themeColors['--text-info'] }}>
                                Min:{minOdds} <span>|</span>{" "}
                              </span>{" "}
                              Max:{maxOdds}
                            </p>
                            </div>
                            <div className="col-lg-5 col-md-7 col-8 mb-0 d-flex justify-content-center">
                              <p className="fs-6 mb-0 px-0 bgInfo text-center">Back</p>
                            <p className="fs-6 px-3 mb-0 bg-pink1" style={{ border: "1px solid #c1bdbd" }}>Lay</p>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-7 col-md-5 col-4 mb-0">
                              <h5
                              className="fs-xl-4 fs-2 ps-2 my-0 text-wrap run"
                              style={{ color: themeColors['--text-table'] }}
                              id={selectionid1}
                            >
                              {runner1}
                            </h5>
                            </div>
                            <div className="col-lg-5 col-md-7 col-8 mb-0 justify-content-end">
                              <div className="d-flex">
                              <span
                                className={`${pr === 1
                                  ? "d-block text-green"
                                  : pr === 2
                                    ? "d-block text-red"
                                    : pr === 3 ? "d-block text-red" : pr === 4
                                      ? "d-block text-green"
                                      : "d-none"
                                  }`}
                              >
                                {"=>"}
                                {pr === 3 ? -money : pr === 4 ? money : pr === 1 ? profit : -profit}
                              </span>

                              {back1
                                .slice()
                                .reverse()
                                .map((bc, index) => (
                                  <div
                                    className={`fs-6 py-2 h-100 text-center cursor-pointer ${index < back1.length - 1
                                      ? "bgSecondary dnone"
                                      : "bgInfo"
                                      }`}
                                    variant="primary"
                                    onClick={() => {
                                      showModal();
                                      handleShow();
                                      setbackActive(1);
                                      setlayActive(3);
                                      setSelectedPrice(bc.price);
                                      setPr(1);
                                      setSelectedId(selectionid1);
                                      setRunner(runner1);
                                      setSide("Back");
                                      setSelectedBet(0);
                                    }}
                                    style={{ width: isLargeScreen ? "4rem" : "3.2rem", borderLeft: "1px solid #c7c8ca", borderLeft: "1px solid #c7c8ca", }}
                                  >
                                    {bc.price}
                                  </div>
                                ))}

                              {lay1.map((bc, index) => (
                                <div
                                  className={`fs-6 py-2 h-100 text-center cursor-pointer ${index === 0
                                    ? "bg-pink1"
                                    : "bgSecondary dnone"
                                    }`}
                                  onClick={() => {
                                    showModal();
                                    handleShow();
                                    setbackActive(0);
                                    setlayActive(4);
                                    setSelectedPrice(bc.price);
                                    setPr(2);
                                    setSelectedId(selectionid1);
                                    setRunner(runner1);
                                    setSide("Lay");
                                    setSelectedBet(0);
                                  }}
                                  style={{ width: isLargeScreen ? "4rem" : "3.2rem", borderLeft: "1px solid #c7c8ca", borderLeft: "1px solid #c7c8ca" }}
                                >
                                  {bc.price}
                                </div>
                              ))}
                            </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-7 col-md-5 col-4 mb-0">
                              <h5
                              className="fs-4 ps-2 text-wrap run"
                              style={{ color: themeColors['--text-table'] }}
                              id={selectionid2}
                            >
                              {runner2}
                            </h5>
                            </div>
                            <div className="col-lg-5 col-md-7 col-8 mb-0 justify-content-end">
                              <div className="d-flex">
                              <span
                                className={`${pr === 3
                                  ? "d-block text-green"
                                  : pr === 4
                                    ? "d-block text-red"
                                    : pr === 1 ? "d-block text-red" : pr === 2
                                      ? "d-block text-green"
                                      : "d-none"
                                  }`}
                              >
                                {"=>"}
                                {pr === 1 ? -money : pr === 2 ? money : pr === 3 ? profit : -profit}
                              </span>

                              {back2
                                .slice()
                                .reverse()
                                .map((bc, index) => (
                                  <div
                                    className={`fs-6 py-2 h-100 text-center cursor-pointer ${index < back2.length - 1
                                      ? "bgSecondary dnone"
                                      : "bgInfo"
                                      }`}
                                    onClick={() => {
                                      showModal();
                                      handleShow();
                                      setbackActive(2);
                                      setlayActive(3);
                                      setSelectedPrice(bc.price);
                                      setPr(3);
                                      setSelectedId(selectionid2);
                                      setSide("Back");
                                      setRunner(runner2);
                                      setSelectedBet(0);
                                    }}
                                    style={{ width: isLargeScreen ? "4rem" : "3.2rem", borderLeft: "1px solid #c7c8ca", borderLeft: "1px solid #c7c8ca" }}
                                  >
                                    {bc.price}
                                  </div>
                                ))}

                              {lay2.map((bc, index) => (
                                <div
                                  className={`fs-6 py-2 h-100 text-center cursor-pointer ${index === 0
                                    ? "bg-pink1"
                                    : "bgSecondary dnone"
                                    }`}
                                  onClick={() => {
                                    showModal();
                                    handleShow();
                                    setlayActive(5);
                                    setbackActive(0);
                                    setSelectedPrice(bc.price);
                                    setPr(4);
                                    setSelectedId(selectionid2);
                                    setSide("Lay");
                                    setRunner(runner2);
                                    setSelectedBet(0);
                                  }}
                                  style={{ width: isLargeScreen ? "4rem" : "3.2rem", borderLeft: "1px solid #c7c8ca", borderLeft: "1px solid #c7c8ca" }}
                                >
                                  {bc.price}
                                </div>
                              ))}
                            </div>
                            </div>
                          </div> */}
                          <div
                            style={{ borderBottom: "1px solid #d3cece" }}
                            className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-center border-1 p-0"
                          >
                            <h5
                              className="fs-xl-4 fs-2 ps-2 my-0 text-wrap run"
                              style={{ color: themeColors["--text-table"] }}
                              id={selectionid1}
                            >
                              {runner1}

                              <span
                                className={`${
                                  (matchLiabilities?.odds?.pnl?.[runner1] !==
                                  undefined
                                    ? matchLiabilities.odds.pnl[runner1]
                                    : parseFloat(oddMatchLiablity)) < 0
                                    ? "text-red"
                                    : "text-green"
                                }`}
                              >
                                {parseFloat(
                                  matchLiabilities?.odds?.pnl?.[runner1] || 0
                                ) + parseFloat(oddMatchLiablity || 0)}
                              </span>
                            </h5>

                            <div className="d-flex">
                              <span
                                className={`${
                                  pr === 1
                                    ? "d-block text-green"
                                    : pr === 2
                                    ? "d-block text-red"
                                    : pr === 3
                                    ? "d-block text-red"
                                    : pr === 4
                                    ? "d-block text-green"
                                    : "d-none"
                                }`}
                              >
                                {"=>"}
                                {pr === 3
                                  ? -money
                                  : pr === 4
                                  ? money
                                  : pr === 1
                                  ? profit
                                  : -profit}
                              </span>

                              {back1
                                .slice()
                                .reverse()
                                .map((bc, index) => (
                                  <div
                                    className={`fs-6 py-2 h-100 text-center cursor-pointer ${
                                      index < back1.length - 1
                                        ? "bgSecondary dnone"
                                        : "bgInfo"
                                    }`}
                                    variant="primary"
                                    onClick={() => {
                                      showModal();
                                      handleShow();
                                      setbackActive(1);
                                      setlayActive(3);
                                      setSelectedPrice(bc.price);
                                      setPr(1);
                                      setSelectedId(selectionid1);
                                      setRunner(runner1);
                                      setSide("Back");
                                      setSelectedBet(0);
                                    }}
                                    style={{
                                      width: isLargeScreen ? "4rem" : "3.2rem",
                                      borderLeft: "1px solid #c7c8ca",
                                      borderLeft: "1px solid #c7c8ca",
                                    }}
                                  >
                                    {bc.price}
                                  </div>
                                ))}

                              {lay1.map((bc, index) => (
                                <div
                                  className={`fs-6 py-2 h-100 text-center cursor-pointer ${
                                    index === 0
                                      ? "bg-pink1"
                                      : "bgSecondary dnone"
                                  }`}
                                  onClick={() => {
                                    showModal();
                                    handleShow();
                                    setbackActive(0);
                                    setlayActive(4);
                                    setSelectedPrice(bc.price);
                                    setPr(2);
                                    setSelectedId(selectionid1);
                                    setRunner(runner1);
                                    setSide("Lay");
                                    setSelectedBet(0);
                                  }}
                                  style={{
                                    width: isLargeScreen ? "4rem" : "3.2rem",
                                    borderLeft: "1px solid #c7c8ca",
                                    borderLeft: "1px solid #c7c8ca",
                                  }}
                                >
                                  {bc.price}
                                </div>
                              ))}
                            </div>
                          </div>

                          <div
                            style={{ borderBottom: "1px solid #d3cece" }}
                            className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center p-0"
                          >
                            <h5
                              className="fs-4 ps-2 text-wrap run"
                              style={{ color: themeColors["--text-table"] }}
                              id={selectionid2}
                            >
                              {runner2}
                              <span
                                className={`${
                                  (matchLiabilities?.odds?.pnl?.[runner2] !==
                                  undefined
                                    ? matchLiabilities.odds.pnl[runner2]
                                    : parseFloat(oddMatchLiablity)) < 0
                                    ? "text-red"
                                    : "text-green"
                                }`}
                              >
                                {parseFloat(
                                  matchLiabilities?.odds?.pnl?.[runner2] || 0
                                ) + parseFloat(oddMatchLiablity || 0)}
                              </span>
                            </h5>

                            <div className="d-flex">
                              <span
                                className={`${
                                  pr === 3
                                    ? "d-block text-green"
                                    : pr === 4
                                    ? "d-block text-red"
                                    : pr === 1
                                    ? "d-block text-red"
                                    : pr === 2
                                    ? "d-block text-green"
                                    : "d-none"
                                }`}
                              >
                                {"=>"}
                                {pr === 1
                                  ? -money
                                  : pr === 2
                                  ? money
                                  : pr === 3
                                  ? profit
                                  : -profit}
                              </span>

                              {back2
                                .slice()
                                .reverse()
                                .map((bc, index) => (
                                  <div
                                    className={`fs-6 py-2 h-100 text-center cursor-pointer ${
                                      index < back2.length - 1
                                        ? "bgSecondary dnone"
                                        : "bgInfo"
                                    }`}
                                    onClick={() => {
                                      showModal();
                                      handleShow();
                                      setbackActive(2);
                                      setlayActive(3);
                                      setSelectedPrice(bc.price);
                                      setPr(3);
                                      setSelectedId(selectionid2);
                                      setSide("Back");
                                      setRunner(runner2);
                                      setSelectedBet(0);
                                    }}
                                    style={{
                                      width: isLargeScreen ? "4rem" : "3.2rem",
                                      borderLeft: "1px solid #c7c8ca",
                                      borderLeft: "1px solid #c7c8ca",
                                    }}
                                  >
                                    {bc.price}
                                  </div>
                                ))}

                              {lay2.map((bc, index) => (
                                <div
                                  className={`fs-6 py-2 h-100 text-center cursor-pointer ${
                                    index === 0
                                      ? "bg-pink1"
                                      : "bgSecondary dnone"
                                  }`}
                                  onClick={() => {
                                    showModal();
                                    handleShow();
                                    setlayActive(5);
                                    setbackActive(0);
                                    setSelectedPrice(bc.price);
                                    setPr(4);
                                    setSelectedId(selectionid2);
                                    setSide("Lay");
                                    setRunner(runner2);
                                    setSelectedBet(0);
                                  }}
                                  style={{
                                    width: isLargeScreen ? "4rem" : "3.2rem",
                                    borderLeft: "1px solid #c7c8ca",
                                    borderLeft: "1px solid #c7c8ca",
                                  }}
                                >
                                  {bc.price}
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>

                        {/* bookmaker */}
                        {book2?.status === "ACTIVE" || (
                          <div>
                            <div className="align-items-start gap-2 mt-2">
                              <div
                                style={{
                                  backgroundColor:
                                    themeColors["--bg-secondary85"],
                                  padding: "5px 10px",
                                }}
                                className="d-flex flex-lg-row flex-row flex-md-row align-items-baseline"
                              >
                                <p
                                  style={{
                                    color:
                                      themeColors["--dark-theme-color-navbar"],
                                  }}
                                  className="py-1 me-3 rad bett mb-0"
                                >
                                  BookMaker
                                </p>

                                {/* <p
                              className="btn mt-0 btn-success rounded-0 disabled ms-auto"
                            >
                              Cashout
                            </p> */}
                              </div>

                              <div
                                className="d-flex"
                                style={{
                                  height: "2.1rem",
                                  marginRight: isLargeScreen ? "8rem" : "0rem",
                                }}
                              >
                                <p
                                  className="d-flex gap-1 fs-7 ps-2 me-5 m-0 fszz fw-bold"
                                  style={{ color: themeColors["--text-info"] }}
                                >
                                  <span
                                    className="fw-bold"
                                    style={{
                                      color: themeColors["--text-info"],
                                    }}
                                  >
                                    Min:{minBookmaker} <span>|</span>{" "}
                                  </span>{" "}
                                  Max:{maxBookmaker}
                                </p>
                                <p className="fs-6 mb-0 px-0  ms-auto bgInfo text-center">
                                  Back
                                </p>
                                <p
                                  className="fs-6 px-3 mb-0 bg-pink1"
                                  style={{ border: "1px solid #c1bdbd" }}
                                >
                                  Lay
                                </p>
                              </div>

                              {/* Toggle Button */}
                            </div>

                            {/* Wrap the betting options in a conditional render based on isExpanded state */}
                            {isExpanded === 1 && (
                              <div className="betting-options d-flex flex-column">
                                <div
                                  style={{ borderBottom: "1px solid #d3cece" }}
                                  className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center p-0"
                                >
                                  <h5
                                    className="fs-3 ps-2 text-wrap run"
                                    style={{
                                      color: themeColors["--text-table"],
                                    }}
                                  >
                                    {runner1}
                                  </h5>

                                  {book2?.status === "ACTIVE" ? (
                                    <div className="d-flex">
                                      <span
                                        className={`${
                                          pr === 5
                                            ? "d-block text-green"
                                            : pr === 6
                                            ? "d-block text-red"
                                            : pr === 7
                                            ? "d-block text-red"
                                            : pr === 8
                                            ? "d-block text-green"
                                            : "d-none"
                                        }`}
                                      >
                                        {"=>"}
                                        {pr === 7
                                          ? -money
                                          : pr === 8
                                          ? money
                                          : pr === 5
                                          ? bookmakerProfit
                                          : -bookmakerProfit}
                                      </span>
                                      <div
                                        className="bg-secondary p-2 dnone"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      ></div>
                                      <div
                                        className="bg-secondary p-2 dnone"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      ></div>

                                      <div
                                        className="bg-Info p-2 text-center fs-6 cursor-pointer"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                        onClick={() => {
                                          showModal();
                                          handleShow();
                                          setSelectedBet(3);
                                          setSelectedPrice(oddb1[2]?.odds);
                                          setStatus(2);
                                          setPr(5);
                                          setRunner(runner1);
                                          setSelectedId(selectionid2);
                                          setSide("Back");
                                          setbackActive(0);
                                          setlayActive(3);
                                        }}
                                      >
                                        {oddb1[2]?.odds}
                                      </div>

                                      <div
                                        className="bg-pink1 p-2 text-center fs-6 cursor-pointer"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                        onClick={() => {
                                          showModal();
                                          handleShow();
                                          setSelectedBet(4);
                                          setSelectedPrice(oddb1[3]?.odds);
                                          setStatus(2);
                                          setPr(6);
                                          setRunner(runner1);
                                          setSelectedId(selectionid2);
                                          setSide("Lay");
                                          setbackActive(0);
                                          setlayActive(3);
                                        }}
                                      >
                                        {oddb1[3]?.odds}
                                      </div>

                                      <div
                                        className="bg-secondary p-2 dnone"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      ></div>
                                      <div
                                        className="bg-secondary p-2 dnone"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      ></div>
                                    </div>
                                  ) : (
                                    <div className="bg-info-pink fs-6 py-2 d-flex justify-content-center align-items-center media">
                                      {book2?.status}
                                    </div>
                                  )}
                                </div>

                                <div
                                  style={{ borderBottom: "1px solid #d3cece" }}
                                  className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center p-0"
                                >
                                  <h5
                                    className="fs-3 ps-2 text-wrap run"
                                    style={{
                                      color: themeColors["--text-table"],
                                    }}
                                  >
                                    {runner2}
                                  </h5>

                                  {book1?.status === "ACTIVE" ? (
                                    <div className="d-flex">
                                      <span
                                        className={`${
                                          pr === 7
                                            ? "d-block text-green"
                                            : pr === 8
                                            ? "d-block text-red"
                                            : pr === 5
                                            ? "d-block text-red"
                                            : pr === 6
                                            ? "d-block text-green"
                                            : "d-none"
                                        }`}
                                      >
                                        {"=>"}
                                        {pr === 5
                                          ? -money
                                          : pr === 6
                                          ? money
                                          : pr === 7
                                          ? bookmakerProfit
                                          : -bookmakerProfit}
                                      </span>
                                      <div
                                        className="bg-secondary p-2 dnone"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      ></div>
                                      <div
                                        className="bg-secondary p-2 dnone"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      ></div>

                                      <div
                                        className="bg-Info p-2 text-center fs-6 cursor-pointer"
                                        onClick={() => {
                                          showModal();
                                          handleShow();
                                          setSelectedBet(3);
                                          setSelectedPrice(oddb2[2]?.odds);
                                          setStatus(1);
                                          setPr(7);
                                          setRunner(runner2);
                                          setSelectedId(selectionid1);
                                          setSide("Back");
                                          setbackActive(0);
                                          setlayActive(3);
                                        }}
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      >
                                        {oddb2[2]?.odds}
                                      </div>

                                      <div
                                        className="bg-pink1 p-2 text-center fs-6 cursor-pointer"
                                        onClick={() => {
                                          showModal();
                                          handleShow();
                                          setSelectedBet(4);
                                          setSelectedPrice(oddb2[3]?.odds);
                                          setStatus(1);
                                          setPr(8);
                                          setRunner(runner2);
                                          setSelectedId(selectionid1);
                                          setSide("Lay");
                                          setbackActive(0);
                                          setlayActive(3);
                                        }}
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      >
                                        {oddb2[3]?.odds}
                                      </div>

                                      <div
                                        className="bg-secondary p-2 dnone"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      ></div>
                                      <div
                                        className="bg-secondary p-2 dnone"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      ></div>
                                    </div>
                                  ) : (
                                    <div className="bg-info-pink fs-6 py-2 d-flex justify-content-center align-items-center media">
                                      {book1?.status}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        )}

                        {/* mini bookmaker data */}
                        {(mini1?.status === "ACTIVE" ||
                          mini2?.status === "ACTIVE" ||
                          mini1?.status === "SUSPENDED" ||
                          mini2?.status === "SUSPENDED") && (
                          <>
                            <div className=" align-items-start gap-2 mt-3">
                              <div
                                style={{
                                  backgroundColor:
                                    themeColors["--bg-secondary85"],
                                  padding: "5px 10px",
                                }}
                                className="d-flex flex-lg-row flex-row flex-md-row align-items-baseline"
                              >
                                <p
                                  style={{
                                    color:
                                      themeColors["--dark-theme-color-navbar"],
                                  }}
                                  className="py-1 me-3 rad bett mb-0"
                                >
                                  Mini BookMaker
                                </p>
                              </div>

                              <div
                                className="d-flex"
                                style={{
                                  height: "2.1rem",
                                  marginRight: isLargeScreen ? "8rem" : "0rem",
                                }}
                              >
                                <p
                                  className="d-flex gap-1 fs-7 ps-2 me-5 m-0 fszz fw-bold"
                                  style={{ color: themeColors["--text-info"] }}
                                >
                                  <span
                                    className="fw-bold"
                                    style={{
                                      color: themeColors["--text-info"],
                                    }}
                                  >
                                    Min:{minMiniBook} <span>|</span>{" "}
                                  </span>{" "}
                                  Max:{maxMiniBook}
                                </p>
                                <p className="fs-6 mb-0 px-0  ms-auto bgInfo text-center">
                                  Back
                                </p>
                                <p
                                  className="fs-6 px-3 mb-0 bg-pink1"
                                  style={{ border: "1px solid #c1bdbd" }}
                                >
                                  Lay
                                </p>
                              </div>
                            </div>

                            {isExpanded1 === 1 && (
                              <div className="betting-options d-flex flex-column">
                                <div
                                  style={{ borderBottom: "1px solid #d3cece" }}
                                  className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center p-0"
                                >
                                  <h5
                                    className="fs-3 ps-2 text-wrap run"
                                    style={{
                                      color: themeColors["--text-table"],
                                    }}
                                  >
                                    {runner1}
                                  </h5>

                                  {mini1?.status === "ACTIVE" ? (
                                    <div className="d-flex">
                                      <span
                                        className={`${
                                          pr === 13
                                            ? "d-block text-green"
                                            : pr === 14
                                            ? "d-block text-red"
                                            : pr === 15
                                            ? "d-block text-red"
                                            : pr === 16
                                            ? "d-block text-green"
                                            : "d-none"
                                        }`}
                                      >
                                        {"=>"}
                                        {pr === 15
                                          ? -money
                                          : pr === 16
                                          ? money
                                          : pr === 13
                                          ? bookmakerProfit
                                          : -bookmakerProfit}
                                      </span>
                                      <div
                                        className="bg-secondary p-2 dnone"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      ></div>
                                      <div
                                        className="bg-secondary p-2 dnone"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      ></div>

                                      <div
                                        className="bg-Info p-2 text-center fs-6 cursor-pointer"
                                        onClick={() => {
                                          showModal();
                                          handleShow();
                                          setSelectedBet(7);
                                          setSelectedPrice(mini1.back_price);
                                          setStatus(1);
                                          setPr(13);
                                          setRunner(runner1);
                                          setSelectedId(selectionid1);
                                          setSide("Back");
                                          setbackActive(0);
                                          setlayActive(3);
                                        }}
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      >
                                        {oddm1[2]?.odds}
                                      </div>

                                      <div
                                        className="bg-pink1 p-2 text-center fs-6 cursor-pointer"
                                        onClick={() => {
                                          showModal();
                                          handleShow();
                                          setSelectedBet(8);
                                          setSelectedPrice(mini1.lay_price);
                                          setStatus(1);
                                          setPr(14);
                                          setRunner(runner1);
                                          setSelectedId(selectionid1);
                                          setSide("Lay");
                                          setbackActive(0);
                                          setlayActive(3);
                                        }}
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      >
                                        {oddm1[3]?.odds}
                                      </div>

                                      <div
                                        className="bg-secondary p-2 dnone"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      ></div>
                                      <div
                                        className="bg-secondary p-2 dnone"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      ></div>
                                    </div>
                                  ) : (
                                    <div className="bg-info-pink fs-6 py-2 d-flex justify-content-center align-items-center media">
                                      {mini1?.status}
                                    </div>
                                  )}
                                </div>

                                <div
                                  style={{ borderBottom: "1px solid #d3cece" }}
                                  className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center p-0"
                                >
                                  <h5
                                    className="fs-3 ps-2 text-wrap run"
                                    style={{
                                      color: themeColors["--text-table"],
                                    }}
                                  >
                                    {runner2}
                                  </h5>

                                  {mini2?.status === "ACTIVE" ? (
                                    <div className="d-flex">
                                      <span
                                        className={`${
                                          pr === 15
                                            ? "d-block text-green"
                                            : pr === 16
                                            ? "d-block text-red"
                                            : pr === 13
                                            ? "d-block text-red"
                                            : pr === 14
                                            ? "d-block text-green"
                                            : "d-none"
                                        }`}
                                      >
                                        {"=>"}
                                        {pr === 13
                                          ? -money
                                          : pr === 14
                                          ? money
                                          : pr === 15
                                          ? bookmakerProfit
                                          : -bookmakerProfit}
                                      </span>
                                      <div
                                        className="bg-secondary p-2 dnone"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      ></div>
                                      <div
                                        className="bg-secondary p-2 dnone"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      ></div>

                                      <div
                                        className="bg-Info p-2 text-center fs-6 cursor-pointer"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                        onClick={() => {
                                          showModal();
                                          handleShow();
                                          setSelectedBet(7);
                                          setSelectedPrice(mini2.back_price);
                                          setStatus(2);
                                          setPr(15);
                                          setRunner(runner2);
                                          setSelectedId(selectionid2);
                                          setSide("Back");
                                          setbackActive(0);
                                          setlayActive(3);
                                        }}
                                      >
                                        {oddm2[2]?.odds}
                                      </div>

                                      <div
                                        className="bg-pink1 p-2 text-center fs-6 cursor-pointer"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                        onClick={() => {
                                          showModal();
                                          handleShow();
                                          setSelectedBet(8);
                                          setSelectedPrice(mini2.lay_price);
                                          setStatus(2);
                                          setPr(16);
                                          setRunner(runner2);
                                          setSelectedId(selectionid2);
                                          setSide("Lay");
                                          setbackActive(0);
                                          setlayActive(3);
                                        }}
                                      >
                                        {oddm2[3]?.odds}
                                      </div>

                                      <div
                                        className="bg-secondary p-2 dnone"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      ></div>
                                      <div
                                        className="bg-secondary p-2 dnone"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      ></div>
                                    </div>
                                  ) : (
                                    <div className="bg-info-pink fs-6 py-2 d-flex justify-content-center align-items-center media">
                                      {mini2?.status}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </>
                        )}

                        {/* toss */}
                        {(toss1?.status === "ACTIVE" ||
                          toss2?.status === "ACTIVE" ||
                          toss1?.status === "SUSPENDED" ||
                          toss2?.status === "SUSPENDED") && (
                          <>
                            <div className="align-items-start gap-2 mt-2">
                              <div
                                style={{
                                  backgroundColor:
                                    themeColors["--bg-secondary85"],
                                  padding: "5px 10px",
                                }}
                                className="d-flex flex-lg-row flex-row flex-md-row align-items-baseline"
                              >
                                <p
                                  style={{
                                    color:
                                      themeColors["--dark-theme-color-navbar"],
                                  }}
                                  className="py-1 me-3 rad bett mb-0"
                                >
                                  Toss
                                </p>
                                {/* <p
                                    className="btn mt-0 btn-success rounded-0 disabled ms-auto"
                                  >
                                    Cashout
                                  </p> */}
                              </div>

                              <div
                                className="d-flex"
                                style={{
                                  height: "2.1rem",
                                  marginRight: isLargeScreen ? "8rem" : "0rem",
                                }}
                              >
                                <p
                                  className="d-flex gap-1 fs-7 ps-2 me-5 m-0 fszz fw-bold"
                                  style={{ color: themeColors["--text-info"] }}
                                >
                                  <span
                                    className="fw-bold"
                                    style={{
                                      color: themeColors["--text-info"],
                                    }}
                                  >
                                    Min:{minBookmaker} <span>|</span>{" "}
                                  </span>{" "}
                                  Max:{maxBookmaker}
                                </p>
                                <p className="fs-6 mb-0 px-0  ms-auto bgInfo text-center">
                                  Back
                                </p>
                                <p
                                  className="fs-6 px-3 mb-0 bg-pink1"
                                  style={{ border: "1px solid #c1bdbd" }}
                                >
                                  Lay
                                </p>
                              </div>
                            </div>
                            {isExpanded2 === 1 && (
                              <div className="betting-options d-flex flex-column">
                                <div
                                  style={{ borderBottom: "1px solid #d3cece" }}
                                  className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center bg-light py-0"
                                >
                                  <h5
                                    className="fs-3 ps-2 text-wrap run"
                                    style={{
                                      color: themeColors["--text-table"],
                                    }}
                                  >
                                    {runner1}
                                  </h5>

                                  {toss1?.status === "ACTIVE" ? (
                                    <div className="d-flex">
                                      <span
                                        className={`${
                                          pr === 9
                                            ? "d-block text-green"
                                            : pr === 10
                                            ? "d-block text-green"
                                            : pr === 11 || pr === 12
                                            ? "d-block text-red"
                                            : "d-none"
                                        }`}
                                      >
                                        {"=>"}
                                        {pr === 11 || pr === 12
                                          ? -money
                                          : bookmakerProfit}
                                      </span>
                                      <div
                                        className="bg-secondary p-2 dnone"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      ></div>
                                      <div
                                        className="bg-secondary p-2 dnone"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      ></div>

                                      <div
                                        className="bg-Info p-2 text-center fs-6 cursor-pointer"
                                        onClick={() => {
                                          showModal();
                                          handleShow();
                                          setSelectedBet(5);
                                          setSelectedPrice(toss1.back_price);
                                          setStatus(1);
                                          setPr(9);
                                          setRunner(runner1);
                                          setSelectedId(selectionid1);
                                          setSide("Back");
                                          setbackActive(0);
                                          setlayActive(3);
                                        }}
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      >
                                        {toss1.back_price}
                                      </div>

                                      <div
                                        className="bg-pink1 p-2 text-center fs-6 cursor-pointer"
                                        onClick={() => {
                                          showModal();
                                          handleShow();
                                          setSelectedBet(6);
                                          setSelectedPrice(toss1.lay_price);
                                          setStatus(1);
                                          setPr(10);
                                          setRunner(runner1);
                                          setSelectedId(selectionid1);
                                          setSide("Lay");
                                          setbackActive(0);
                                          setlayActive(3);
                                        }}
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      >
                                        {toss1.lay_price}
                                      </div>

                                      <div
                                        className="bg-secondary p-2 dnone"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      ></div>
                                      <div
                                        className="bg-secondary p-2 dnone"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      ></div>
                                    </div>
                                  ) : (
                                    <div className="bg-info-pink fs-6 py-2 d-flex justify-content-center align-items-center media">
                                      {toss1?.status}
                                    </div>
                                  )}
                                </div>

                                <div
                                  style={{ borderBottom: "1px solid #d3cece" }}
                                  className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center p-0"
                                >
                                  <h5
                                    className="fs-3 ps-2 text-wrap run"
                                    style={{
                                      color: themeColors["--text-table"],
                                    }}
                                  >
                                    {runner2}
                                  </h5>

                                  {toss2?.status === "ACTIVE" ? (
                                    <div className="d-flex">
                                      <span
                                        className={`${
                                          pr === 11
                                            ? "d-block text-green"
                                            : pr === 12
                                            ? "d-block text-green"
                                            : pr === 9 || pr === 10
                                            ? "d-block text-red"
                                            : "d-none"
                                        }`}
                                      >
                                        {"=>"}
                                        {pr === 9 || pr === 10
                                          ? -money
                                          : bookmakerProfit}
                                      </span>
                                      <div
                                        className="bg-secondary p-2 dnone"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      ></div>
                                      <div
                                        className="bg-secondary p-2 dnone"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      ></div>

                                      <div
                                        className="bg-Info p-2 text-center fs-6 cursor-pointer"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                        onClick={() => {
                                          showModal();
                                          handleShow();
                                          setSelectedBet(5);
                                          setSelectedPrice(toss2.back_price);
                                          setStatus(2);
                                          setPr(11);
                                          setRunner(runner2);
                                          setSelectedId(selectionid2);
                                          setSide("Back");
                                          setbackActive(0);
                                          setlayActive(3);
                                        }}
                                      >
                                        {toss2.back_price}
                                      </div>

                                      <div
                                        className="bg-pink1 p-2 text-center fs-6 cursor-pointer"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                        onClick={() => {
                                          showModal();
                                          handleShow();
                                          setSelectedBet(6);
                                          setSelectedPrice(toss2.lay_price);
                                          setStatus(2);
                                          setPr(12);
                                          setRunner(runner2);
                                          setSelectedId(selectionid2);
                                          setSide("Lay");
                                          setbackActive(0);
                                          setlayActive(3);
                                        }}
                                      >
                                        {toss2.lay_price}
                                      </div>

                                      <div
                                        className="bg-secondary p-2 dnone"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      ></div>
                                      <div
                                        className="bg-secondary p-2 dnone"
                                        style={{
                                          width: isLargeScreen
                                            ? "4rem"
                                            : "3.2rem",
                                          borderLeft: "1px solid #c7c8ca",
                                        }}
                                      ></div>
                                    </div>
                                  ) : (
                                    <div className="bg-info-pink fs-6 py-2 d-flex justify-content-center align-items-center media">
                                      {toss2?.status}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </>
                        )}

                        {/* fancy market */}
                        <div className="match-header align-items-start mt-0 w-100 mb-5 h-auto">
                          <div
                            style={{
                              backgroundColor: themeColors["--bg-secondary85"],
                            }}
                            className="d-flex align-items-baseline w-100"
                          >
                            <p
                              style={{
                                color: themeColors["--dark-theme-color-navbar"],
                              }}
                              className="py-1 me-5 px-2 rad bett mb-0"
                            >
                              Fancy Markets
                            </p>

                            <div
                              className="d-flex align-items-end gap-5 ms-0 m-0 ms-md-auto me-4 pr-3"
                              style={{ height: "2.5rem" }}
                            >
                              <p
                                style={{
                                  color:
                                    themeColors["--dark-theme-color-navbar"],
                                }}
                                className="fs-5 mb-1"
                              >
                                No
                              </p>
                              <p
                                style={{
                                  color:
                                    themeColors["--dark-theme-color-navbar"],
                                }}
                                className="fs-5 mb-1"
                              >
                                Yes
                              </p>
                            </div>
                          </div>

                          <div className="bg-light rounded gap-2 d-flex px-3 py-2 d-flex align-items-baseline w-100 pt-2 overflow-auto">
                            <div
                              className={`rounded text-center px-4 py-1 cursor-pointer bet ${
                                newactive === 0 ? "colr" : ""
                              }`}
                              onClick={() => setNewActive(0)}
                              style={{
                                border: "1px solid var(--dark-theme-data-box)",
                              }}
                            >
                              ALL
                            </div>
                            <div
                              className={`rounded text-center px-4 py-1 cursor-pointer bet ${
                                newactive === 1 ? "colr" : ""
                              }`}
                              onClick={() => setNewActive(1)}
                              style={{
                                border: "1px solid var(--dark-theme-data-box)",
                              }}
                            >
                              SESSION
                            </div>
                            <div
                              className={`rounded text-center px-4 py-1 cursor-pointer bet text-nowrap ${
                                newactive === 2 ? "colr" : ""
                              }`}
                              onClick={() => setNewActive(2)}
                              style={{
                                border: "1px solid var(--dark-theme-data-box)",
                              }}
                            >
                              W/P MARKET
                            </div>
                            <div
                              className={`rounded text-center px-4 py-1 cursor-pointer bet ${
                                newactive === 3 ? "colr" : ""
                              }`}
                              onClick={() => setNewActive(3)}
                              style={{
                                border: "1px solid var(--dark-theme-data-box)",
                              }}
                            >
                              ODD/EVEN
                            </div>
                            <div
                              className={`rounded text-center px-4 py-1 cursor-pointer bet ${
                                newactive === 4 ? "colr" : ""
                              }`}
                              onClick={() => setNewActive(4)}
                              style={{
                                border: "1px solid var(--dark-theme-data-box)",
                              }}
                            >
                              XTRA
                            </div>
                          </div>

                         {/* session */}
                               {Array.isArray(session) && session.length > 0 && (newactive === 0 || newactive === 1) ? (
                            <div className="d-flex flex-column align-items-baseline w-100">
                              {/* Header */}
                              <div
                                style={{ backgroundColor: themeColors['--bg-secondary85'], padding: "5px 10px" }}
                                className="d-flex flex-lg-row flex-row w-100 flex-md-row align-items-baseline"
                              >
                                <p
                                  style={{ color: themeColors['--dark-theme-color-navbar'] }}
                                  className="py-1 me-3 rad bett mb-0"
                                >
                                  Session
                                </p>
                              </div>

                              {/* Min/Max Row */}
                              <div
                                className="d-flex w-100"
                                style={{ height: "2.1rem", marginRight: isLargeScreen ? "8rem" : '0rem' }}
                              >
                                <p className="d-flex gap-1 fs-7 ps-2 me-5 m-0 fszz fw-bold" style={{ color: themeColors['--text-info'] }}>
                                  <span className="fw-bold" style={{ color: themeColors['--text-info'] }}>
                                    Min: {minBookmaker} <span>|</span>{" "}
                                  </span>{" "}
                                  Max: {maxBookmaker}
                                </p>
                                <p className="fs-6 mb-0 px-0 me-0 ms-auto bg-pink1 text-center" style={{ width: "70px" }}>No</p>
                                <p className="fs-6 px-3 mb-0 bgInfo me-0" style={{ border: "1px solid #c1bdbd", width: "70px" }}>Yes</p>
                              </div>

                              {/* Section Rows */}
                              {isExpanded3 === 1 && (
                                <div className="w-100">
                                  {session.map((item, index) => {
                                    const nat = item?.rate?.fancyName|| "-";
                                    const odds1 =  item?.rate?.rates[0].rate_1|| "-";
                                    const odds2 =item?.rate?.rates[0].rate_2|| "-";
                                    const size1 = item?.rate?.rates[0].value_1|| "-";
                                    const size2 = item?.rate?.rates[0].value_2|| "-";

                                    console.log(odds1,odds2,size1,size2,"helo")

                                    return (
                                      <div key={index} className="w-100">
                                        <div
                                          style={{ borderBottom: "1px solid #d3cece" }}
                                          className="betting-row d-flex flex-md-row justify-content-between rounded align-items-md-center p-0 w-100"
                                        >
                                          <h5
                                            className="mb-3 mb-md-0 text-wrap run ps-2"
                                            style={{ color: themeColors['--text-table'] }}
                                          >
                                            {nat}
                                          </h5>

                                          <div className="d-flex">
                                            <img
                                              className="small-grid ng-star-inserted mt-4 heig"
                                              src="/assets/images/ladder.svg"
                                              alt="ladder"
                                            />

                                            {item?.status === "ACTIVE" ? (
                                              <>
                                                {/* No Odds */}
                                                <div
                                                  className="bg-pink1 d-flex flex-column px-3 text-center cursor-pointer"
                                                  style={{ width: "70px" }}
                                                  onClick={() => {
                                                    showModal();
                                                    handleShow();
                                                    setSelectedMarket(odds2);
                                                    setFancyBet(index);
                                                    setSelectedBet(2);
                                                    setStake(
                                                      item?.rate?.rates[0].value_2
                                                    );
                                                    setSelectFancy(nat);
                                                    setSide("no");
                                                  
                                                    setFancyValue(
                                                      item?.rate?.rates[0].value_2
                                                    );
                                                    setFancySrno(
                                                      item?.rate?.srno
                                                    );
                                                    setbackActive(0);
                                                    setlayActive(3);
                                                    setSelectedPrice(odds2)
                                                  }}
                                                >
                                                  <span className="fonts">{odds2}</span>
                                                  <span className="fonts">{size2}</span>
                                                </div>

                                                {/* Yes Odds */}
                                                <div
                                                  className="bg-Info d-flex flex-column px-3 text-center cursor-pointer"
                                                  style={{ width: "70px" }}
                                                  onClick={() => {
                                                    showModal();
                                                    handleShow();
                                                    setSelectedMarket(odds1);
                                                    setFancyBet(index);
                                                    setSelectedBet(1);
                                                    setStake(
                                                      item?.rate?.rates[0].value_1
                                                    );
                                                    setSelectedPrice(odds1)
                                                    setSelectFancy(nat);
                                                    setSide("yes");
                                                    setFancyValue(
                                                      item?.rate?.rates[0].value_1
                                                    );
                                                    setFancySrno(
                                                      item?.rate?.srno
                                                    );
                                                    setbackActive(0);
                                                    setlayActive(3);
                                                  }}
                                                >
                                                  <span className="fonts">{odds1}</span>
                                                  <span className="fonts">{size1}</span>
                                                </div>
                                              </>
                                            ) : (
                                              <div className="bg-info-pink rounded p-2 d-flex flex-column px-3 fonts d-flex align-items-center fw-bold">
                                                {item?.status || "CLOSED"}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                          ) : (
                            <p className="text-white"></p>
                          )}

                          {/* wpmakrket */}

                          {Array.isArray(wpMarket) &&
                            wpMarket.length > 0 &&
                            (newactive === 0 || newactive === 2) ? (
                            <div className="align-items-baseline">
                              {/* Add your heading here */}
                              <div style={{ backgroundColor: themeColors['--bg-secondary85'], padding: "5px 10px" }} className="d-flex flex-lg-row w-100 flex-row flex-md-row align-items-baseline">
                                <p style={{ color: themeColors['--dark-theme-color-navbar'] }} className="py-1 me-3 rad bett mb-0">
                                  WP Market
                                </p>

                                {/* <p
                                  className="btn mt-0 btn-success rounded-0 disabled ms-auto"
                                >
                                  Cashout
                                </p> */}
                              </div>

                              <div
                                className="d-flex w-100"
                                style={{ height: "2.1rem", marginRight: isLargeScreen ? "8rem" : '0rem' }}
                              >

                                <p className="d-flex gap-1 fs-7 ps-2 me-5 m-0 fszz fw-bold" style={{ color: themeColors['--text-info'] }}>
                                  <span className="fw-bold" style={{ color: themeColors['--text-info'] }}>
                                    Min:{minBookmaker} <span>|</span>{" "}
                                  </span>{" "}
                                  Max:{maxBookmaker}
                                </p>
                                <p className="fs-6 mb-0 px-0 me-0  ms-auto bg-pink1  text-center" style={{ width: "70px" }}>No</p>
                                <p className="fs-6 px-3 mb-0 bgInfo me-0" style={{ border: "1px solid #c1bdbd", width: "70px" }}>Yes</p>
                              </div>
                              {isExpanded4 === 1 && (
                                <div className="w-100">
                                  {/* Map through wpMarket */}
                                  {wpMarket.map((item, index) => {
                                    const nat = item?.rate?.fancyName|| "-";
                                    const odds1 =  item?.rate?.rates[0].rate_1|| "-";
                                    const odds2 =item?.rate?.rates[0].rate_2|| "-";
                                    const size1 = item?.rate?.rates[0].value_1|| "-";
                                    const size2 = item?.rate?.rates[0].value_2|| "-";

                                    return (
                                      <div key={index} className="w-100 mb-0">
                                        <div style={{ borderBottom: "1px solid #d3cece" }} className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center p-0 w-100 mb-0">
                                          <h5 className="mb-3 mb-md-0 text-wrap run ps-2" style={{ color: themeColors['--text-table'] }}>
                                            {nat}
                                          </h5>

                                          <div className="d-flex">
                                            <img
                                              className="small-grid ng-star-inserted mt-4 heig"
                                              src="/assets/images/ladder.svg"
                                              alt="TVKheloyaar360"
                                            />

                                            {item?.status === "ACTIVE" ? (
                                              <>
                                                <div
                                                  className="bg-pink1 d-flex flex-column px-3 text-center cursor-pointer"
                                                  style={{ width: "70px" }}
                                                  onClick={() => {
                                                    showModal();
                                                    handleShow();
                                                    setSelectedMarket(odds2);
                                                    setFancyMarket(index);
                                                    setSelectedBet(10);
                                                    setStake(
                                                      item?.rate?.rates[0].value_2
                                                    );
                                                    setSelectFancy(nat);
                                                    setSide("no");
                                                    setFancyValue(
                                                      item?.rate?.rates[0].value_2
                                                    );
                                                    setFancySrno(
                                                      item?.rate?.srno
                                                    );
                                                    setbackActive(0);
                                                    setlayActive(3);
                                                    setSelectedPrice(odds2)
                                                  }}
                                                >
                                                  <span className="fonts">
                                                    {odds2}
                                                  </span>
                                                  <span>
                                                    {size2}
                                                  </span>
                                                </div>

                                                <div
                                                  className="bg-Info d-flex flex-column px-3 text-center cursor-pointer"
                                                  style={{ width: "70px" }}
                                                  onClick={() => {
                                                    showModal();
                                                    handleShow();
                                                    setSelectedMarket(odds1);
                                                    setFancyMarket(index);
                                                    setSelectedBet(9);
                                                    setStake(
                                                      item?.rate?.rates[0].value_1
                                                    );
                                                    setSelectFancy(nat);
                                                    setSide("yes");
                                                    setFancyValue(
                                                      item?.rate?.rates[0].value_1
                                                    );
                                                    setFancySrno(
                                                      item?.rate?.srno
                                                    );
                                                    setbackActive(0);
                                                    setlayActive(3);
                                                    setSelectedPrice(odds1)
                                                  }}
                                                >
                                                  <span className="fonts">
                                                    {odds1}
                                                  </span>
                                                  <span>
                                                    {size1}
                                                  </span>
                                                </div>

                                              </>
                                            ) : (
                                              <div className="bg-info-pink rounded p-2 d-flex flex-column px-3 fonts d-flex align-items-center fw-bold">
                                                {item?.status}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  })}
                                </div>
                              )}
                            </div>
                          ) : (
                            <p className="text-white"></p>
                          )}

                          {/* odd even */}
                          {Array.isArray(oddEven) &&
                            oddEven.length > 0 &&
                            (newactive === 0 || newactive === 3) ? (
                            <div className="align-items-baseline w-100 mt-0">
                              {/* Add your heading here */}
                              <div style={{ backgroundColor: themeColors['--bg-secondary85'], padding: "5px 10px" }} className="d-flex flex-lg-row w-100 flex-row flex-md-row align-items-baseline">
                                <p style={{ color: themeColors['--dark-theme-color-navbar'] }} className="py-1 me-3 rad bett mb-0">
                                  ODD/EVEN
                                </p>

                                {/* <p
                                  className="btn mt-0 btn-success rounded-0 disabled ms-auto"
                                >
                                  Cashout
                                </p> */}
                              </div>

                              <div
                                className="d-flex w-100"
                                style={{ height: "2.1rem", marginRight: isLargeScreen ? "8rem" : '0rem' }}
                              >

                                <p className="d-flex gap-1 fs-7 ps-2 me-5 m-0 fszz fw-bold" style={{ color: themeColors['--text-info'] }}>
                                  <span className="fw-bold" style={{ color: themeColors['--text-info'] }}>
                                    Min:{minBookmaker} <span>|</span>{" "}
                                  </span>{" "}
                                  Max:{maxBookmaker}
                                </p>
                                <p className="fs-6 mb-0 px-0 me-0  ms-auto bg-pink1 text-center" style={{ width: "70px" }}>No</p>
                                <p className="fs-6 px-3 mb-0 bgInfo me-0" style={{ border: "1px solid #c1bdbd", width: "70px" }}>Yes</p>
                              </div>
                              {isExpanded6 === 1 && (
                                <div className="w-100">
                                  {/* Map through wpMarket */}
                                  {oddEven.map((item, index) => {
                                    const nat = item?.rate?.fancyName|| "-";
                                    const odds1 =  item?.rate?.rates[0].rate_1|| "-";
                                    const odds2 =item?.rate?.rates[0].rate_2|| "-";
                                    const size1 = item?.rate?.rates[0].value_1|| "-";
                                    const size2 = item?.rate?.rates[0].value_2|| "-";

                                    return (
                                      <div key={index} className="w-100">
                                        <div style={{ borderBottom: "1px solid #d3cece" }} className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center p-0 w-100 mb-0">
                                          <h5 className="mb-3 mb-md-0 text-wrap run ps-2" style={{ color: themeColors['--text-table'] }}>
                                            {nat}
                                          </h5>

                                          <div className="d-flex">
                                            <img
                                              className="small-grid ng-star-inserted mt-4 heig"
                                              src="/assets/images/ladder.svg"
                                              alt="TVKheloyaar360"
                                            />

                                            {item?.status === "ACTIVE" ? (
                                              <>
                                                <div
                                                  className="bg-pink1 d-flex flex-column px-3 text-center cursor-pointer"
                                                  style={{ width: "70px" }}
                                                  onClick={() => {
                                                    showModal();
                                                    handleShow();
                                                    setSelectedMarket(odds2);
                                                    setFancyOdd(index);
                                                    setSelectedBet(12);
                                                    setStake(
                                                      item?.rate?.rates[0].value_2
                                                    );
                                                    setSelectFancy(nat);
                                                    setSide("no");
                                                    setFancyValue(
                                                      item?.rate?.rates[0].value_2
                                                    );

                                                    setFancySrno(
                                                      item?.rate?.srno
                                                    );
                                                    setbackActive(0);
                                                    setlayActive(3);
                                                    setSelectedPrice(odds2)
                                                  }}
                                                >
                                                  <span className="fonts">
                                                    {odds2}
                                                  </span>
                                                  <span>
                                                    {size2}
                                                  </span>
                                                </div>
                                                <div
                                                  className="bg-Info d-flex flex-column px-3 text-center cursor-pointer"
                                                  style={{ width: "70px" }}
                                                  onClick={() => {
                                                    showModal();
                                                    handleShow();
                                                    setSelectedMarket(odds1);
                                                    setFancyOdd(index);
                                                    setSelectedBet(11);
                                                    setStake(
                                                      item?.rate?.rates[0].value_1
                                                    );
                                                    setSelectFancy(nat);
                                                    setSide("yes");
                                                    setFancyValue(
                                                      item?.rate?.rates[0].value_1
                                                    );

                                                    setFancySrno(
                                                      item?.rate?.srno
                                                    );
                                                    setbackActive(0);
                                                    setlayActive(3);
                                                    setSelectedPrice(odds1)
                                                  }}
                                                >
                                                  <span className="fonts">
                                                    {odds1}
                                                  </span>
                                                  <span>
                                                    {size1}
                                                  </span>
                                                </div>

                                              </>
                                            ) : (
                                              <div className="bg-info-pink rounded p-2 d-flex flex-column px-3 fonts d-flex align-items-center fw-bold">
                                                {item?.status}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  })}
                                </div>
                              )}
                            </div>
                          ) : (
                            <p className="text-white"></p>
                          )}

                          {/* xtra */}
                          {Array.isArray(fancy) &&
                            fancy.length > 0 &&
                            (newactive === 0 || newactive === 4) ? (
                            <div className="align-items-baseline w-100">
                              {/* Add your heading here */}
                              <div style={{ backgroundColor: themeColors['--bg-secondary85'], padding: "5px 10px" }} className="d-flex flex-lg-row w-100 flex-row flex-md-row align-items-baseline">
                                <p style={{ color: themeColors['--dark-theme-color-navbar'] }} className="py-1 me-3 rad bett mb-0">
                                  XTRA
                                </p>

                                {/* <p
                                  className="btn mt-0 btn-success rounded-0 disabled ms-auto"
                                >
                                  Cashout
                                </p> */}
                              </div>

                              <div
                                className="d-flex w-100"
                                style={{ height: "2.1rem", marginRight: isLargeScreen ? "8rem" : '0rem' }}
                              >

                                <p className="d-flex gap-1 fs-7 ps-2 me-5 m-0 fszz fw-bold" style={{ color: themeColors['--text-info'] }}>
                                  <span className="fw-bold" style={{ color: themeColors['--text-info'] }}>
                                    Min:{minBookmaker} <span>|</span>{" "}
                                  </span>{" "}
                                  Max:{maxBookmaker}
                                </p>
                                <p className="fs-6 mb-0 px-0 me-0 ms-auto bg-pink1 text-center" style={{ width: "70px" }}>No</p>
                                <p className="fs-6 px-3 mb-0 bgInfo me-0" style={{ border: "1px solid #c1bdbd", width: "70px" }}>Yes</p>
                              </div>

                              {isExpanded5 === 1 && (
                                <div className="w-100">
                                  {/* Map through wp Market */}
                                  {fancy.map((item, index) => {
                                    const nat = item?.rate?.fancyName|| "-";
                                    const odds1 =  item?.rate?.rates[0].rate_1|| "-";
                                    const odds2 =item?.rate?.rates[0].rate_2|| "-";
                                    const size1 = item?.rate?.rates[0].value_1|| "-";
                                    const size2 = item?.rate?.rates[0].value_2|| "-";

                                    return (
                                      <div key={index} className="w-100">
                                        <div style={{ borderBottom: "1px solid #d3cece" }} className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center p-0 w-100 mb-0">
                                          <h5 className="mb-3 mb-md-0 text-wrap run ps-2" style={{ color: themeColors['--text-table'] }}>
                                            {nat}
                                          </h5>

                                          <div className="d-flex">
                                            <img
                                              className="small-grid ng-star-inserted mt-4 heig"
                                              src="/assets/images/ladder.svg"
                                              alt="TVKheloyaar360"
                                            />

                                            {item?.status === "ACTIVE" ? (
                                              <>
                                                <div
                                                  className="bg-pink1 d-flex flex-column px-3 text-center cursor-pointer"
                                                  style={{ width: "70px" }}
                                                  onClick={() => {
                                                    showModal();
                                                    handleShow();
                                                    setSelectedMarket(odds2);
                                                    setFancyXtra(index);
                                                    setSelectedBet(14);
                                                    setStake(
                                                      item?.rate?.rates[0].value_2
                                                    );
                                                    setSelectFancy(nat);
                                                    setSide("no");
                                                    setFancyValue(
                                                      item?.rate?.rates[0].value_2
                                                    );
                                                    setFancySrno(
                                                      item?.rate?.srno
                                                    );
                                                    setbackActive(0);
                                                    setlayActive(3);
                                                    setSelectedPrice(odds2)
                                                  }}
                                                >
                                                  <span className="fonts">
                                                    {odds2}
                                                  </span>
                                                  <span>
                                                    {size2}
                                                  </span>
                                                </div>
                                                <div
                                                  className="bg-Info d-flex flex-column px-3 text-center cursor-pointer"
                                                  style={{ width: "70px" }}
                                                  onClick={() => {
                                                    showModal();
                                                    handleShow();
                                                    setSelectedMarket(odds1);
                                                    setFancyXtra(index);
                                                    setSelectedBet(13);
                                                    setStake(
                                                      item?.rate?.rates[0].value_1
                                                    );
                                                    setSelectFancy(nat);
                                                    setSide("yes");
                                                    setFancyValue(
                                                      item?.rate?.rates[0].value_1
                                                    );

                                                    setFancySrno(
                                                      item?.rate?.srno
                                                    );
                                                    setbackActive(0);
                                                    setlayActive(3);
                                                    setSelectedPrice(oddb1)
                                                  }}
                                                >
                                                  <span className="fonts">
                                                    {odds1}
                                                  </span>
                                                  <span>
                                                    {size1}
                                                  </span>
                                                </div>

                                              </>
                                            ) : (
                                              <div className="bg-info-pink rounded p-2 d-flex flex-column px-3 fonts d-flex align-items-center fw-bold">
                                                {item?.status}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  })}
                                </div>
                              )}
                            </div>
                          ) : (
                            <p className="text-white"></p>
                          )}
                        </div>
                      </div>
                    </div>

                    <div
                      className="bets-container d-flex flex-column betTv gap-2"
                      style={{
                        height: `${betData.length * 6}vh`,
                        top: isLargeScreen ? "0px" : "",
                      }}
                    >
                      <div
                        className=" mt-3 mt-lg-0 ms-0 ms-lg-1 mb-4  h-100"
                        style={{}}
                      >
                        <div className="d-none d-lg-block position-relative pl-0">
                          <div
                            className="py-1 px-2 cursor-pointer d-flex justify-content-between"
                            style={{
                              backgroundColor: themeColors["--bg-secondary"],
                            }}
                            onClick={() => setPlay(!play)}
                          >
                            <div>
                              <span>
                                {" "}
                                <i
                                  className="bi bi-broadcast fs-16"
                                  style={{ color: "#DC3545" }}
                                ></i>
                              </span>
                              <span> Watch Live Match</span>
                            </div>
                            <div>
                              <button className="live-stream-button ng-star-inserted">
                                {" "}
                                Watch Live{" "}
                              </button>
                            </div>
                          </div>
                          {play && channel && (
                            <iframe
                              title="Live TV"
                              className="border w-100 h-75"
                              // src={`https://cache.bpexchanges.com/embed?eventId=${channel}`}
                              src={`https://e765432.diamondcricketid.com/dtv.php?id=${channel}`}
                              allowFullScreen
                              referrerPolicy="strict-origin-when-cross-origin"
                              sandbox="allow-same-origin allow-scripts"
                            ></iframe>
                          )}
                        </div>

                        {isLargeScreen && (
                          <div>
                            {/* Match ODDS */}

                            {/* Back */}
                            {backActive !== 0 && (
                              <>
                                <div
                                  className="m-0 mt-1 px-2 py-1 bett"
                                  style={{
                                    background: themeColors["--bg-secondary"],
                                    color: themeColors["--dark-theme-color"],
                                  }}
                                >
                                  Place Bet
                                </div>
                                <div
                                  style={{
                                    backgroundColor: "#72bbef",
                                    color:
                                      themeColors["--dark-theme-color-navbar"],
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  ></div>

                                  <table style={{ width: "100%" }}>
                                    <thead
                                      style={{
                                        backgroundColor:
                                          themeColors["--bg-sidebar"],
                                      }}
                                    >
                                      <tr>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          {" "}
                                          (Bet for){" "}
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          Odds
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          Stake
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          <div>Profit:</div>
                                        </td>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        style={{
                                          borderBottom:
                                            "1px solid var(--table-border) !important",
                                        }}
                                      >
                                        <td style={{ padding: "5px" }}>
                                          <div
                                            style={{
                                              display: "flex",
                                              paddingLeft: "5px",
                                              color: themeColors["--text-body"],
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {runner}
                                          </div>
                                        </td>
                                        <td style={{ padding: "5px" }}>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "24px",
                                              paddingLeft: "5px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={selectedPrice}
                                              onChange={(e) =>
                                                setSelectedPrice(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "12px",
                                                width: "27px",
                                              }}
                                            />
                                            <div>
                                              <button
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-sidebar"],
                                                  color:
                                                    themeColors["--text-body"],
                                                  width: "20px",
                                                  border: "none",
                                                  fontSize: "10px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                }}
                                                onClick={() =>
                                                  handlelayChange(0)
                                                }
                                              >
                                                <IoIosArrowUp />
                                              </button>
                                              <button
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-sidebar"],
                                                  color:
                                                    themeColors["--text-body"],
                                                  width: "20px",
                                                  border: "none",
                                                  fontSize: "10px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                }}
                                                onClick={() =>
                                                  handlelayChange(1)
                                                }
                                              >
                                                <IoIosArrowDown />
                                              </button>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "24px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={money}
                                              onChange={(e) =>
                                                setMoney(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "32px",
                                              }}
                                            />
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            padding: "5px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              paddingRight: "5px",
                                              color: themeColors["--text-body"],
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {(
                                              money *
                                              (selectedPrice - 1)
                                            ).toFixed(1)}
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>

                                  <div
                                    style={{
                                      display: "grid",
                                      paddingLeft: "5px",
                                      paddingRight: "5px",
                                      gridTemplateColumns: "repeat(5, 1fr)",
                                      gap: "2px",
                                      marginBottom: "2px",
                                    }}
                                  >
                                    {gameButtons.map((btn) => (
                                      <button
                                        key={btn.id}
                                        className="homebet_set"
                                        style={{
                                          color: themeColors["--text-sidebar"],
                                          padding: "5px 0",
                                          border: "none",
                                          fontWeight: "bold",
                                        }}
                                        onClick={() => setMoney(btn.value)}
                                      >
                                        + {btn.label}
                                      </button>
                                    ))}
                                  </div>

                                  <div
                                    style={{
                                      display: "grid",
                                      padding: "2px 5px 4px 5px",
                                      gridTemplateColumns: "repeat(4, 1fr)",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    <button
                                      style={{
                                        backgroundColor: "transparent",
                                        color: "#0d6efd",
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        setMoney(0);
                                        setPr(0);
                                      }}
                                    >
                                      Clear
                                    </button>
                                    <button
                                      style={{
                                        backgroundColor:
                                          themeColors["--bg-info"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        handleShowV();
                                      }}
                                    >
                                      Edit
                                    </button>

                                    <button
                                      style={{
                                        background: themeColors["--bg-danger"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        setbackActive(0);
                                        setSelectedBet(0);
                                        setlayActive(3);
                                        setMoney(0);
                                        setPr(0);
                                      }}
                                    >
                                      Reset
                                    </button>
                                    <button
                                      style={{
                                        background: themeColors["--bg-success"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => handleSubmit()}
                                    >
                                      Submit
                                    </button>
                                  </div>

                                  {/* <div
                                style={{
                                  display: "grid",
                                  padding: "5px",
                                  gridTemplateColumns: "repeat(2, 1fr)",
                                  gap: "8px",
                                }}
                              >
                              </div> */}
                                </div>
                              </>
                            )}
                            {/* lay */}
                            {layActive !== 3 && (
                              <>
                                <div
                                  className="m-0 mt-1 px-2 py-1 bett"
                                  style={{
                                    background: themeColors["--bg-secondary"],
                                    color: themeColors["--dark-theme-color"],
                                  }}
                                >
                                  PlaceM Bet
                                </div>
                                <div
                                  style={{
                                    backgroundColor: "#faa9ba",
                                    color:
                                      themeColors["--dark-theme-color-navbar"],
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    {/* <button
                                style={{
                                  backgroundColor: themeColors['--dark-theme-data-backbtn'],
                                  color: themeColors['--dark-theme-color-navbar'],
                                  padding: "8px 20px",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                BACK
                              </button> */}

                                    {/* <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    marginRight: "8px",
                                  }}
                                  id="matchAtAnyRate"
                                />
                                <label htmlFor="matchAtAnyRate">
                                  Match At Any Rate
                                </label>
                              </div> */}
                                  </div>

                                  <table style={{ width: "100%" }}>
                                    <thead
                                      style={{
                                        backgroundColor:
                                          themeColors["--bg-sidebar"],
                                      }}
                                    >
                                      <tr>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          {" "}
                                          (Bet for){" "}
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          Odds
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          Stake
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          <div>Profit:</div>
                                        </td>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        style={{
                                          borderBottom:
                                            "1px solid var(--table-border) !important",
                                        }}
                                      >
                                        <td style={{ padding: "5px" }}>
                                          <div
                                            style={{
                                              display: "flex",
                                              paddingLeft: "5px",
                                              color: themeColors["--text-body"],
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {runner}
                                          </div>
                                        </td>
                                        <td style={{ padding: "5px" }}>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "24px",
                                              paddingLeft: "5px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={selectedPrice}
                                              onChange={(e) =>
                                                setSelectedPrice(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "12px",
                                                width: "27px",
                                              }}
                                            />
                                            <div>
                                              <button
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-sidebar"],
                                                  color:
                                                    themeColors["--text-body"],
                                                  width: "20px",
                                                  border: "none",
                                                  fontSize: "10px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                }}
                                                onClick={() =>
                                                  handlelayChange(0)
                                                }
                                              >
                                                <IoIosArrowUp />
                                              </button>
                                              <button
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-sidebar"],
                                                  color:
                                                    themeColors["--text-body"],
                                                  width: "20px",
                                                  border: "none",
                                                  fontSize: "10px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                }}
                                                onClick={() =>
                                                  handlelayChange(1)
                                                }
                                              >
                                                <IoIosArrowDown />
                                              </button>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "24px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={money}
                                              onChange={(e) =>
                                                setMoney(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "32px",
                                              }}
                                            />
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            padding: "5px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              paddingRight: "5px",
                                              color: themeColors["--text-body"],
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {(
                                              money *
                                              (selectedPrice - 1)
                                            ).toFixed(1)}
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>

                                  {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(12, 1fr)",
                                gap: "5px",
                                marginBottom: "0px",
                              }}
                            >
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div> */}

                                  <div
                                    style={{
                                      display: "grid",
                                      paddingLeft: "5px",
                                      paddingRight: "5px",
                                      gridTemplateColumns: "repeat(5, 1fr)",
                                      gap: "2px",
                                      marginBottom: "2px",
                                    }}
                                  >
                                    {gameButtons.map((btn) => (
                                      <button
                                        key={btn.id}
                                        className="homebet_set"
                                        style={{
                                          color: themeColors["--text-sidebar"],
                                          padding: "5px 0",
                                          border: "none",
                                          fontWeight: "bold",
                                        }}
                                        onClick={() => setMoney(btn.value)}
                                      >
                                        + {btn.label}
                                      </button>
                                    ))}
                                  </div>

                                  <div
                                    style={{
                                      display: "grid",
                                      padding: "2px 5px 4px 5px",
                                      gridTemplateColumns: "repeat(4, 1fr)",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    {/* <button
                                onClick={() => setMoney(minOdds)}
                                style={{
                                  backgroundColor: themeColors['--dark-theme-data-min'],
                                  color: themeColors['--dark-theme-color-navbar'],
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Min
                              </button>
                              <button
                                onClick={() => setMoney(maxOdds)}

                                style={{
                                  backgroundColor: themeColors['--dark-theme-dark-blue-bm'],
                                  color: themeColors['--dark-theme-color-navbar'],
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Max
                              </button> */}
                                    <button
                                      style={{
                                        backgroundColor: "transparent",
                                        color: "#0d6efd",
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        setMoney(0);
                                        setPr(0);
                                      }}
                                    >
                                      Clear
                                    </button>
                                    <button
                                      style={{
                                        backgroundColor:
                                          themeColors["--bg-info"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        handleShowV();
                                      }}
                                    >
                                      Edit
                                    </button>

                                    <button
                                      style={{
                                        background: themeColors["--bg-danger"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        setbackActive(0);
                                        setSelectedBet(0);
                                        setlayActive(3);
                                        setMoney(0);
                                        setPr(0);
                                      }}
                                    >
                                      Reset
                                    </button>
                                    <button
                                      style={{
                                        background: themeColors["--bg-success"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => handleSubmit()}
                                    >
                                      Submit
                                    </button>
                                  </div>

                                  {/* <div
                                style={{
                                  display: "grid",
                                  padding: "5px",
                                  gridTemplateColumns: "repeat(2, 1fr)",
                                  gap: "8px",
                                }}
                              >
                              </div> */}
                                </div>
                              </>
                            )}
                            {/* /Match ODDS */}

                            {/* BookMaker */}

                            {/* back */}
                            {selectedBet === 3 && isExpanded === 1 && (
                              <>
                                <div
                                  className="m-0 mt-1 px-2 py-1 bett"
                                  style={{
                                    background: themeColors["--bg-secondary"],
                                    color: themeColors["--dark-theme-color"],
                                  }}
                                >
                                  Place Bet
                                </div>
                                <div
                                  style={{
                                    backgroundColor: "#72bbef",
                                    color:
                                      themeColors["--dark-theme-color-navbar"],
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    {/* <button
                                style={{
                                  backgroundColor: themeColors['--dark-theme-data-backbtn'],
                                  color: themeColors['--dark-theme-color-navbar'],
                                  padding: "8px 20px",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                BACK
                              </button> */}

                                    {/* <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    marginRight: "8px",
                                  }}
                                  id="matchAtAnyRate"
                                />
                                <label htmlFor="matchAtAnyRate">
                                  Match At Any Rate
                                </label>
                              </div> */}
                                  </div>

                                  <table style={{ width: "100%" }}>
                                    <thead
                                      style={{
                                        backgroundColor:
                                          themeColors["--bg-sidebar"],
                                      }}
                                    >
                                      <tr>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          {" "}
                                          (Bet for){" "}
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          Odds
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          Stake
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          <div>Profit:</div>
                                        </td>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        style={{
                                          borderBottom:
                                            "1px solid var(--table-border) !important",
                                        }}
                                      >
                                        <td style={{ padding: "5px" }}>
                                          <div
                                            style={{
                                              display: "flex",
                                              paddingLeft: "5px",
                                              color: themeColors["--text-body"],
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {runner}
                                          </div>
                                        </td>
                                        <td style={{ padding: "5px" }}>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "24px",
                                              paddingLeft: "5px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={selectedPrice}
                                              onChange={(e) =>
                                                setSelectedPrice(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "12px",
                                                width: "27px",
                                              }}
                                            />
                                            <div>
                                              <button
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-sidebar"],
                                                  color:
                                                    themeColors["--text-body"],
                                                  width: "20px",
                                                  border: "none",
                                                  fontSize: "10px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                }}
                                                onClick={() =>
                                                  handlelayChange(0)
                                                }
                                              >
                                                <IoIosArrowUp />
                                              </button>
                                              <button
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-sidebar"],
                                                  color:
                                                    themeColors["--text-body"],
                                                  width: "20px",
                                                  border: "none",
                                                  fontSize: "10px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                }}
                                                onClick={() =>
                                                  handlelayChange(1)
                                                }
                                              >
                                                <IoIosArrowDown />
                                              </button>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "24px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={money}
                                              onChange={(e) =>
                                                setMoney(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "32px",
                                              }}
                                            />
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            padding: "5px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              paddingRight: "5px",
                                              color: themeColors["--text-body"],
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {(
                                              money *
                                              (selectedPrice - 1)
                                            ).toFixed(1)}
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>

                                  {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(12, 1fr)",
                                gap: "5px",
                                marginBottom: "0px",
                              }}
                            >
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div> */}

                                  <div
                                    style={{
                                      display: "grid",
                                      paddingLeft: "5px",
                                      paddingRight: "5px",
                                      gridTemplateColumns: "repeat(5, 1fr)",
                                      gap: "2px",
                                      marginBottom: "2px",
                                    }}
                                  >
                                    {gameButtons.map((btn) => (
                                      <button
                                        key={btn.id}
                                        className="homebet_set"
                                        style={{
                                          color: themeColors["--text-sidebar"],
                                          padding: "5px 0",
                                          border: "none",
                                          fontWeight: "bold",
                                        }}
                                        onClick={() => setMoney(btn.value)}
                                      >
                                        + {btn.label}
                                      </button>
                                    ))}
                                  </div>

                                  <div
                                    style={{
                                      display: "grid",
                                      padding: "2px 5px 4px 5px",
                                      gridTemplateColumns: "repeat(4, 1fr)",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    {/* <button
                                onClick={() => setMoney(minOdds)}
                                style={{
                                  backgroundColor: themeColors['--dark-theme-data-min'],
                                  color: themeColors['--dark-theme-color-navbar'],
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Min
                              </button>
                              <button
                                onClick={() => setMoney(maxOdds)}

                                style={{
                                  backgroundColor: themeColors['--dark-theme-dark-blue-bm'],
                                  color: themeColors['--dark-theme-color-navbar'],
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Max
                              </button> */}
                                    <button
                                      style={{
                                        backgroundColor: "transparent",
                                        color: "#0d6efd",
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        setMoney(0);
                                        setPr(0);
                                      }}
                                    >
                                      Clear
                                    </button>
                                    <button
                                      style={{
                                        backgroundColor:
                                          themeColors["--bg-info"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        handleShowV();
                                      }}
                                    >
                                      Edit
                                    </button>

                                    <button
                                      style={{
                                        background: themeColors["--bg-danger"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        setbackActive(0);
                                        setSelectedBet(0);
                                        setlayActive(3);
                                        setMoney(0);
                                        setPr(0);
                                      }}
                                    >
                                      Reset
                                    </button>
                                    <button
                                      style={{
                                        background: themeColors["--bg-success"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => handleSubmit()}
                                    >
                                      Submit
                                    </button>
                                  </div>

                                  {/* <div
                                style={{
                                  display: "grid",
                                  padding: "5px",
                                  gridTemplateColumns: "repeat(2, 1fr)",
                                  gap: "8px",
                                }}
                              >
                              </div> */}
                                </div>
                              </>
                            )}

                            {/* lay */}
                            {selectedBet === 4 && isExpanded === 1 && (
                              <>
                                <div
                                  className="m-0 mt-1 px-2 py-1 bett"
                                  style={{
                                    background: themeColors["--bg-secondary"],
                                    color: themeColors["--dark-theme-color"],
                                  }}
                                >
                                  Place Bet
                                </div>
                                <div
                                  style={{
                                    backgroundColor: "#faa9ba",
                                    color:
                                      themeColors["--dark-theme-color-navbar"],
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    {/* <button
                                style={{
                                  backgroundColor: themeColors['--dark-theme-data-backbtn'],
                                  color: themeColors['--dark-theme-color-navbar'],
                                  padding: "8px 20px",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                BACK
                              </button> */}

                                    {/* <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    marginRight: "8px",
                                  }}
                                  id="matchAtAnyRate"
                                />
                                <label htmlFor="matchAtAnyRate">
                                  Match At Any Rate
                                </label>
                              </div> */}
                                  </div>

                                  <table style={{ width: "100%" }}>
                                    <thead
                                      style={{
                                        backgroundColor:
                                          themeColors["--bg-sidebar"],
                                      }}
                                    >
                                      <tr>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          {" "}
                                          (Bet for){" "}
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          Odds
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          Stake
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          <div>Profit:</div>
                                        </td>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        style={{
                                          borderBottom:
                                            "1px solid var(--table-border) !important",
                                        }}
                                      >
                                        <td style={{ padding: "5px" }}>
                                          <div
                                            style={{
                                              display: "flex",
                                              paddingLeft: "5px",
                                              color: themeColors["--text-body"],
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {runner}
                                          </div>
                                        </td>
                                        <td style={{ padding: "5px" }}>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "24px",
                                              paddingLeft: "5px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={selectedPrice}
                                              onChange={(e) =>
                                                setSelectedPrice(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "12px",
                                                width: "27px",
                                              }}
                                            />
                                            <div>
                                              <button
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-sidebar"],
                                                  color:
                                                    themeColors["--text-body"],
                                                  width: "20px",
                                                  border: "none",
                                                  fontSize: "10px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                }}
                                                onClick={() =>
                                                  handlelayChange(0)
                                                }
                                              >
                                                <IoIosArrowUp />
                                              </button>
                                              <button
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-sidebar"],
                                                  color:
                                                    themeColors["--text-body"],
                                                  width: "20px",
                                                  border: "none",
                                                  fontSize: "10px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                }}
                                                onClick={() =>
                                                  handlelayChange(1)
                                                }
                                              >
                                                <IoIosArrowDown />
                                              </button>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "24px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={money}
                                              onChange={(e) =>
                                                setMoney(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "32px",
                                              }}
                                            />
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            padding: "5px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              paddingRight: "5px",
                                              color: themeColors["--text-body"],
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {(
                                              money *
                                              (selectedPrice - 1)
                                            ).toFixed(1)}
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>

                                  {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(12, 1fr)",
                                gap: "5px",
                                marginBottom: "0px",
                              }}
                            >
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div> */}

                                  <div
                                    style={{
                                      display: "grid",
                                      paddingLeft: "5px",
                                      paddingRight: "5px",
                                      gridTemplateColumns: "repeat(5, 1fr)",
                                      gap: "2px",
                                      marginBottom: "2px",
                                    }}
                                  >
                                    {gameButtons.map((btn) => (
                                      <button
                                        key={btn.id}
                                        className="homebet_set"
                                        style={{
                                          color: themeColors["--text-sidebar"],
                                          padding: "5px 0",
                                          border: "none",
                                          fontWeight: "bold",
                                        }}
                                        onClick={() => setMoney(btn.value)}
                                      >
                                        + {btn.label}
                                      </button>
                                    ))}
                                  </div>

                                  <div
                                    style={{
                                      display: "grid",
                                      padding: "2px 5px 4px 5px",
                                      gridTemplateColumns: "repeat(4, 1fr)",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    {/* <button
                                onClick={() => setMoney(minOdds)}
                                style={{
                                  backgroundColor: themeColors['--dark-theme-data-min'],
                                  color: themeColors['--dark-theme-color-navbar'],
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Min
                              </button>
                              <button
                                onClick={() => setMoney(maxOdds)}

                                style={{
                                  backgroundColor: themeColors['--dark-theme-dark-blue-bm'],
                                  color: themeColors['--dark-theme-color-navbar'],
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Max
                              </button> */}
                                    <button
                                      style={{
                                        backgroundColor: "transparent",
                                        color: "#0d6efd",
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        setMoney(0);
                                        setPr(0);
                                      }}
                                    >
                                      Clear
                                    </button>
                                    <button
                                      style={{
                                        backgroundColor:
                                          themeColors["--bg-info"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        handleShowV();
                                      }}
                                    >
                                      Edit
                                    </button>

                                    <button
                                      style={{
                                        background: themeColors["--bg-danger"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        setbackActive(0);
                                        setSelectedBet(0);
                                        setlayActive(3);
                                        setMoney(0);
                                        setPr(0);
                                      }}
                                    >
                                      Reset
                                    </button>
                                    <button
                                      style={{
                                        background: themeColors["--bg-success"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => handleSubmit()}
                                    >
                                      Submit
                                    </button>
                                  </div>

                                  {/* <div
                                style={{
                                  display: "grid",
                                  padding: "5px",
                                  gridTemplateColumns: "repeat(2, 1fr)",
                                  gap: "8px",
                                }}
                              >
                              </div> */}
                                </div>
                              </>
                            )}

                            {/* /BookMaker */}

                            {/* Mini BookMaker */}

                            {/* back */}
                            {selectedBet === 7 && isExpanded1 === 1 && (
                              <>
                                <div
                                  className="m-0 mt-1 px-2 py-1 bett"
                                  style={{
                                    background: themeColors["--bg-secondary"],
                                    color: themeColors["--dark-theme-color"],
                                  }}
                                >
                                  Place Bet
                                </div>
                                <div
                                  style={{
                                    backgroundColor: "#72bbef",
                                    color:
                                      themeColors["--dark-theme-color-navbar"],
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    {/* <button
                                style={{
                                  backgroundColor: themeColors['--dark-theme-data-backbtn'],
                                  color: themeColors['--dark-theme-color-navbar'],
                                  padding: "8px 20px",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                BACK
                              </button> */}

                                    {/* <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    marginRight: "8px",
                                  }}
                                  id="matchAtAnyRate"
                                />
                                <label htmlFor="matchAtAnyRate">
                                  Match At Any Rate
                                </label>
                              </div> */}
                                  </div>

                                  <table style={{ width: "100%" }}>
                                    <thead
                                      style={{
                                        backgroundColor:
                                          themeColors["--bg-sidebar"],
                                      }}
                                    >
                                      <tr>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          {" "}
                                          (Bet for){" "}
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          Odds
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          Stake
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          <div>Profit:</div>
                                        </td>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        style={{
                                          borderBottom:
                                            "1px solid var(--table-border) !important",
                                        }}
                                      >
                                        <td style={{ padding: "5px" }}>
                                          <div
                                            style={{
                                              display: "flex",
                                              paddingLeft: "5px",
                                              color: themeColors["--text-body"],
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {runner}
                                          </div>
                                        </td>
                                        <td style={{ padding: "5px" }}>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "24px",
                                              paddingLeft: "5px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={selectedPrice}
                                              onChange={(e) =>
                                                setSelectedPrice(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "12px",
                                                width: "27px",
                                              }}
                                            />
                                            <div>
                                              <button
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-sidebar"],
                                                  color:
                                                    themeColors["--text-body"],
                                                  width: "20px",
                                                  border: "none",
                                                  fontSize: "10px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                }}
                                                onClick={() =>
                                                  handlelayChange(0)
                                                }
                                              >
                                                <IoIosArrowUp />
                                              </button>
                                              <button
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-sidebar"],
                                                  color:
                                                    themeColors["--text-body"],
                                                  width: "20px",
                                                  border: "none",
                                                  fontSize: "10px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                }}
                                                onClick={() =>
                                                  handlelayChange(1)
                                                }
                                              >
                                                <IoIosArrowDown />
                                              </button>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "24px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={money}
                                              onChange={(e) =>
                                                setMoney(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "32px",
                                              }}
                                            />
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            padding: "5px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              paddingRight: "5px",
                                              color: themeColors["--text-body"],
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {(
                                              money *
                                              (selectedPrice - 1)
                                            ).toFixed(1)}
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>

                                  {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(12, 1fr)",
                                gap: "5px",
                                marginBottom: "0px",
                              }}
                            >
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div> */}

                                  <div
                                    style={{
                                      display: "grid",
                                      paddingLeft: "5px",
                                      paddingRight: "5px",
                                      gridTemplateColumns: "repeat(5, 1fr)",
                                      gap: "2px",
                                      marginBottom: "2px",
                                    }}
                                  >
                                    {gameButtons.map((btn) => (
                                      <button
                                        key={btn.id}
                                        className="homebet_set"
                                        style={{
                                          color: themeColors["--text-sidebar"],
                                          padding: "5px 0",
                                          border: "none",
                                          fontWeight: "bold",
                                        }}
                                        onClick={() => setMoney(btn.value)}
                                      >
                                        + {btn.label}
                                      </button>
                                    ))}
                                  </div>

                                  <div
                                    style={{
                                      display: "grid",
                                      padding: "2px 5px 4px 5px",
                                      gridTemplateColumns: "repeat(4, 1fr)",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    {/* <button
                                onClick={() => setMoney(minOdds)}
                                style={{
                                  backgroundColor: themeColors['--dark-theme-data-min'],
                                  color: themeColors['--dark-theme-color-navbar'],
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Min
                              </button>
                              <button
                                onClick={() => setMoney(maxOdds)}

                                style={{
                                  backgroundColor: themeColors['--dark-theme-dark-blue-bm'],
                                  color: themeColors['--dark-theme-color-navbar'],
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Max
                              </button> */}
                                    <button
                                      style={{
                                        backgroundColor: "transparent",
                                        color: "#0d6efd",
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        setMoney(0);
                                        setPr(0);
                                      }}
                                    >
                                      Clear
                                    </button>
                                    <button
                                      style={{
                                        backgroundColor:
                                          themeColors["--bg-info"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        handleShowV();
                                      }}
                                    >
                                      Edit
                                    </button>

                                    <button
                                      style={{
                                        background: themeColors["--bg-danger"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        setbackActive(0);
                                        setSelectedBet(0);
                                        setlayActive(3);
                                        setMoney(0);
                                        setPr(0);
                                      }}
                                    >
                                      Reset
                                    </button>
                                    <button
                                      style={{
                                        background: themeColors["--bg-success"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => handleSubmit()}
                                    >
                                      Submit
                                    </button>
                                  </div>
                                </div>
                              </>
                            )}

                            {/* lay */}
                            {selectedBet === 8 && isExpanded1 === 1 && (
                              <>
                                <div
                                  className="m-0 mt-1 px-2 py-1 bett"
                                  style={{
                                    background: themeColors["--bg-secondary"],
                                    color: themeColors["--dark-theme-color"],
                                  }}
                                >
                                  Place Bet
                                </div>
                                <div
                                  style={{
                                    backgroundColor: "#faa9ba",
                                    color:
                                      themeColors["--dark-theme-color-navbar"],
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    {/* <button
                                style={{
                                  backgroundColor: themeColors['--dark-theme-data-backbtn'],
                                  color: themeColors['--dark-theme-color-navbar'],
                                  padding: "8px 20px",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                BACK
                              </button> */}

                                    {/* <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    marginRight: "8px",
                                  }}
                                  id="matchAtAnyRate"
                                />
                                <label htmlFor="matchAtAnyRate">
                                  Match At Any Rate
                                </label>
                              </div> */}
                                  </div>

                                  <table style={{ width: "100%" }}>
                                    <thead
                                      style={{
                                        backgroundColor:
                                          themeColors["--bg-sidebar"],
                                      }}
                                    >
                                      <tr>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          {" "}
                                          (Bet for){" "}
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          Odds
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          Stake
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          <div>Profit:</div>
                                        </td>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        style={{
                                          borderBottom:
                                            "1px solid var(--table-border) !important",
                                        }}
                                      >
                                        <td style={{ padding: "5px" }}>
                                          <div
                                            style={{
                                              display: "flex",
                                              paddingLeft: "5px",
                                              color: themeColors["--text-body"],
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {runner}
                                          </div>
                                        </td>
                                        <td style={{ padding: "5px" }}>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "24px",
                                              paddingLeft: "5px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={selectedPrice}
                                              onChange={(e) =>
                                                setSelectedPrice(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "12px",
                                                width: "27px",
                                              }}
                                            />
                                            <div>
                                              <button
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-sidebar"],
                                                  color:
                                                    themeColors["--text-body"],
                                                  width: "20px",
                                                  border: "none",
                                                  fontSize: "10px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                }}
                                                onClick={() =>
                                                  handlelayChange(0)
                                                }
                                              >
                                                <IoIosArrowUp />
                                              </button>
                                              <button
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-sidebar"],
                                                  color:
                                                    themeColors["--text-body"],
                                                  width: "20px",
                                                  border: "none",
                                                  fontSize: "10px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                }}
                                                onClick={() =>
                                                  handlelayChange(1)
                                                }
                                              >
                                                <IoIosArrowDown />
                                              </button>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "24px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={money}
                                              onChange={(e) =>
                                                setMoney(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "32px",
                                              }}
                                            />
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            padding: "5px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              paddingRight: "5px",
                                              color: themeColors["--text-body"],
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {(
                                              money *
                                              (selectedPrice - 1)
                                            ).toFixed(1)}
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>

                                  {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(12, 1fr)",
                                gap: "5px",
                                marginBottom: "0px",
                              }}
                            >
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div> */}

                                  <div
                                    style={{
                                      display: "grid",
                                      paddingLeft: "5px",
                                      paddingRight: "5px",
                                      gridTemplateColumns: "repeat(5, 1fr)",
                                      gap: "2px",
                                      marginBottom: "2px",
                                    }}
                                  >
                                    {gameButtons.map((btn) => (
                                      <button
                                        key={btn.id}
                                        className="homebet_set"
                                        style={{
                                          color: themeColors["--text-sidebar"],
                                          padding: "5px 0",
                                          border: "none",
                                          fontWeight: "bold",
                                        }}
                                        onClick={() => setMoney(btn.value)}
                                      >
                                        + {btn.label}
                                      </button>
                                    ))}
                                  </div>

                                  <div
                                    style={{
                                      display: "grid",
                                      padding: "2px 5px 4px 5px",
                                      gridTemplateColumns: "repeat(4, 1fr)",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    {/* <button
                                onClick={() => setMoney(minOdds)}
                                style={{
                                  backgroundColor: themeColors['--dark-theme-data-min'],
                                  color: themeColors['--dark-theme-color-navbar'],
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Min
                              </button>
                              <button
                                onClick={() => setMoney(maxOdds)}

                                style={{
                                  backgroundColor: themeColors['--dark-theme-dark-blue-bm'],
                                  color: themeColors['--dark-theme-color-navbar'],
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Max
                              </button> */}
                                    <button
                                      style={{
                                        backgroundColor: "transparent",
                                        color: "#0d6efd",
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        setMoney(0);
                                        setPr(0);
                                      }}
                                    >
                                      Clear
                                    </button>
                                    <button
                                      style={{
                                        backgroundColor:
                                          themeColors["--bg-info"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        handleShowV();
                                      }}
                                    >
                                      Edit
                                    </button>

                                    <button
                                      style={{
                                        background: themeColors["--bg-danger"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        setbackActive(0);
                                        setSelectedBet(0);
                                        setlayActive(3);
                                        setMoney(0);
                                        setPr(0);
                                      }}
                                    >
                                      Reset
                                    </button>
                                    <button
                                      style={{
                                        background: themeColors["--bg-success"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => handleSubmit3()}
                                    >
                                      Submit
                                    </button>
                                  </div>

                                  {/* <div
                                style={{
                                  display: "grid",
                                  padding: "5px",
                                  gridTemplateColumns: "repeat(2, 1fr)",
                                  gap: "8px",
                                }}
                              >
                              </div> */}
                                </div>
                              </>
                            )}

                            {/* /Mini BookMaker */}

                            {/* Toss */}

                            {/* back */}
                            {selectedBet === 5 && isExpanded2 === 1 && (
                              <>
                                <div
                                  className="m-0 mt-1 px-2 py-1 bett"
                                  style={{
                                    background: themeColors["--bg-secondary"],
                                    color: themeColors["--dark-theme-color"],
                                  }}
                                >
                                  Place Bet
                                </div>
                                <div
                                  style={{
                                    backgroundColor: "#72bbef",
                                    color:
                                      themeColors["--dark-theme-color-navbar"],
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    {/* <button
                                style={{
                                  backgroundColor: themeColors['--dark-theme-data-backbtn'],
                                  color: themeColors['--dark-theme-color-navbar'],
                                  padding: "8px 20px",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                BACK
                              </button> */}

                                    {/* <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    marginRight: "8px",
                                  }}
                                  id="matchAtAnyRate"
                                />
                                <label htmlFor="matchAtAnyRate">
                                  Match At Any Rate
                                </label>
                              </div> */}
                                  </div>

                                  <table style={{ width: "100%" }}>
                                    <thead
                                      style={{
                                        backgroundColor:
                                          themeColors["--bg-sidebar"],
                                      }}
                                    >
                                      <tr>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          {" "}
                                          (Bet for){" "}
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          Odds
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          Stake
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          <div>Profit:</div>
                                        </td>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        style={{
                                          borderBottom:
                                            "1px solid var(--table-border) !important",
                                        }}
                                      >
                                        <td style={{ padding: "5px" }}>
                                          <div
                                            style={{
                                              display: "flex",
                                              paddingLeft: "5px",
                                              color: themeColors["--text-body"],
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {runner}
                                          </div>
                                        </td>
                                        <td style={{ padding: "5px" }}>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "24px",
                                              paddingLeft: "5px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={selectedPrice}
                                              onChange={(e) =>
                                                setSelectedPrice(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "12px",
                                                width: "27px",
                                              }}
                                            />
                                            <div>
                                              <button
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-sidebar"],
                                                  color:
                                                    themeColors["--text-body"],
                                                  width: "20px",
                                                  border: "none",
                                                  fontSize: "10px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                }}
                                                onClick={() =>
                                                  handlelayChange(0)
                                                }
                                              >
                                                <IoIosArrowUp />
                                              </button>
                                              <button
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-sidebar"],
                                                  color:
                                                    themeColors["--text-body"],
                                                  width: "20px",
                                                  border: "none",
                                                  fontSize: "10px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                }}
                                                onClick={() =>
                                                  handlelayChange(1)
                                                }
                                              >
                                                <IoIosArrowDown />
                                              </button>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "24px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={money}
                                              onChange={(e) =>
                                                setMoney(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "32px",
                                              }}
                                            />
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            padding: "5px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              paddingRight: "5px",
                                              color: themeColors["--text-body"],
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {(
                                              money *
                                              (selectedPrice - 1)
                                            ).toFixed(1)}
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>

                                  {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(12, 1fr)",
                                gap: "5px",
                                marginBottom: "0px",
                              }}
                            >
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div> */}

                                  <div
                                    style={{
                                      display: "grid",
                                      paddingLeft: "5px",
                                      paddingRight: "5px",
                                      gridTemplateColumns: "repeat(5, 1fr)",
                                      gap: "2px",
                                      marginBottom: "2px",
                                    }}
                                  >
                                    {gameButtons.map((btn) => (
                                      <button
                                        key={btn.id}
                                        className="homebet_set"
                                        style={{
                                          color: themeColors["--text-sidebar"],
                                          padding: "5px 0",
                                          border: "none",
                                          fontWeight: "bold",
                                        }}
                                        onClick={() => setMoney(btn.value)}
                                      >
                                        + {btn.label}
                                      </button>
                                    ))}
                                  </div>

                                  <div
                                    style={{
                                      display: "grid",
                                      padding: "2px 5px 4px 5px",
                                      gridTemplateColumns: "repeat(4, 1fr)",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    {/* <button
                                onClick={() => setMoney(minOdds)}
                                style={{
                                  backgroundColor: themeColors['--dark-theme-data-min'],
                                  color: themeColors['--dark-theme-color-navbar'],
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Min
                              </button>
                              <button
                                onClick={() => setMoney(maxOdds)}

                                style={{
                                  backgroundColor: themeColors['--dark-theme-dark-blue-bm'],
                                  color: themeColors['--dark-theme-color-navbar'],
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Max
                              </button> */}
                                    <button
                                      style={{
                                        backgroundColor: "transparent",
                                        color: "#0d6efd",
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        setMoney(0);
                                        setPr(0);
                                      }}
                                    >
                                      Clear
                                    </button>
                                    <button
                                      style={{
                                        backgroundColor:
                                          themeColors["--bg-info"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        handleShowV();
                                      }}
                                    >
                                      Edit
                                    </button>

                                    <button
                                      style={{
                                        background: themeColors["--bg-danger"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        setbackActive(0);
                                        setSelectedBet(0);
                                        setlayActive(3);
                                        setMoney(0);
                                        setPr(0);
                                      }}
                                    >
                                      Reset
                                    </button>
                                    <button
                                      style={{
                                        background: themeColors["--bg-success"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => handleSubmit3()}
                                    >
                                      Submit
                                    </button>
                                  </div>

                                  {/* <div
                                style={{
                                  display: "grid",
                                  padding: "5px",
                                  gridTemplateColumns: "repeat(2, 1fr)",
                                  gap: "8px",
                                }}
                              >
                              </div> */}
                                </div>
                              </>
                            )}

                            {/* lay */}
                            {selectedBet === 6 && isExpanded2 === 1 && (
                              <>
                                <div
                                  className="m-0 mt-1 px-2 py-1 bett"
                                  style={{
                                    background: themeColors["--bg-secondary"],
                                    color: themeColors["--dark-theme-color"],
                                  }}
                                >
                                  Place Bet
                                </div>
                                <div
                                  style={{
                                    backgroundColor: "#faa9ba",
                                    color:
                                      themeColors["--dark-theme-color-navbar"],
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    {/* <button
                                style={{
                                  backgroundColor: themeColors['--dark-theme-data-backbtn'],
                                  color: themeColors['--dark-theme-color-navbar'],
                                  padding: "8px 20px",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                BACK
                              </button> */}

                                    {/* <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    marginRight: "8px",
                                  }}
                                  id="matchAtAnyRate"
                                />
                                <label htmlFor="matchAtAnyRate">
                                  Match At Any Rate
                                </label>
                              </div> */}
                                  </div>

                                  <table style={{ width: "100%" }}>
                                    <thead
                                      style={{
                                        backgroundColor:
                                          themeColors["--bg-sidebar"],
                                      }}
                                    >
                                      <tr>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          {" "}
                                          (Bet for){" "}
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          Odds
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          Stake
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color: themeColors["--text-body"],
                                            fontWeight: "bold",
                                            padding: "5px",
                                          }}
                                        >
                                          <div>Profit:</div>
                                        </td>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        style={{
                                          borderBottom:
                                            "1px solid var(--table-border) !important",
                                        }}
                                      >
                                        <td style={{ padding: "5px" }}>
                                          <div
                                            style={{
                                              display: "flex",
                                              paddingLeft: "5px",
                                              color: themeColors["--text-body"],
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {runner}
                                          </div>
                                        </td>
                                        <td style={{ padding: "5px" }}>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "24px",
                                              paddingLeft: "5px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={selectedPrice}
                                              onChange={(e) =>
                                                setSelectedPrice(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "12px",
                                                width: "27px",
                                              }}
                                            />
                                            <div>
                                              <button
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-sidebar"],
                                                  color:
                                                    themeColors["--text-body"],
                                                  width: "20px",
                                                  border: "none",
                                                  fontSize: "10px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                }}
                                                onClick={() =>
                                                  handlelayChange(0)
                                                }
                                              >
                                                <IoIosArrowUp />
                                              </button>
                                              <button
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-sidebar"],
                                                  color:
                                                    themeColors["--text-body"],
                                                  width: "20px",
                                                  border: "none",
                                                  fontSize: "10px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                }}
                                                onClick={() =>
                                                  handlelayChange(1)
                                                }
                                              >
                                                <IoIosArrowDown />
                                              </button>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "24px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={money}
                                              onChange={(e) =>
                                                setMoney(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "32px",
                                              }}
                                            />
                                          </div>
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            padding: "5px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              paddingRight: "5px",
                                              color: themeColors["--text-body"],
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {(
                                              money *
                                              (selectedPrice - 1)
                                            ).toFixed(1)}
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>

                                  {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(12, 1fr)",
                                gap: "5px",
                                marginBottom: "0px",
                              }}
                            >
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </div> */}

                                  <div
                                    style={{
                                      display: "grid",
                                      paddingLeft: "5px",
                                      paddingRight: "5px",
                                      gridTemplateColumns: "repeat(5, 1fr)",
                                      gap: "2px",
                                      marginBottom: "2px",
                                    }}
                                  >
                                    {gameButtons.map((btn) => (
                                      <button
                                        key={btn.id}
                                        className="homebet_set"
                                        style={{
                                          color: themeColors["--text-sidebar"],
                                          padding: "5px 0",
                                          border: "none",
                                          fontWeight: "bold",
                                        }}
                                        onClick={() => setMoney(btn.value)}
                                      >
                                        + {btn.label}
                                      </button>
                                    ))}
                                  </div>

                                  <div
                                    style={{
                                      display: "grid",
                                      padding: "2px 5px 4px 5px",
                                      gridTemplateColumns: "repeat(4, 1fr)",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    {/* <button
                                onClick={() => setMoney(minOdds)}
                                style={{
                                  backgroundColor: themeColors['--dark-theme-data-min'],
                                  color: themeColors['--dark-theme-color-navbar'],
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Min
                              </button>
                              <button
                                onClick={() => setMoney(maxOdds)}

                                style={{
                                  backgroundColor: themeColors['--dark-theme-dark-blue-bm'],
                                  color: themeColors['--dark-theme-color-navbar'],
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Max
                              </button> */}
                                    <button
                                      style={{
                                        backgroundColor: "transparent",
                                        color: "#0d6efd",
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        setMoney(0);
                                        setPr(0);
                                      }}
                                    >
                                      Clear
                                    </button>
                                    <button
                                      style={{
                                        backgroundColor:
                                          themeColors["--bg-info"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        handleShowV();
                                      }}
                                    >
                                      Edit
                                    </button>

                                    <button
                                      style={{
                                        background: themeColors["--bg-danger"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => {
                                        setbackActive(0);
                                        setSelectedBet(0);
                                        setlayActive(3);
                                        setMoney(0);
                                        setPr(0);
                                      }}
                                    >
                                      Reset
                                    </button>
                                    <button
                                      style={{
                                        background: themeColors["--bg-success"],
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        padding: "9px 0",
                                        border: "none",
                                        fontWeight: "bold",
                                      }}
                                      onClick={() => handleSubmit()}
                                    >
                                      Submit
                                    </button>
                                  </div>

                                  {/* <div
                                style={{
                                  display: "grid",
                                  padding: "5px",
                                  gridTemplateColumns: "repeat(2, 1fr)",
                                  gap: "8px",
                                }}
                              >
                              </div> */}
                                </div>
                              </>
                            )}

                            {/* /Toss */}

                            {/* Fancy Markets */}

                            {/* /Fancy Markets */}

                            {/* Session */}
                            {Array.isArray(session) &&
                            session.length > 0 &&
                            (newactive === 0 || newactive === 1) ? (
                              <div className="d-flex flex-column align-items-baseline w-100">
                                {isExpanded3 === 1 && (
                                  <div className="w-100">
                                    {session.map((item, index) => (
                                      <div key={index} className="w-100">
                                        {/* back */}
                                        {fancyBet === index &&
                                          selectedBet === 2 && (
                                            <>
                                              <div
                                                className="m-0 mt-1 px-2 py-1 bett"
                                                style={{
                                                  background:
                                                    themeColors[
                                                      "--bg-secondary"
                                                    ],
                                                  color:
                                                    themeColors[
                                                      "--dark-theme-color"
                                                    ],
                                                }}
                                              >
                                                Place Bet
                                              </div>
                                              <div
                                                style={{
                                                  backgroundColor: "#faa9ba",
                                                  color:
                                                    themeColors[
                                                      "--dark-theme-color-navbar"
                                                    ],
                                                  width: "100%",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent:
                                                      "space-between",
                                                    alignItems: "center",
                                                  }}
                                                ></div>

                                                <table
                                                  style={{ width: "100%" }}
                                                >
                                                  <thead
                                                    style={{
                                                      backgroundColor:
                                                        themeColors[
                                                          "--bg-sidebar"
                                                        ],
                                                    }}
                                                  >
                                                    <tr>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        {" "}
                                                        (Bet for){" "}
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        Odds
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        Stake
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div>Profit:</div>
                                                      </td>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    <tr
                                                      style={{
                                                        borderBottom:
                                                          "1px solid var(--table-border) !important",
                                                      }}
                                                    >
                                                      <td
                                                        style={{
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            paddingLeft: "5px",
                                                            color:
                                                              themeColors[
                                                                "--text-body"
                                                              ],
                                                            fontWeight: "bold",
                                                          }}
                                                        >
                                                          {selectFancy}
                                                        </div>
                                                      </td>
                                                      <td
                                                        style={{
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "24px",
                                                            paddingLeft: "5px",
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            value={
                                                              selectedMarket
                                                            }
                                                            onChange={(e) =>
                                                              setSelectedMarket(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                themeColors[
                                                                  "--dark-theme-color-navbar"
                                                                ],
                                                              color:
                                                                themeColors[
                                                                  "--dark-theme-white-color"
                                                                ],
                                                              border: "none",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "12px",
                                                              width: "27px",
                                                            }}
                                                          />
                                                          <div>
                                                            <button
                                                              style={{
                                                                backgroundColor:
                                                                  themeColors[
                                                                    "--bg-sidebar"
                                                                  ],
                                                                color:
                                                                  themeColors[
                                                                    "--text-body"
                                                                  ],
                                                                width: "20px",
                                                                border: "none",
                                                                fontSize:
                                                                  "10px",
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                justifyContent:
                                                                  "center",
                                                              }}
                                                              onClick={() =>
                                                                handlefancyChange(
                                                                  0
                                                                )
                                                              }
                                                            >
                                                              <IoIosArrowUp />
                                                            </button>
                                                            <button
                                                              style={{
                                                                backgroundColor:
                                                                  themeColors[
                                                                    "--bg-sidebar"
                                                                  ],
                                                                color:
                                                                  themeColors[
                                                                    "--text-body"
                                                                  ],
                                                                width: "20px",
                                                                border: "none",
                                                                fontSize:
                                                                  "10px",
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                justifyContent:
                                                                  "center",
                                                              }}
                                                              onClick={() =>
                                                                handlefancyChange(
                                                                  1
                                                                )
                                                              }
                                                            >
                                                              <IoIosArrowDown />
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </td>
                                                      <td>
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "24px",
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            value={money}
                                                            onChange={(e) =>
                                                              setMoney(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                themeColors[
                                                                  "--dark-theme-color-navbar"
                                                                ],
                                                              color:
                                                                themeColors[
                                                                  "--dark-theme-white-color"
                                                                ],
                                                              border: "none",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "13px",
                                                              width: "32px",
                                                            }}
                                                          />
                                                        </div>
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            paddingRight: "5px",
                                                            color:
                                                              themeColors[
                                                                "--text-body"
                                                              ],
                                                            fontWeight: "bold",
                                                          }}
                                                        >
                                                          {(money * 2).toFixed(
                                                            1
                                                          )}
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>

                                                <div
                                                  style={{
                                                    display: "grid",
                                                    paddingLeft: "5px",
                                                    paddingRight: "5px",
                                                    gridTemplateColumns:
                                                      "repeat(5, 1fr)",
                                                    gap: "2px",
                                                    marginBottom: "2px",
                                                  }}
                                                >
                                                  {gameButtons.map((btn) => (
                                                    <button
                                                      key={btn.id}
                                                      className="homebet_set"
                                                      style={{
                                                        color:
                                                          themeColors[
                                                            "--text-sidebar"
                                                          ],
                                                        padding: "5px 0",
                                                        border: "none",
                                                        fontWeight: "bold",
                                                      }}
                                                      onClick={() =>
                                                        setMoney(btn.value)
                                                      }
                                                    >
                                                      + {btn.label}
                                                    </button>
                                                  ))}
                                                </div>

                                                <div
                                                  style={{
                                                    display: "grid",
                                                    padding: "2px 5px 4px 5px",
                                                    gridTemplateColumns:
                                                      "repeat(4, 1fr)",
                                                    marginBottom: "8px",
                                                  }}
                                                >
                                                  <button
                                                    style={{
                                                      backgroundColor:
                                                        "transparent",
                                                      color: "#0d6efd",
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() => {
                                                      setMoney(0);
                                                      setPr(0);
                                                    }}
                                                  >
                                                    Clear
                                                  </button>
                                                  <button
                                                    style={{
                                                      backgroundColor:
                                                        themeColors[
                                                          "--bg-info"
                                                        ],
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() => {
                                                      handleShowV();
                                                    }}
                                                  >
                                                    Edit
                                                  </button>

                                                  <button
                                                    style={{
                                                      background:
                                                        themeColors[
                                                          "--bg-danger"
                                                        ],
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() => {
                                                      setbackActive(0);
                                                      setSelectedBet(0);
                                                      setlayActive(3);
                                                      setMoney(0);
                                                      setPr(0);
                                                    }}
                                                  >
                                                    Reset
                                                  </button>
                                                  <button
                                                    style={{
                                                      background:
                                                        themeColors[
                                                          "--bg-success"
                                                        ],
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() =>
                                                      handleSubmit3()
                                                    }
                                                  >
                                                    Submit
                                                  </button>
                                                </div>
                                              </div>
                                            </>
                                          )}

                                        {/* lay */}
                                        {fancyBet === index &&
                                          selectedBet === 1 && (
                                            <>
                                              <div
                                                className="m-0 mt-1 px-2 py-1 bett"
                                                style={{
                                                  background:
                                                    themeColors[
                                                      "--bg-secondary"
                                                    ],
                                                  color:
                                                    themeColors[
                                                      "--dark-theme-color"
                                                    ],
                                                }}
                                              >
                                                PlaceW Bet
                                              </div>
                                              <div
                                                style={{
                                                  backgroundColor: "#72bbef",
                                                  color:
                                                    themeColors[
                                                      "--dark-theme-color-navbar"
                                                    ],
                                                  width: "100%",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent:
                                                      "space-between",
                                                    alignItems: "center",
                                                  }}
                                                ></div>

                                                <table
                                                  style={{ width: "100%" }}
                                                >
                                                  <thead
                                                    style={{
                                                      backgroundColor:
                                                        themeColors[
                                                          "--bg-sidebar"
                                                        ],
                                                    }}
                                                  >
                                                    <tr>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        {" "}
                                                        (Bet for){" "}
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        Odds
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        Stake
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div>Profit:</div>
                                                      </td>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    <tr
                                                      style={{
                                                        borderBottom:
                                                          "1px solid var(--table-border) !important",
                                                      }}
                                                    >
                                                      <td
                                                        style={{
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            paddingLeft: "5px",
                                                            color:
                                                              themeColors[
                                                                "--text-body"
                                                              ],
                                                            fontWeight: "bold",
                                                          }}
                                                        >
                                                          {selectFancy}
                                                        </div>
                                                      </td>
                                                      <td
                                                        style={{
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "24px",
                                                            paddingLeft: "5px",
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            value={
                                                              selectedMarket
                                                            }
                                                            onChange={(e) =>
                                                              setSelectedMarket(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                themeColors[
                                                                  "--dark-theme-color-navbar"
                                                                ],
                                                              color:
                                                                themeColors[
                                                                  "--dark-theme-white-color"
                                                                ],
                                                              border: "none",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "12px",
                                                              width: "27px",
                                                            }}
                                                          />
                                                          <div>
                                                            <button
                                                              style={{
                                                                backgroundColor:
                                                                  themeColors[
                                                                    "--bg-sidebar"
                                                                  ],
                                                                color:
                                                                  themeColors[
                                                                    "--text-body"
                                                                  ],
                                                                width: "20px",
                                                                border: "none",
                                                                fontSize:
                                                                  "10px",
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                justifyContent:
                                                                  "center",
                                                              }}
                                                              onClick={() =>
                                                                handlefancyChange(
                                                                  0
                                                                )
                                                              }
                                                            >
                                                              <IoIosArrowUp />
                                                            </button>
                                                            <button
                                                              style={{
                                                                backgroundColor:
                                                                  themeColors[
                                                                    "--bg-sidebar"
                                                                  ],
                                                                color:
                                                                  themeColors[
                                                                    "--text-body"
                                                                  ],
                                                                width: "20px",
                                                                border: "none",
                                                                fontSize:
                                                                  "10px",
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                justifyContent:
                                                                  "center",
                                                              }}
                                                              onClick={() =>
                                                                handlefancyChange(
                                                                  1
                                                                )
                                                              }
                                                            >
                                                              <IoIosArrowDown />
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </td>
                                                      <td>
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "24px",
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            value={money}
                                                            onChange={(e) =>
                                                              setMoney(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                themeColors[
                                                                  "--dark-theme-color-navbar"
                                                                ],
                                                              color:
                                                                themeColors[
                                                                  "--dark-theme-white-color"
                                                                ],
                                                              border: "none",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "13px",
                                                              width: "32px",
                                                            }}
                                                          />
                                                        </div>
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            paddingRight: "5px",
                                                            color:
                                                              themeColors[
                                                                "--text-body"
                                                              ],
                                                            fontWeight: "bold",
                                                          }}
                                                        >
                                                          {(money * 2).toFixed(
                                                            1
                                                          )}
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>

                                                <div
                                                  style={{
                                                    display: "grid",
                                                    paddingLeft: "5px",
                                                    paddingRight: "5px",
                                                    gridTemplateColumns:
                                                      "repeat(5, 1fr)",
                                                    gap: "2px",
                                                    marginBottom: "2px",
                                                  }}
                                                >
                                                  {gameButtons.map((btn) => (
                                                    <button
                                                      key={btn.id}
                                                      className="homebet_set"
                                                      style={{
                                                        color:
                                                          themeColors[
                                                            "--text-sidebar"
                                                          ],
                                                        padding: "5px 0",
                                                        border: "none",
                                                        fontWeight: "bold",
                                                      }}
                                                      onClick={() =>
                                                        setMoney(btn.value)
                                                      }
                                                    >
                                                      + {btn.label}
                                                    </button>
                                                  ))}
                                                </div>

                                                <div
                                                  style={{
                                                    display: "grid",
                                                    padding: "2px 5px 4px 5px",
                                                    gridTemplateColumns:
                                                      "repeat(4, 1fr)",
                                                    marginBottom: "8px",
                                                  }}
                                                >
                                                  <button
                                                    style={{
                                                      backgroundColor:
                                                        "transparent",
                                                      color: "#0d6efd",
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() => {
                                                      setMoney(0);
                                                      setPr(0);
                                                    }}
                                                  >
                                                    Clear
                                                  </button>
                                                  <button
                                                    style={{
                                                      backgroundColor:
                                                        themeColors[
                                                          "--bg-info"
                                                        ],
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() => {
                                                      handleShowV();
                                                    }}
                                                  >
                                                    Edit
                                                  </button>

                                                  <button
                                                    style={{
                                                      background:
                                                        themeColors[
                                                          "--bg-danger"
                                                        ],
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() => {
                                                      setbackActive(0);
                                                      setSelectedBet(0);
                                                      setlayActive(3);
                                                      setMoney(0);
                                                      setPr(0);
                                                    }}
                                                  >
                                                    Reset
                                                  </button>
                                                  <button
                                                    style={{
                                                      background:
                                                        themeColors[
                                                          "--bg-success"
                                                        ],
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() =>
                                                      handleSubmit3()
                                                    }
                                                  >
                                                    Submit
                                                  </button>
                                                </div>
                                              </div>
                                            </>
                                          )}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            ) : (
                              <p className="text-white"></p>
                            )}
                            {/* /Session */}

                            {/* WP Market */}
                            {Array.isArray(wpMarket) &&
                            wpMarket.length > 0 &&
                            (newactive === 0 || newactive === 2) ? (
                              <div className="align-items-baseline">
                                {isExpanded4 === 1 && (
                                  <div className="w-100">
                                    {wpMarket.map((item, index) => (
                                      <div key={index} className="w-100 mb-0">
                                        {/* back */}
                                        {fancymarket === index &&
                                          selectedBet === 10 && (
                                            <>
                                              <div
                                                className="m-0 mt-1 px-2 py-1 bett"
                                                style={{
                                                  background:
                                                    themeColors[
                                                      "--bg-secondary"
                                                    ],
                                                  color:
                                                    themeColors[
                                                      "--dark-theme-color"
                                                    ],
                                                }}
                                              >
                                                PlaceW Bet
                                              </div>
                                              <div
                                                style={{
                                                  backgroundColor: "#faa9ba",
                                                  color:
                                                    themeColors[
                                                      "--dark-theme-color-navbar"
                                                    ],
                                                  width: "100%",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent:
                                                      "space-between",
                                                    alignItems: "center",
                                                  }}
                                                ></div>

                                                <table
                                                  style={{ width: "100%" }}
                                                >
                                                  <thead
                                                    style={{
                                                      backgroundColor:
                                                        themeColors[
                                                          "--bg-sidebar"
                                                        ],
                                                    }}
                                                  >
                                                    <tr>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        {" "}
                                                        (Bet for){" "}
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        Odds
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        Stake
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div>Profit:</div>
                                                      </td>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    <tr
                                                      style={{
                                                        borderBottom:
                                                          "1px solid var(--table-border) !important",
                                                      }}
                                                    >
                                                      <td
                                                        style={{
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            paddingLeft: "5px",
                                                            color:
                                                              themeColors[
                                                                "--text-body"
                                                              ],
                                                            fontWeight: "bold",
                                                          }}
                                                        >
                                                          {selectFancy}
                                                        </div>
                                                      </td>
                                                      <td
                                                        style={{
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "24px",
                                                            paddingLeft: "5px",
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            value={
                                                              selectedMarket
                                                            }
                                                            onChange={(e) =>
                                                              setSelectedMarket(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                themeColors[
                                                                  "--dark-theme-color-navbar"
                                                                ],
                                                              color:
                                                                themeColors[
                                                                  "--dark-theme-white-color"
                                                                ],
                                                              border: "none",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "12px",
                                                              width: "27px",
                                                            }}
                                                          />
                                                          <div>
                                                            <button
                                                              style={{
                                                                backgroundColor:
                                                                  themeColors[
                                                                    "--bg-sidebar"
                                                                  ],
                                                                color:
                                                                  themeColors[
                                                                    "--text-body"
                                                                  ],
                                                                width: "20px",
                                                                border: "none",
                                                                fontSize:
                                                                  "10px",
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                justifyContent:
                                                                  "center",
                                                              }}
                                                              onClick={() =>
                                                                handlefancyChange(
                                                                  0
                                                                )
                                                              }
                                                            >
                                                              <IoIosArrowUp />
                                                            </button>
                                                            <button
                                                              style={{
                                                                backgroundColor:
                                                                  themeColors[
                                                                    "--bg-sidebar"
                                                                  ],
                                                                color:
                                                                  themeColors[
                                                                    "--text-body"
                                                                  ],
                                                                width: "20px",
                                                                border: "none",
                                                                fontSize:
                                                                  "10px",
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                justifyContent:
                                                                  "center",
                                                              }}
                                                              onClick={() =>
                                                                handlefancyChange(
                                                                  1
                                                                )
                                                              }
                                                            >
                                                              <IoIosArrowDown />
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </td>
                                                      <td>
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "24px",
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            value={money}
                                                            onChange={(e) =>
                                                              setMoney(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                themeColors[
                                                                  "--dark-theme-color-navbar"
                                                                ],
                                                              color:
                                                                themeColors[
                                                                  "--dark-theme-white-color"
                                                                ],
                                                              border: "none",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "13px",
                                                              width: "32px",
                                                            }}
                                                          />
                                                        </div>
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            paddingRight: "5px",
                                                            color:
                                                              themeColors[
                                                                "--text-body"
                                                              ],
                                                            fontWeight: "bold",
                                                          }}
                                                        >
                                                          {(money * 2).toFixed(
                                                            1
                                                          )}
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>

                                                <div
                                                  style={{
                                                    display: "grid",
                                                    paddingLeft: "5px",
                                                    paddingRight: "5px",
                                                    gridTemplateColumns:
                                                      "repeat(5, 1fr)",
                                                    gap: "2px",
                                                    marginBottom: "2px",
                                                  }}
                                                >
                                                  {gameButtons.map((btn) => (
                                                    <button
                                                      key={btn.id}
                                                      className="homebet_set"
                                                      style={{
                                                        color:
                                                          themeColors[
                                                            "--text-sidebar"
                                                          ],
                                                        padding: "5px 0",
                                                        border: "none",
                                                        fontWeight: "bold",
                                                      }}
                                                      onClick={() =>
                                                        setMoney(btn.value)
                                                      }
                                                    >
                                                      + {btn.label}
                                                    </button>
                                                  ))}
                                                </div>

                                                <div
                                                  style={{
                                                    display: "grid",
                                                    padding: "2px 5px 4px 5px",
                                                    gridTemplateColumns:
                                                      "repeat(4, 1fr)",
                                                    marginBottom: "8px",
                                                  }}
                                                >
                                                  <button
                                                    style={{
                                                      backgroundColor:
                                                        "transparent",
                                                      color: "#0d6efd",
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() => {
                                                      setMoney(0);
                                                      setPr(0);
                                                    }}
                                                  >
                                                    Clear
                                                  </button>
                                                  <button
                                                    style={{
                                                      backgroundColor:
                                                        themeColors[
                                                          "--bg-info"
                                                        ],
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() => {
                                                      handleShowV();
                                                    }}
                                                  >
                                                    Edit
                                                  </button>

                                                  <button
                                                    style={{
                                                      background:
                                                        themeColors[
                                                          "--bg-danger"
                                                        ],
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() => {
                                                      setbackActive(0);
                                                      setSelectedBet(0);
                                                      setlayActive(3);
                                                      setMoney(0);
                                                      setPr(0);
                                                    }}
                                                  >
                                                    Reset
                                                  </button>
                                                  <button
                                                    style={{
                                                      background:
                                                        themeColors[
                                                          "--bg-success"
                                                        ],
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() =>
                                                      handleSubmit()
                                                    }
                                                  >
                                                    Submit
                                                  </button>
                                                </div>
                                              </div>
                                            </>
                                          )}

                                        {/* lay */}
                                        {fancymarket === index &&
                                          selectedBet === 9 && (
                                            <>
                                              <div
                                                className="m-0 mt-1 px-2 py-1 bett"
                                                style={{
                                                  background:
                                                    themeColors[
                                                      "--bg-secondary"
                                                    ],
                                                  color:
                                                    themeColors[
                                                      "--dark-theme-color"
                                                    ],
                                                }}
                                              >
                                                PlaceW Bet
                                              </div>
                                              <div
                                                style={{
                                                  backgroundColor: "#72bbef",
                                                  color:
                                                    themeColors[
                                                      "--dark-theme-color-navbar"
                                                    ],
                                                  width: "100%",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent:
                                                      "space-between",
                                                    alignItems: "center",
                                                  }}
                                                ></div>

                                                <table
                                                  style={{ width: "100%" }}
                                                >
                                                  <thead
                                                    style={{
                                                      backgroundColor:
                                                        themeColors[
                                                          "--bg-sidebar"
                                                        ],
                                                    }}
                                                  >
                                                    <tr>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        {" "}
                                                        (Bet for){" "}
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        Odds
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        Stake
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div>Profit:</div>
                                                      </td>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    <tr
                                                      style={{
                                                        borderBottom:
                                                          "1px solid var(--table-border) !important",
                                                      }}
                                                    >
                                                      <td
                                                        style={{
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            paddingLeft: "5px",
                                                            color:
                                                              themeColors[
                                                                "--text-body"
                                                              ],
                                                            fontWeight: "bold",
                                                          }}
                                                        >
                                                          {selectFancy}
                                                        </div>
                                                      </td>
                                                      <td
                                                        style={{
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "24px",
                                                            paddingLeft: "5px",
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            value={
                                                              selectedMarket
                                                            }
                                                            onChange={(e) =>
                                                              setSelectedMarket(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                themeColors[
                                                                  "--dark-theme-color-navbar"
                                                                ],
                                                              color:
                                                                themeColors[
                                                                  "--dark-theme-white-color"
                                                                ],
                                                              border: "none",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "12px",
                                                              width: "27px",
                                                            }}
                                                          />
                                                          <div>
                                                            <button
                                                              style={{
                                                                backgroundColor:
                                                                  themeColors[
                                                                    "--bg-sidebar"
                                                                  ],
                                                                color:
                                                                  themeColors[
                                                                    "--text-body"
                                                                  ],
                                                                width: "20px",
                                                                border: "none",
                                                                fontSize:
                                                                  "10px",
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                justifyContent:
                                                                  "center",
                                                              }}
                                                              onClick={() =>
                                                                handlefancyChange(
                                                                  0
                                                                )
                                                              }
                                                            >
                                                              <IoIosArrowUp />
                                                            </button>
                                                            <button
                                                              style={{
                                                                backgroundColor:
                                                                  themeColors[
                                                                    "--bg-sidebar"
                                                                  ],
                                                                color:
                                                                  themeColors[
                                                                    "--text-body"
                                                                  ],
                                                                width: "20px",
                                                                border: "none",
                                                                fontSize:
                                                                  "10px",
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                justifyContent:
                                                                  "center",
                                                              }}
                                                              onClick={() =>
                                                                handlefancyChange(
                                                                  1
                                                                )
                                                              }
                                                            >
                                                              <IoIosArrowDown />
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </td>
                                                      <td>
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "24px",
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            value={money}
                                                            onChange={(e) =>
                                                              setMoney(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                themeColors[
                                                                  "--dark-theme-color-navbar"
                                                                ],
                                                              color:
                                                                themeColors[
                                                                  "--dark-theme-white-color"
                                                                ],
                                                              border: "none",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "13px",
                                                              width: "32px",
                                                            }}
                                                          />
                                                        </div>
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            paddingRight: "5px",
                                                            color:
                                                              themeColors[
                                                                "--text-body"
                                                              ],
                                                            fontWeight: "bold",
                                                          }}
                                                        >
                                                          {(money * 2).toFixed(
                                                            1
                                                          )}
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>

                                                <div
                                                  style={{
                                                    display: "grid",
                                                    paddingLeft: "5px",
                                                    paddingRight: "5px",
                                                    gridTemplateColumns:
                                                      "repeat(5, 1fr)",
                                                    gap: "2px",
                                                    marginBottom: "2px",
                                                  }}
                                                >
                                                  {gameButtons.map((btn) => (
                                                    <button
                                                      key={btn.id}
                                                      className="homebet_set"
                                                      style={{
                                                        color:
                                                          themeColors[
                                                            "--text-sidebar"
                                                          ],
                                                        padding: "5px 0",
                                                        border: "none",
                                                        fontWeight: "bold",
                                                      }}
                                                      onClick={() =>
                                                        setMoney(btn.value)
                                                      }
                                                    >
                                                      + {btn.label}
                                                    </button>
                                                  ))}
                                                </div>

                                                <div
                                                  style={{
                                                    display: "grid",
                                                    padding: "2px 5px 4px 5px",
                                                    gridTemplateColumns:
                                                      "repeat(4, 1fr)",
                                                    marginBottom: "8px",
                                                  }}
                                                >
                                                  <button
                                                    style={{
                                                      backgroundColor:
                                                        "transparent",
                                                      color: "#0d6efd",
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() => {
                                                      setMoney(0);
                                                      setPr(0);
                                                    }}
                                                  >
                                                    Clear
                                                  </button>
                                                  <button
                                                    style={{
                                                      backgroundColor:
                                                        themeColors[
                                                          "--bg-info"
                                                        ],
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() => {
                                                      handleShowV();
                                                    }}
                                                  >
                                                    Edit
                                                  </button>

                                                  <button
                                                    style={{
                                                      background:
                                                        themeColors[
                                                          "--bg-danger"
                                                        ],
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() => {
                                                      setbackActive(0);
                                                      setSelectedBet(0);
                                                      setlayActive(3);
                                                      setMoney(0);
                                                      setPr(0);
                                                    }}
                                                  >
                                                    Reset
                                                  </button>
                                                  <button
                                                    style={{
                                                      background:
                                                        themeColors[
                                                          "--bg-success"
                                                        ],
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() =>
                                                      handleSubmit3()
                                                    }
                                                  >
                                                    Submit
                                                  </button>
                                                </div>
                                              </div>
                                            </>
                                          )}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            ) : (
                              <p className="text-white"></p>
                            )}
                            {/* /WP Market */}

                            {/* ODD/EVEN */}
                            {Array.isArray(oddEven) &&
                            oddEven.length > 0 &&
                            (newactive === 0 || newactive === 3) ? (
                              <div className="align-items-baseline w-100 mt-0">
                                {isExpanded6 === 1 && (
                                  <div className="w-100">
                                    {/* Map through wpMarket */}
                                    {oddEven.map((item, index) => (
                                      <div key={index} className="w-100">
                                        {/* back */}
                                        {fancyOdd === index &&
                                          selectedBet === 12 && (
                                            <>
                                              <div
                                                className="m-0 mt-1 px-2 py-1 bett"
                                                style={{
                                                  background:
                                                    themeColors[
                                                      "--bg-secondary"
                                                    ],
                                                  color:
                                                    themeColors[
                                                      "--dark-theme-color"
                                                    ],
                                                }}
                                              >
                                                PlaceW Bet
                                              </div>
                                              <div
                                                style={{
                                                  backgroundColor: "#faa9ba",
                                                  color:
                                                    themeColors[
                                                      "--dark-theme-color-navbar"
                                                    ],
                                                  width: "100%",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent:
                                                      "space-between",
                                                    alignItems: "center",
                                                  }}
                                                ></div>

                                                <table
                                                  style={{ width: "100%" }}
                                                >
                                                  <thead
                                                    style={{
                                                      backgroundColor:
                                                        themeColors[
                                                          "--bg-sidebar"
                                                        ],
                                                    }}
                                                  >
                                                    <tr>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        {" "}
                                                        (Bet for){" "}
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        Odds
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        Stake
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div>Profit:</div>
                                                      </td>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    <tr
                                                      style={{
                                                        borderBottom:
                                                          "1px solid var(--table-border) !important",
                                                      }}
                                                    >
                                                      <td
                                                        style={{
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            paddingLeft: "5px",
                                                            color:
                                                              themeColors[
                                                                "--text-body"
                                                              ],
                                                            fontWeight: "bold",
                                                          }}
                                                        >
                                                          {selectFancy}
                                                        </div>
                                                      </td>
                                                      <td
                                                        style={{
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "24px",
                                                            paddingLeft: "5px",
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            value={
                                                              selectedMarket
                                                            }
                                                            onChange={(e) =>
                                                              setSelectedMarket(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                themeColors[
                                                                  "--dark-theme-color-navbar"
                                                                ],
                                                              color:
                                                                themeColors[
                                                                  "--dark-theme-white-color"
                                                                ],
                                                              border: "none",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "12px",
                                                              width: "27px",
                                                            }}
                                                          />
                                                          <div>
                                                            <button
                                                              style={{
                                                                backgroundColor:
                                                                  themeColors[
                                                                    "--bg-sidebar"
                                                                  ],
                                                                color:
                                                                  themeColors[
                                                                    "--text-body"
                                                                  ],
                                                                width: "20px",
                                                                border: "none",
                                                                fontSize:
                                                                  "10px",
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                justifyContent:
                                                                  "center",
                                                              }}
                                                              onClick={() =>
                                                                handlefancyChange(
                                                                  0
                                                                )
                                                              }
                                                            >
                                                              <IoIosArrowUp />
                                                            </button>
                                                            <button
                                                              style={{
                                                                backgroundColor:
                                                                  themeColors[
                                                                    "--bg-sidebar"
                                                                  ],
                                                                color:
                                                                  themeColors[
                                                                    "--text-body"
                                                                  ],
                                                                width: "20px",
                                                                border: "none",
                                                                fontSize:
                                                                  "10px",
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                justifyContent:
                                                                  "center",
                                                              }}
                                                              onClick={() =>
                                                                handlefancyChange(
                                                                  1
                                                                )
                                                              }
                                                            >
                                                              <IoIosArrowDown />
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </td>
                                                      <td>
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "24px",
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            value={money}
                                                            onChange={(e) =>
                                                              setMoney(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                themeColors[
                                                                  "--dark-theme-color-navbar"
                                                                ],
                                                              color:
                                                                themeColors[
                                                                  "--dark-theme-white-color"
                                                                ],
                                                              border: "none",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "13px",
                                                              width: "32px",
                                                            }}
                                                          />
                                                        </div>
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            paddingRight: "5px",
                                                            color:
                                                              themeColors[
                                                                "--text-body"
                                                              ],
                                                            fontWeight: "bold",
                                                          }}
                                                        >
                                                          {(money * 2).toFixed(
                                                            1
                                                          )}
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>

                                                <div
                                                  style={{
                                                    display: "grid",
                                                    paddingLeft: "5px",
                                                    paddingRight: "5px",
                                                    gridTemplateColumns:
                                                      "repeat(5, 1fr)",
                                                    gap: "2px",
                                                    marginBottom: "2px",
                                                  }}
                                                >
                                                  {gameButtons.map((btn) => (
                                                    <button
                                                      key={btn.id}
                                                      className="homebet_set"
                                                      style={{
                                                        color:
                                                          themeColors[
                                                            "--text-sidebar"
                                                          ],
                                                        padding: "5px 0",
                                                        border: "none",
                                                        fontWeight: "bold",
                                                      }}
                                                      onClick={() =>
                                                        setMoney(btn.value)
                                                      }
                                                    >
                                                      + {btn.label}
                                                    </button>
                                                  ))}
                                                </div>

                                                <div
                                                  style={{
                                                    display: "grid",
                                                    padding: "2px 5px 4px 5px",
                                                    gridTemplateColumns:
                                                      "repeat(4, 1fr)",
                                                    marginBottom: "8px",
                                                  }}
                                                >
                                                  <button
                                                    style={{
                                                      backgroundColor:
                                                        "transparent",
                                                      color: "#0d6efd",
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() => {
                                                      setMoney(0);
                                                      setPr(0);
                                                    }}
                                                  >
                                                    Clear
                                                  </button>
                                                  <button
                                                    style={{
                                                      backgroundColor:
                                                        themeColors[
                                                          "--bg-info"
                                                        ],
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() => {
                                                      handleShowV();
                                                    }}
                                                  >
                                                    Edit
                                                  </button>

                                                  <button
                                                    style={{
                                                      background:
                                                        themeColors[
                                                          "--bg-danger"
                                                        ],
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() => {
                                                      setbackActive(0);
                                                      setSelectedBet(0);
                                                      setlayActive(3);
                                                      setMoney(0);
                                                      setPr(0);
                                                    }}
                                                  >
                                                    Reset
                                                  </button>
                                                  <button
                                                    style={{
                                                      background:
                                                        themeColors[
                                                          "--bg-success"
                                                        ],
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() =>
                                                      handleSubmit()
                                                    }
                                                  >
                                                    Submit
                                                  </button>
                                                </div>
                                              </div>
                                            </>
                                          )}

                                        {/* lay */}
                                        {fancyOdd === index &&
                                          selectedBet === 11 && (
                                            <>
                                              <div
                                                className="m-0 mt-1 px-2 py-1 bett"
                                                style={{
                                                  background:
                                                    themeColors[
                                                      "--bg-secondary"
                                                    ],
                                                  color:
                                                    themeColors[
                                                      "--dark-theme-color"
                                                    ],
                                                }}
                                              >
                                                PlaceW Bet
                                              </div>
                                              <div
                                                style={{
                                                  backgroundColor: "#72bbef",
                                                  color:
                                                    themeColors[
                                                      "--dark-theme-color-navbar"
                                                    ],
                                                  width: "100%",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent:
                                                      "space-between",
                                                    alignItems: "center",
                                                  }}
                                                ></div>

                                                <table
                                                  style={{ width: "100%" }}
                                                >
                                                  <thead
                                                    style={{
                                                      backgroundColor:
                                                        themeColors[
                                                          "--bg-sidebar"
                                                        ],
                                                    }}
                                                  >
                                                    <tr>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        {" "}
                                                        (Bet for){" "}
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        Odds
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        Stake
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div>Profit:</div>
                                                      </td>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    <tr
                                                      style={{
                                                        borderBottom:
                                                          "1px solid var(--table-border) !important",
                                                      }}
                                                    >
                                                      <td
                                                        style={{
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            paddingLeft: "5px",
                                                            color:
                                                              themeColors[
                                                                "--text-body"
                                                              ],
                                                            fontWeight: "bold",
                                                          }}
                                                        >
                                                          {selectFancy}
                                                        </div>
                                                      </td>
                                                      <td
                                                        style={{
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "24px",
                                                            paddingLeft: "5px",
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            value={
                                                              selectedMarket
                                                            }
                                                            onChange={(e) =>
                                                              setSelectedMarket(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                themeColors[
                                                                  "--dark-theme-color-navbar"
                                                                ],
                                                              color:
                                                                themeColors[
                                                                  "--dark-theme-white-color"
                                                                ],
                                                              border: "none",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "12px",
                                                              width: "27px",
                                                            }}
                                                          />
                                                          <div>
                                                            <button
                                                              style={{
                                                                backgroundColor:
                                                                  themeColors[
                                                                    "--bg-sidebar"
                                                                  ],
                                                                color:
                                                                  themeColors[
                                                                    "--text-body"
                                                                  ],
                                                                width: "20px",
                                                                border: "none",
                                                                fontSize:
                                                                  "10px",
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                justifyContent:
                                                                  "center",
                                                              }}
                                                              onClick={() =>
                                                                handlefancyChange(
                                                                  1
                                                                )
                                                              }
                                                            >
                                                              <IoIosArrowUp />
                                                            </button>
                                                            <button
                                                              style={{
                                                                backgroundColor:
                                                                  themeColors[
                                                                    "--bg-sidebar"
                                                                  ],
                                                                color:
                                                                  themeColors[
                                                                    "--text-body"
                                                                  ],
                                                                width: "20px",
                                                                border: "none",
                                                                fontSize:
                                                                  "10px",
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                justifyContent:
                                                                  "center",
                                                              }}
                                                              onClick={() =>
                                                                handlefancyChange(
                                                                  0
                                                                )
                                                              }
                                                            >
                                                              <IoIosArrowDown />
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </td>
                                                      <td>
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "24px",
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            value={money}
                                                            onChange={(e) =>
                                                              setMoney(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                themeColors[
                                                                  "--dark-theme-color-navbar"
                                                                ],
                                                              color:
                                                                themeColors[
                                                                  "--dark-theme-white-color"
                                                                ],
                                                              border: "none",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "13px",
                                                              width: "32px",
                                                            }}
                                                          />
                                                        </div>
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            paddingRight: "5px",
                                                            color:
                                                              themeColors[
                                                                "--text-body"
                                                              ],
                                                            fontWeight: "bold",
                                                          }}
                                                        >
                                                          {(money * 2).toFixed(
                                                            1
                                                          )}
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>

                                                <div
                                                  style={{
                                                    display: "grid",
                                                    paddingLeft: "5px",
                                                    paddingRight: "5px",
                                                    gridTemplateColumns:
                                                      "repeat(5, 1fr)",
                                                    gap: "2px",
                                                    marginBottom: "2px",
                                                  }}
                                                >
                                                  {gameButtons.map((btn) => (
                                                    <button
                                                      key={btn.id}
                                                      className="homebet_set"
                                                      style={{
                                                        color:
                                                          themeColors[
                                                            "--text-sidebar"
                                                          ],
                                                        padding: "5px 0",
                                                        border: "none",
                                                        fontWeight: "bold",
                                                      }}
                                                      onClick={() =>
                                                        setMoney(btn.value)
                                                      }
                                                    >
                                                      + {btn.label}
                                                    </button>
                                                  ))}
                                                </div>

                                                <div
                                                  style={{
                                                    display: "grid",
                                                    padding: "2px 5px 4px 5px",
                                                    gridTemplateColumns:
                                                      "repeat(4, 1fr)",
                                                    marginBottom: "8px",
                                                  }}
                                                >
                                                  <button
                                                    style={{
                                                      backgroundColor:
                                                        "transparent",
                                                      color: "#0d6efd",
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() => {
                                                      setMoney(0);
                                                      setPr(0);
                                                    }}
                                                  >
                                                    Clear
                                                  </button>
                                                  <button
                                                    style={{
                                                      backgroundColor:
                                                        themeColors[
                                                          "--bg-info"
                                                        ],
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() => {
                                                      handleShowV();
                                                    }}
                                                  >
                                                    Edit
                                                  </button>

                                                  <button
                                                    style={{
                                                      background:
                                                        themeColors[
                                                          "--bg-danger"
                                                        ],
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() => {
                                                      setbackActive(0);
                                                      setSelectedBet(0);
                                                      setlayActive(3);
                                                      setMoney(0);
                                                      setPr(0);
                                                    }}
                                                  >
                                                    Reset
                                                  </button>
                                                  <button
                                                    style={{
                                                      background:
                                                        themeColors[
                                                          "--bg-success"
                                                        ],
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() =>
                                                      handleSubmit3()
                                                    }
                                                  >
                                                    Submit
                                                  </button>
                                                </div>
                                              </div>
                                            </>
                                          )}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            ) : (
                              <p className="text-white"></p>
                            )}
                            {/* /ODD/EVEN */}

                            {/* XTRA */}
                            {Array.isArray(fancy) &&
                            fancy.length > 0 &&
                            (newactive === 0 || newactive === 4) ? (
                              <div className="align-items-baseline w-100">
                                {isExpanded5 === 1 && (
                                  <div className="w-100">
                                    {/* Map through wp Market */}
                                    {fancy.map((item, index) => (
                                      <div key={index} className="w-100">
                                        {/* fancy betting back div */}
                                        {fancyXtra === index &&
                                          selectedBet === 14 && (
                                            <>
                                              <div
                                                className="m-0 mt-1 px-2 py-1 bett"
                                                style={{
                                                  background:
                                                    themeColors[
                                                      "--bg-secondary"
                                                    ],
                                                  color:
                                                    themeColors[
                                                      "--dark-theme-color"
                                                    ],
                                                }}
                                              >
                                                PlaceW Bet
                                              </div>
                                              <div
                                                style={{
                                                  backgroundColor: "#faa9ba",
                                                  color:
                                                    themeColors[
                                                      "--dark-theme-color-navbar"
                                                    ],
                                                  width: "100%",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent:
                                                      "space-between",
                                                    alignItems: "center",
                                                  }}
                                                ></div>

                                                <table
                                                  style={{ width: "100%" }}
                                                >
                                                  <thead
                                                    style={{
                                                      backgroundColor:
                                                        themeColors[
                                                          "--bg-sidebar"
                                                        ],
                                                    }}
                                                  >
                                                    <tr>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        {" "}
                                                        (Bet for){" "}
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        Odds
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        Stake
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div>Profit:</div>
                                                      </td>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    <tr
                                                      style={{
                                                        borderBottom:
                                                          "1px solid var(--table-border) !important",
                                                      }}
                                                    >
                                                      <td
                                                        style={{
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            paddingLeft: "5px",
                                                            color:
                                                              themeColors[
                                                                "--text-body"
                                                              ],
                                                            fontWeight: "bold",
                                                          }}
                                                        >
                                                          {selectFancy}
                                                        </div>
                                                      </td>
                                                      <td
                                                        style={{
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "24px",
                                                            paddingLeft: "5px",
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            value={
                                                              selectedMarket
                                                            }
                                                            onChange={(e) =>
                                                              setSelectedMarket(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                themeColors[
                                                                  "--dark-theme-color-navbar"
                                                                ],
                                                              color:
                                                                themeColors[
                                                                  "--dark-theme-white-color"
                                                                ],
                                                              border: "none",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "12px",
                                                              width: "27px",
                                                            }}
                                                          />
                                                          <div>
                                                            <button
                                                              style={{
                                                                backgroundColor:
                                                                  themeColors[
                                                                    "--bg-sidebar"
                                                                  ],
                                                                color:
                                                                  themeColors[
                                                                    "--text-body"
                                                                  ],
                                                                width: "20px",
                                                                border: "none",
                                                                fontSize:
                                                                  "10px",
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                justifyContent:
                                                                  "center",
                                                              }}
                                                              onClick={() =>
                                                                handlefancyChange(
                                                                  0
                                                                )
                                                              }
                                                            >
                                                              <IoIosArrowUp />
                                                            </button>
                                                            <button
                                                              style={{
                                                                backgroundColor:
                                                                  themeColors[
                                                                    "--bg-sidebar"
                                                                  ],
                                                                color:
                                                                  themeColors[
                                                                    "--text-body"
                                                                  ],
                                                                width: "20px",
                                                                border: "none",
                                                                fontSize:
                                                                  "10px",
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                justifyContent:
                                                                  "center",
                                                              }}
                                                              onClick={() =>
                                                                handlefancyChange(
                                                                  1
                                                                )
                                                              }
                                                            >
                                                              <IoIosArrowDown />
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </td>
                                                      <td>
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "24px",
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            value={money}
                                                            onChange={(e) =>
                                                              setMoney(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                themeColors[
                                                                  "--dark-theme-color-navbar"
                                                                ],
                                                              color:
                                                                themeColors[
                                                                  "--dark-theme-white-color"
                                                                ],
                                                              border: "none",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "13px",
                                                              width: "32px",
                                                            }}
                                                          />
                                                        </div>
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            paddingRight: "5px",
                                                            color:
                                                              themeColors[
                                                                "--text-body"
                                                              ],
                                                            fontWeight: "bold",
                                                          }}
                                                        >
                                                          {(money * 2).toFixed(
                                                            1
                                                          )}
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>

                                                <div
                                                  style={{
                                                    display: "grid",
                                                    paddingLeft: "5px",
                                                    paddingRight: "5px",
                                                    gridTemplateColumns:
                                                      "repeat(5, 1fr)",
                                                    gap: "2px",
                                                    marginBottom: "2px",
                                                  }}
                                                >
                                                  {gameButtons.map((btn) => (
                                                    <button
                                                      key={btn.id}
                                                      className="homebet_set"
                                                      style={{
                                                        color:
                                                          themeColors[
                                                            "--text-sidebar"
                                                          ],
                                                        padding: "5px 0",
                                                        border: "none",
                                                        fontWeight: "bold",
                                                      }}
                                                      onClick={() =>
                                                        setMoney(btn.value)
                                                      }
                                                    >
                                                      + {btn.label}
                                                    </button>
                                                  ))}
                                                </div>

                                                <div
                                                  style={{
                                                    display: "grid",
                                                    padding: "2px 5px 4px 5px",
                                                    gridTemplateColumns:
                                                      "repeat(4, 1fr)",
                                                    marginBottom: "8px",
                                                  }}
                                                >
                                                  <button
                                                    style={{
                                                      backgroundColor:
                                                        "transparent",
                                                      color: "#0d6efd",
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() => {
                                                      setMoney(0);
                                                      setPr(0);
                                                    }}
                                                  >
                                                    Clear
                                                  </button>
                                                  <button
                                                    style={{
                                                      backgroundColor:
                                                        themeColors[
                                                          "--bg-info"
                                                        ],
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() => {
                                                      handleShowV();
                                                    }}
                                                  >
                                                    Edit
                                                  </button>

                                                  <button
                                                    style={{
                                                      background:
                                                        themeColors[
                                                          "--bg-danger"
                                                        ],
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() => {
                                                      setbackActive(0);
                                                      setSelectedBet(0);
                                                      setlayActive(3);
                                                      setMoney(0);
                                                      setPr(0);
                                                    }}
                                                  >
                                                    Reset
                                                  </button>
                                                  <button
                                                    style={{
                                                      background:
                                                        themeColors[
                                                          "--bg-success"
                                                        ],
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() =>
                                                      handleSubmit3()
                                                    }
                                                  >
                                                    Submit
                                                  </button>
                                                </div>
                                              </div>
                                            </>
                                          )}

                                        {/* betting lay div */}
                                        {fancyXtra === index &&
                                          selectedBet === 13 && (
                                            <>
                                              <div
                                                className="m-0 mt-1 px-2 py-1 bett"
                                                style={{
                                                  background:
                                                    themeColors[
                                                      "--bg-secondary"
                                                    ],
                                                  color:
                                                    themeColors[
                                                      "--dark-theme-color"
                                                    ],
                                                }}
                                              >
                                                PlaceW Bet
                                              </div>
                                              <div
                                                style={{
                                                  backgroundColor: "#72bbef",
                                                  color:
                                                    themeColors[
                                                      "--dark-theme-color-navbar"
                                                    ],
                                                  width: "100%",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent:
                                                      "space-between",
                                                    alignItems: "center",
                                                  }}
                                                ></div>

                                                <table
                                                  style={{ width: "100%" }}
                                                >
                                                  <thead
                                                    style={{
                                                      backgroundColor:
                                                        themeColors[
                                                          "--bg-sidebar"
                                                        ],
                                                    }}
                                                  >
                                                    <tr>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        {" "}
                                                        (Bet for){" "}
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        Odds
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        Stake
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          color:
                                                            themeColors[
                                                              "--text-body"
                                                            ],
                                                          fontWeight: "bold",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div>Profit:</div>
                                                      </td>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    <tr
                                                      style={{
                                                        borderBottom:
                                                          "1px solid var(--table-border) !important",
                                                      }}
                                                    >
                                                      <td
                                                        style={{
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            paddingLeft: "5px",
                                                            color:
                                                              themeColors[
                                                                "--text-body"
                                                              ],
                                                            fontWeight: "bold",
                                                          }}
                                                        >
                                                          {selectFancy}
                                                        </div>
                                                      </td>
                                                      <td
                                                        style={{
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "24px",
                                                            paddingLeft: "5px",
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            value={
                                                              selectedMarket
                                                            }
                                                            onChange={(e) =>
                                                              setSelectedMarket(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                themeColors[
                                                                  "--dark-theme-color-navbar"
                                                                ],
                                                              color:
                                                                themeColors[
                                                                  "--dark-theme-white-color"
                                                                ],
                                                              border: "none",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "12px",
                                                              width: "27px",
                                                            }}
                                                          />
                                                          <div>
                                                            <button
                                                              style={{
                                                                backgroundColor:
                                                                  themeColors[
                                                                    "--bg-sidebar"
                                                                  ],
                                                                color:
                                                                  themeColors[
                                                                    "--text-body"
                                                                  ],
                                                                width: "20px",
                                                                border: "none",
                                                                fontSize:
                                                                  "10px",
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                justifyContent:
                                                                  "center",
                                                              }}
                                                              onClick={() =>
                                                                handlefancyChange(
                                                                  0
                                                                )
                                                              }
                                                            >
                                                              <IoIosArrowUp />
                                                            </button>
                                                            <button
                                                              style={{
                                                                backgroundColor:
                                                                  themeColors[
                                                                    "--bg-sidebar"
                                                                  ],
                                                                color:
                                                                  themeColors[
                                                                    "--text-body"
                                                                  ],
                                                                width: "20px",
                                                                border: "none",
                                                                fontSize:
                                                                  "10px",
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                justifyContent:
                                                                  "center",
                                                              }}
                                                              onClick={() =>
                                                                handlefancyChange(
                                                                  1
                                                                )
                                                              }
                                                            >
                                                              <IoIosArrowDown />
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </td>
                                                      <td>
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "24px",
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            value={money}
                                                            onChange={(e) =>
                                                              setMoney(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                themeColors[
                                                                  "--dark-theme-color-navbar"
                                                                ],
                                                              color:
                                                                themeColors[
                                                                  "--dark-theme-white-color"
                                                                ],
                                                              border: "none",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "13px",
                                                              width: "32px",
                                                            }}
                                                          />
                                                        </div>
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "center",
                                                          padding: "5px",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            paddingRight: "5px",
                                                            color:
                                                              themeColors[
                                                                "--text-body"
                                                              ],
                                                            fontWeight: "bold",
                                                          }}
                                                        >
                                                          {(money * 2).toFixed(
                                                            1
                                                          )}
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>

                                                <div
                                                  style={{
                                                    display: "grid",
                                                    paddingLeft: "5px",
                                                    paddingRight: "5px",
                                                    gridTemplateColumns:
                                                      "repeat(5, 1fr)",
                                                    gap: "2px",
                                                    marginBottom: "2px",
                                                  }}
                                                >
                                                  {gameButtons.map((btn) => (
                                                    <button
                                                      key={btn.id}
                                                      className="homebet_set"
                                                      style={{
                                                        color:
                                                          themeColors[
                                                            "--text-sidebar"
                                                          ],
                                                        padding: "5px 0",
                                                        border: "none",
                                                        fontWeight: "bold",
                                                      }}
                                                      onClick={() =>
                                                        setMoney(btn.value)
                                                      }
                                                    >
                                                      + {btn.label}
                                                    </button>
                                                  ))}
                                                </div>

                                                <div
                                                  style={{
                                                    display: "grid",
                                                    padding: "2px 5px 4px 5px",
                                                    gridTemplateColumns:
                                                      "repeat(4, 1fr)",
                                                    marginBottom: "8px",
                                                  }}
                                                >
                                                  <button
                                                    style={{
                                                      backgroundColor:
                                                        "transparent",
                                                      color: "#0d6efd",
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() => {
                                                      setMoney(0);
                                                      setPr(0);
                                                    }}
                                                  >
                                                    Clear
                                                  </button>
                                                  <button
                                                    style={{
                                                      backgroundColor:
                                                        themeColors[
                                                          "--bg-info"
                                                        ],
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() => {
                                                      handleShowV();
                                                    }}
                                                  >
                                                    Edit
                                                  </button>

                                                  <button
                                                    style={{
                                                      background:
                                                        themeColors[
                                                          "--bg-danger"
                                                        ],
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() => {
                                                      setbackActive(0);
                                                      setSelectedBet(0);
                                                      setlayActive(3);
                                                      setMoney(0);
                                                      setPr(0);
                                                    }}
                                                  >
                                                    Reset
                                                  </button>
                                                  <button
                                                    style={{
                                                      background:
                                                        themeColors[
                                                          "--bg-success"
                                                        ],
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      padding: "9px 0",
                                                      border: "none",
                                                      fontWeight: "bold",
                                                    }}
                                                    onClick={() =>
                                                      handleSubmit()
                                                    }
                                                  >
                                                    Submit
                                                  </button>
                                                </div>
                                              </div>
                                            </>
                                          )}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            ) : (
                              <p className="text-white"></p>
                            )}
                            {/* /XTRA */}
                          </div>
                        )}

                        {!isLargeScreen && (
                          <div
                            style={{
                              position: "sticky",
                              top: 0,
                              zIndex: 1000,
                            }}
                          >
                            {/* Match ODDS */}

                            {/* Back */}
                            {backActive !== 0 && (
                              <Offcanvas
                                show={show}
                                onHide={handleClose}
                                placement="top"
                                style={{
                                  height: "45vh",
                                  background: "transparent",
                                }}
                              >
                                <Offcanvas.Header
                                  closeButton
                                  style={{
                                    backgroundColor:
                                      themeColors["--bg-primary"],
                                    padding: "10px",
                                    color: themeColors["--text-primary"],
                                  }}
                                >
                                  <Offcanvas.Title className="my-0">
                                    Place Bet
                                  </Offcanvas.Title>
                                </Offcanvas.Header>
                                <Offcanvas.Body className="p-0">
                                  <>
                                    <div
                                      className="px-3"
                                      style={{
                                        backgroundColor: "#72bbef",
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        width: "100%",
                                      }}
                                    >
                                      <div
                                        style={{
                                          paddingTop: "5px",
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                        }}
                                      >
                                        <div className="text-dark">
                                          {runner}
                                        </div>
                                        <div className="text-dark">
                                          Profit:{" "}
                                          {(
                                            money *
                                            (selectedPrice - 1)
                                          ).toFixed(1)}
                                        </div>
                                      </div>
                                      <div
                                        className="row mx-1 py-2"
                                        style={{ backgroundColor: "#ffffff45" }}
                                      >
                                        <div className="col-lg-6 col-6 mb-0 px-1">
                                          <div>
                                            <h6 className="text-center my-0 text-dark">
                                              Odds
                                            </h6>
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "28px",
                                            }}
                                          >
                                            <button
                                              style={{
                                                backgroundColor:
                                                  "var(--bg-secondary)",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                width: "22px",
                                                border: "none",
                                                fontSize: "13px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "0px",
                                              }}
                                              onClick={() => handlelayChange(0)}
                                            >
                                              −
                                            </button>
                                            <input
                                              type="text"
                                              value={selectedPrice}
                                              onChange={(e) =>
                                                setSelectedPrice(e.target.value)
                                              }
                                              style={{
                                                backgroundColor: "#fff",
                                                color:
                                                  "var(--dark-theme-white-color)",
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "84px",
                                              }}
                                            />
                                            <button
                                              style={{
                                                backgroundColor:
                                                  "var(--bg-secondary)",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                width: "22px",
                                                border: "none",
                                                fontSize: "13px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "0px",
                                              }}
                                              onClick={() => handlelayChange(1)}
                                            >
                                              +
                                            </button>
                                          </div>
                                        </div>
                                        <div className="col-lg-6 col-6 mb-0 px-1">
                                          <div>
                                            <h6 className="text-center my-0 text-dark">
                                              Amount
                                            </h6>
                                          </div>

                                          <div
                                            style={{
                                              display: "flex",
                                              height: "28px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={money}
                                              onChange={(e) =>
                                                setMoney(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "1px solid black",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "32px",
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        style={{
                                          display: "grid",
                                          paddingLeft: "5px",
                                          paddingRight: "5px",
                                          gridTemplateColumns: "repeat(4, 1fr)",
                                          gap: "2px",
                                          marginBottom: "2px",
                                        }}
                                      >
                                        {gameButtons.map((btn) => (
                                          <button
                                            key={btn.id}
                                            className="homebet_setSm"
                                            style={{
                                              color:
                                                themeColors["--text-secondary"],
                                              padding: "5px 0",
                                              border: "none",
                                              fontWeight: "bold",
                                            }}
                                            onClick={() => setMoney(btn.value)}
                                          >
                                            + {btn.label}
                                          </button>
                                        ))}
                                      </div>

                                      <div
                                        style={{
                                          display: "grid",
                                          padding: "2px 5px 4px 5px",
                                          gridTemplateColumns: "repeat(4, 1fr)",
                                          marginBottom: "8px",
                                        }}
                                      >
                                        <button
                                          style={{
                                            backgroundColor: "transparent",
                                            color: "#0d6efd",
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            setMoney(0);
                                            setPr(0);
                                          }}
                                        >
                                          Clear
                                        </button>
                                        <button
                                          style={{
                                            backgroundColor:
                                              themeColors["--bg-info"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            handleShowV();
                                          }}
                                        >
                                          Edit
                                        </button>

                                        <button
                                          style={{
                                            background:
                                              themeColors["--bg-danger"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            setbackActive(0);
                                            setSelectedBet(0);
                                            setlayActive(3);
                                            setMoney(0);
                                            setPr(0);
                                          }}
                                        >
                                          Reset
                                        </button>
                                        <button
                                          style={{
                                            background:
                                              themeColors["--bg-success"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            handleSubmit();
                                            setbackActive(0);
                                          }}
                                        >
                                          Submit
                                        </button>
                                      </div>
                                    </div>
                                  </>
                                </Offcanvas.Body>
                              </Offcanvas>
                            )}
                            {/* lay */}
                            {layActive !== 3 && (
                              <Offcanvas
                                show={show}
                                onHide={handleClose}
                                placement="top"
                                style={{
                                  height: "45vh",
                                  background: "transparent",
                                }}
                              >
                                <Offcanvas.Header
                                  closeButton
                                  style={{
                                    backgroundColor:
                                      themeColors["--bg-primary"],
                                    padding: "10px",
                                    color: themeColors["--text-primary"],
                                  }}
                                >
                                  <Offcanvas.Title className="my-0">
                                    Place Bet
                                  </Offcanvas.Title>
                                </Offcanvas.Header>
                                <Offcanvas.Body className="p-0">
                                  <>
                                    <div
                                      className="px-3"
                                      style={{
                                        backgroundColor: "#faa9ba",
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        width: "100%",
                                      }}
                                    >
                                      <div
                                        style={{
                                          paddingTop: "5px",
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                        }}
                                      >
                                        <div className="text-dark">
                                          {runner}
                                        </div>
                                        <div className="text-dark">
                                          Profit:{" "}
                                          {(
                                            money *
                                            (selectedPrice - 1)
                                          ).toFixed(1)}
                                        </div>
                                      </div>
                                      <div
                                        className="row mx-1 py-2"
                                        style={{ backgroundColor: "#ffffff45" }}
                                      >
                                        <div className="col-lg-6 col-6 mb-0 px-1">
                                          <div>
                                            <h6 className="text-center my-0 text-dark">
                                              Odds
                                            </h6>
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "28px",
                                            }}
                                          >
                                            <button
                                              style={{
                                                backgroundColor:
                                                  "var(--bg-secondary)",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                width: "22px",
                                                border: "none",
                                                fontSize: "13px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "0px",
                                              }}
                                              onClick={() => handlelayChange(0)}
                                            >
                                              −
                                            </button>
                                            <input
                                              type="text"
                                              value={selectedPrice}
                                              onChange={(e) =>
                                                setSelectedPrice(e.target.value)
                                              }
                                              style={{
                                                backgroundColor: "#fff",
                                                color:
                                                  "var(--dark-theme-white-color)",
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "84px",
                                              }}
                                            />
                                            <button
                                              style={{
                                                backgroundColor:
                                                  "var(--bg-secondary)",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                width: "22px",
                                                border: "none",
                                                fontSize: "13px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "0px",
                                              }}
                                              onClick={() => handlelayChange(1)}
                                            >
                                              +
                                            </button>
                                          </div>
                                        </div>
                                        <div className="col-lg-6 col-6 mb-0 px-1">
                                          <div>
                                            <h6 className="text-center my-0 text-dark">
                                              Amount
                                            </h6>
                                          </div>

                                          <div
                                            style={{
                                              display: "flex",
                                              height: "28px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={money}
                                              onChange={(e) =>
                                                setMoney(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "1px solid black",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "32px",
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        style={{
                                          display: "grid",
                                          paddingLeft: "5px",
                                          paddingRight: "5px",
                                          gridTemplateColumns: "repeat(5, 1fr)",
                                          gap: "2px",
                                          marginBottom: "2px",
                                        }}
                                      >
                                        {gameButtons.map((btn) => (
                                          <button
                                            key={btn.id}
                                            className="homebet_setSm"
                                            style={{
                                              color:
                                                themeColors["--text-secondary"],
                                              padding: "5px 0",
                                              border: "none",
                                              fontWeight: "bold",
                                            }}
                                            onClick={() => setMoney(btn.value)}
                                          >
                                            + {btn.label}
                                          </button>
                                        ))}
                                      </div>

                                      <div
                                        style={{
                                          display: "grid",
                                          padding: "2px 5px 4px 5px",
                                          gridTemplateColumns: "repeat(4, 1fr)",
                                          marginBottom: "8px",
                                        }}
                                      >
                                        <button
                                          style={{
                                            backgroundColor: "transparent",
                                            color: "#0d6efd",
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            setMoney(0);
                                            setPr(0);
                                          }}
                                        >
                                          Clear
                                        </button>
                                        <button
                                          style={{
                                            backgroundColor:
                                              themeColors["--bg-info"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            handleShowV();
                                          }}
                                        >
                                          Edit
                                        </button>

                                        <button
                                          style={{
                                            background:
                                              themeColors["--bg-danger"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            setbackActive(0);
                                            setSelectedBet(0);
                                            setlayActive(3);
                                            setMoney(0);
                                            setPr(0);
                                          }}
                                        >
                                          Reset
                                        </button>
                                        <button
                                          style={{
                                            background:
                                              themeColors["--bg-success"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            handleSubmit();
                                            setlayActive(3);
                                          }}
                                        >
                                          Submit
                                        </button>
                                      </div>
                                    </div>
                                  </>
                                </Offcanvas.Body>
                              </Offcanvas>
                            )}

                            {/* /Match ODDS */}

                            {/* BookMaker */}

                            {/* back */}
                            {selectedBet === 3 && isExpanded === 1 && (
                              <Offcanvas
                                show={show}
                                onHide={handleClose}
                                placement="top"
                                style={{
                                  height: "45vh",
                                  background: "transparent",
                                }}
                              >
                                <Offcanvas.Header
                                  closeButton
                                  style={{
                                    backgroundColor:
                                      themeColors["--bg-primary"],
                                    padding: "10px",
                                    color: themeColors["--text-primary"],
                                  }}
                                >
                                  <Offcanvas.Title className="my-0">
                                    Place Bet
                                  </Offcanvas.Title>
                                </Offcanvas.Header>
                                <Offcanvas.Body className="p-0">
                                  <>
                                    <div
                                      className="px-3"
                                      style={{
                                        backgroundColor: "#72bbef",
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        width: "100%",
                                      }}
                                    >
                                      <div
                                        style={{
                                          paddingTop: "5px",
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                        }}
                                      >
                                        <div className="text-dark">
                                          {runner}
                                        </div>
                                        <div className="text-dark">
                                          Profit:{" "}
                                          {(
                                            money *
                                            (selectedPrice - 1)
                                          ).toFixed(1)}
                                        </div>
                                      </div>
                                      <div
                                        className="row mx-1 py-2"
                                        style={{ backgroundColor: "#ffffff45" }}
                                      >
                                        <div className="col-lg-6 col-6 mb-0 px-1">
                                          <div>
                                            <h6 className="text-center my-0 text-dark">
                                              Odds
                                            </h6>
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "28px",
                                            }}
                                          >
                                            <button
                                              style={{
                                                backgroundColor:
                                                  "var(--bg-secondary)",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                width: "22px",
                                                border: "none",
                                                fontSize: "13px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "0px",
                                              }}
                                              onClick={() => handlelayChange(0)}
                                            >
                                              −
                                            </button>
                                            <input
                                              type="text"
                                              value={selectedPrice}
                                              onChange={(e) =>
                                                setSelectedPrice(e.target.value)
                                              }
                                              style={{
                                                backgroundColor: "#fff",
                                                color:
                                                  "var(--dark-theme-white-color)",
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "84px",
                                              }}
                                            />
                                            <button
                                              style={{
                                                backgroundColor:
                                                  "var(--bg-secondary)",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                width: "22px",
                                                border: "none",
                                                fontSize: "13px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "0px",
                                              }}
                                              onClick={() => handlelayChange(1)}
                                            >
                                              +
                                            </button>
                                          </div>
                                        </div>
                                        <div className="col-lg-6 col-6 mb-0 px-1">
                                          <div>
                                            <h6 className="text-center my-0 text-dark">
                                              Amount
                                            </h6>
                                          </div>

                                          <div
                                            style={{
                                              display: "flex",
                                              height: "28px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={money}
                                              onChange={(e) =>
                                                setMoney(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "1px solid black",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "32px",
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        style={{
                                          display: "grid",
                                          paddingLeft: "5px",
                                          paddingRight: "5px",
                                          gridTemplateColumns: "repeat(4, 1fr)",
                                          gap: "2px",
                                          marginBottom: "2px",
                                        }}
                                      >
                                        {gameButtons.map((btn) => (
                                          <button
                                            key={btn.id}
                                            className="homebet_setSm"
                                            style={{
                                              color:
                                                themeColors["--text-secondary"],
                                              padding: "5px 0",
                                              border: "none",
                                              fontWeight: "bold",
                                            }}
                                            onClick={() => setMoney(btn.value)}
                                          >
                                            + {btn.label}
                                          </button>
                                        ))}
                                      </div>

                                      <div
                                        style={{
                                          display: "grid",
                                          padding: "2px 5px 4px 5px",
                                          gridTemplateColumns: "repeat(4, 1fr)",
                                          marginBottom: "8px",
                                        }}
                                      >
                                        <button
                                          style={{
                                            backgroundColor: "transparent",
                                            color: "#0d6efd",
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            setMoney(0);
                                            setPr(0);
                                          }}
                                        >
                                          Clear
                                        </button>
                                        <button
                                          style={{
                                            backgroundColor:
                                              themeColors["--bg-info"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            handleShowV();
                                          }}
                                        >
                                          Edit
                                        </button>

                                        <button
                                          style={{
                                            background:
                                              themeColors["--bg-danger"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            setbackActive(0);
                                            setSelectedBet(0);
                                            setlayActive(3);
                                            setMoney(0);
                                            setPr(0);
                                          }}
                                        >
                                          Reset
                                        </button>
                                        <button
                                          style={{
                                            background:
                                              themeColors["--bg-success"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            handleSubmit();
                                            setbackActive(0);
                                          }}
                                        >
                                          Submit
                                        </button>
                                      </div>
                                    </div>
                                  </>
                                </Offcanvas.Body>
                              </Offcanvas>
                            )}

                            {/* lay */}
                            {selectedBet === 4 && isExpanded === 1 && (
                              <Offcanvas
                                show={show}
                                onHide={handleClose}
                                placement="top"
                                style={{
                                  height: "45vh",
                                  background: "transparent",
                                }}
                              >
                                <Offcanvas.Header
                                  closeButton
                                  style={{
                                    backgroundColor:
                                      themeColors["--bg-primary"],
                                    padding: "10px",
                                    color: themeColors["--text-primary"],
                                  }}
                                >
                                  <Offcanvas.Title className="my-0">
                                    Place Bet
                                  </Offcanvas.Title>
                                </Offcanvas.Header>
                                <Offcanvas.Body className="p-0">
                                  <>
                                    <div
                                      className="px-3"
                                      style={{
                                        backgroundColor: "#faa9ba",
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        width: "100%",
                                      }}
                                    >
                                      <div
                                        style={{
                                          paddingTop: "5px",
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                        }}
                                      >
                                        <div className="text-dark">
                                          {runner}
                                        </div>
                                        <div className="text-dark">
                                          Profit:{" "}
                                          {(
                                            money *
                                            (selectedPrice - 1)
                                          ).toFixed(1)}
                                        </div>
                                      </div>
                                      <div
                                        className="row mx-1 py-2"
                                        style={{ backgroundColor: "#ffffff45" }}
                                      >
                                        <div className="col-lg-6 col-6 mb-0 px-1">
                                          <div>
                                            <h6 className="text-center my-0 text-dark">
                                              Odds
                                            </h6>
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "28px",
                                            }}
                                          >
                                            <button
                                              style={{
                                                backgroundColor:
                                                  "var(--bg-secondary)",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                width: "22px",
                                                border: "none",
                                                fontSize: "13px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "0px",
                                              }}
                                              onClick={() => handlelayChange(0)}
                                            >
                                              −
                                            </button>
                                            <input
                                              type="text"
                                              value={selectedPrice}
                                              onChange={(e) =>
                                                setSelectedPrice(e.target.value)
                                              }
                                              style={{
                                                backgroundColor: "#fff",
                                                color:
                                                  "var(--dark-theme-white-color)",
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "84px",
                                              }}
                                            />
                                            <button
                                              style={{
                                                backgroundColor:
                                                  "var(--bg-secondary)",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                width: "22px",
                                                border: "none",
                                                fontSize: "13px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "0px",
                                              }}
                                              onClick={() => handlelayChange(1)}
                                            >
                                              +
                                            </button>
                                          </div>
                                        </div>
                                        <div className="col-lg-6 col-6 mb-0 px-1">
                                          <div>
                                            <h6 className="text-center my-0 text-dark">
                                              Amount
                                            </h6>
                                          </div>

                                          <div
                                            style={{
                                              display: "flex",
                                              height: "28px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={money}
                                              onChange={(e) =>
                                                setMoney(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "1px solid black",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "32px",
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        style={{
                                          display: "grid",
                                          paddingLeft: "5px",
                                          paddingRight: "5px",
                                          gridTemplateColumns: "repeat(5, 1fr)",
                                          gap: "2px",
                                          marginBottom: "2px",
                                        }}
                                      >
                                        {gameButtons.map((btn) => (
                                          <button
                                            key={btn.id}
                                            className="homebet_setSm"
                                            style={{
                                              color:
                                                themeColors["--text-secondary"],
                                              padding: "5px 0",
                                              border: "none",
                                              fontWeight: "bold",
                                            }}
                                            onClick={() => setMoney(btn.value)}
                                          >
                                            + {btn.label}
                                          </button>
                                        ))}
                                      </div>

                                      <div
                                        style={{
                                          display: "grid",
                                          padding: "2px 5px 4px 5px",
                                          gridTemplateColumns: "repeat(4, 1fr)",
                                          marginBottom: "8px",
                                        }}
                                      >
                                        <button
                                          style={{
                                            backgroundColor: "transparent",
                                            color: "#0d6efd",
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            setMoney(0);
                                            setPr(0);
                                          }}
                                        >
                                          Clear
                                        </button>
                                        <button
                                          style={{
                                            backgroundColor:
                                              themeColors["--bg-info"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            handleShowV();
                                          }}
                                        >
                                          Edit
                                        </button>

                                        <button
                                          style={{
                                            background:
                                              themeColors["--bg-danger"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            setbackActive(0);
                                            setSelectedBet(0);
                                            setlayActive(3);
                                            setMoney(0);
                                            setPr(0);
                                          }}
                                        >
                                          Reset
                                        </button>
                                        <button
                                          style={{
                                            background:
                                              themeColors["--bg-success"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            handleSubmit();
                                            setSelectedBet(0);
                                          }}
                                        >
                                          Submit
                                        </button>
                                      </div>
                                    </div>
                                  </>
                                </Offcanvas.Body>
                              </Offcanvas>
                            )}

                            {/* /BookMaker */}

                            {/* Mini BookMaker */}

                            {/* back */}
                            {selectedBet === 7 && isExpanded1 === 1 && (
                              <Offcanvas
                                show={show}
                                onHide={handleClose}
                                placement="top"
                                style={{
                                  height: "45vh",
                                  background: "transparent",
                                }}
                              >
                                <Offcanvas.Header
                                  closeButton
                                  style={{
                                    backgroundColor:
                                      themeColors["--bg-primary"],
                                    padding: "10px",
                                    color: themeColors["--text-primary"],
                                  }}
                                >
                                  <Offcanvas.Title className="my-0">
                                    Place Bet
                                  </Offcanvas.Title>
                                </Offcanvas.Header>
                                <Offcanvas.Body className="p-0">
                                  <>
                                    <div
                                      className="px-3"
                                      style={{
                                        backgroundColor: "#72bbef",
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        width: "100%",
                                      }}
                                    >
                                      <div
                                        style={{
                                          paddingTop: "5px",
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                        }}
                                      >
                                        <div className="text-dark">
                                          {runner}
                                        </div>
                                        <div className="text-dark">
                                          Profit:{" "}
                                          {(
                                            money *
                                            (selectedPrice - 1)
                                          ).toFixed(1)}
                                        </div>
                                      </div>
                                      <div
                                        className="row mx-1 py-2"
                                        style={{ backgroundColor: "#ffffff45" }}
                                      >
                                        <div className="col-lg-6 col-6 mb-0 px-1">
                                          <div>
                                            <h6 className="text-center my-0 text-dark">
                                              Odds
                                            </h6>
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "28px",
                                            }}
                                          >
                                            <button
                                              style={{
                                                backgroundColor:
                                                  "var(--bg-secondary)",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                width: "22px",
                                                border: "none",
                                                fontSize: "13px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "0px",
                                              }}
                                              onClick={() => handlelayChange(0)}
                                            >
                                              −
                                            </button>
                                            <input
                                              type="text"
                                              value={selectedPrice}
                                              onChange={(e) =>
                                                setSelectedPrice(e.target.value)
                                              }
                                              style={{
                                                backgroundColor: "#fff",
                                                color:
                                                  "var(--dark-theme-white-color)",
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "84px",
                                              }}
                                            />
                                            <button
                                              style={{
                                                backgroundColor:
                                                  "var(--bg-secondary)",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                width: "22px",
                                                border: "none",
                                                fontSize: "13px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "0px",
                                              }}
                                              onClick={() => handlelayChange(1)}
                                            >
                                              +
                                            </button>
                                          </div>
                                        </div>
                                        <div className="col-lg-6 col-6 mb-0 px-1">
                                          <div>
                                            <h6 className="text-center my-0 text-dark">
                                              Amount
                                            </h6>
                                          </div>

                                          <div
                                            style={{
                                              display: "flex",
                                              height: "28px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={money}
                                              onChange={(e) =>
                                                setMoney(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "1px solid black",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "32px",
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        style={{
                                          display: "grid",
                                          paddingLeft: "5px",
                                          paddingRight: "5px",
                                          gridTemplateColumns: "repeat(4, 1fr)",
                                          gap: "2px",
                                          marginBottom: "2px",
                                        }}
                                      >
                                        {gameButtons.map((btn) => (
                                          <button
                                            key={btn.id}
                                            className="homebet_setSm"
                                            style={{
                                              color:
                                                themeColors["--text-secondary"],
                                              padding: "5px 0",
                                              border: "none",
                                              fontWeight: "bold",
                                            }}
                                            onClick={() => setMoney(btn.value)}
                                          >
                                            + {btn.label}
                                          </button>
                                        ))}
                                      </div>

                                      <div
                                        style={{
                                          display: "grid",
                                          padding: "2px 5px 4px 5px",
                                          gridTemplateColumns: "repeat(4, 1fr)",
                                          marginBottom: "8px",
                                        }}
                                      >
                                        <button
                                          style={{
                                            backgroundColor: "transparent",
                                            color: "#0d6efd",
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            setMoney(0);
                                            setPr(0);
                                          }}
                                        >
                                          Clear
                                        </button>
                                        <button
                                          style={{
                                            backgroundColor:
                                              themeColors["--bg-info"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            handleShowV();
                                          }}
                                        >
                                          Edit
                                        </button>

                                        <button
                                          style={{
                                            background:
                                              themeColors["--bg-danger"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            setbackActive(0);
                                            setSelectedBet(0);
                                            setlayActive(3);
                                            setMoney(0);
                                            setPr(0);
                                          }}
                                        >
                                          Reset
                                        </button>
                                        <button
                                          style={{
                                            background:
                                              themeColors["--bg-success"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => handleSubmit()}
                                        >
                                          Submit
                                        </button>
                                      </div>
                                    </div>
                                  </>
                                </Offcanvas.Body>
                              </Offcanvas>
                            )}

                            {/* lay */}
                            {selectedBet === 8 && isExpanded1 === 1 && (
                              <Offcanvas
                                show={show}
                                onHide={handleClose}
                                placement="top"
                                style={{
                                  height: "45vh",
                                  background: "transparent",
                                }}
                              >
                                <Offcanvas.Header
                                  closeButton
                                  style={{
                                    backgroundColor:
                                      themeColors["--bg-primary"],
                                    padding: "10px",
                                    color: themeColors["--text-primary"],
                                  }}
                                >
                                  <Offcanvas.Title className="my-0">
                                    Place Bet
                                  </Offcanvas.Title>
                                </Offcanvas.Header>
                                <Offcanvas.Body className="p-0">
                                  <>
                                    <div
                                      className="px-3"
                                      style={{
                                        backgroundColor: "#faa9ba",
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        width: "100%",
                                      }}
                                    >
                                      <div
                                        style={{
                                          paddingTop: "5px",
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                        }}
                                      >
                                        <div className="text-dark">
                                          {runner}
                                        </div>
                                        <div className="text-dark">
                                          Profit:{" "}
                                          {(
                                            money *
                                            (selectedPrice - 1)
                                          ).toFixed(1)}
                                        </div>
                                      </div>
                                      <div
                                        className="row mx-1 py-2"
                                        style={{ backgroundColor: "#ffffff45" }}
                                      >
                                        <div className="col-lg-6 col-6 mb-0 px-1">
                                          <div>
                                            <h6 className="text-center my-0 text-dark">
                                              Odds
                                            </h6>
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "28px",
                                            }}
                                          >
                                            <button
                                              style={{
                                                backgroundColor:
                                                  "var(--bg-secondary)",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                width: "22px",
                                                border: "none",
                                                fontSize: "13px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "0px",
                                              }}
                                              onClick={() => handlelayChange(0)}
                                            >
                                              −
                                            </button>
                                            <input
                                              type="text"
                                              value={selectedPrice}
                                              onChange={(e) =>
                                                setSelectedPrice(e.target.value)
                                              }
                                              style={{
                                                backgroundColor: "#fff",
                                                color:
                                                  "var(--dark-theme-white-color)",
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "84px",
                                              }}
                                            />
                                            <button
                                              style={{
                                                backgroundColor:
                                                  "var(--bg-secondary)",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                width: "22px",
                                                border: "none",
                                                fontSize: "13px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "0px",
                                              }}
                                              onClick={() => handlelayChange(1)}
                                            >
                                              +
                                            </button>
                                          </div>
                                        </div>
                                        <div className="col-lg-6 col-6 mb-0 px-1">
                                          <div>
                                            <h6 className="text-center my-0 text-dark">
                                              Amount
                                            </h6>
                                          </div>

                                          <div
                                            style={{
                                              display: "flex",
                                              height: "28px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={money}
                                              onChange={(e) =>
                                                setMoney(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "1px solid black",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "32px",
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        style={{
                                          display: "grid",
                                          paddingLeft: "5px",
                                          paddingRight: "5px",
                                          gridTemplateColumns: "repeat(5, 1fr)",
                                          gap: "2px",
                                          marginBottom: "2px",
                                        }}
                                      >
                                        {gameButtons.map((btn) => (
                                          <button
                                            key={btn.id}
                                            className="homebet_setSm"
                                            style={{
                                              color:
                                                themeColors["--text-secondary"],
                                              padding: "5px 0",
                                              border: "none",
                                              fontWeight: "bold",
                                            }}
                                            onClick={() => setMoney(btn.value)}
                                          >
                                            + {btn.label}
                                          </button>
                                        ))}
                                      </div>

                                      <div
                                        style={{
                                          display: "grid",
                                          padding: "2px 5px 4px 5px",
                                          gridTemplateColumns: "repeat(4, 1fr)",
                                          marginBottom: "8px",
                                        }}
                                      >
                                        <button
                                          style={{
                                            backgroundColor: "transparent",
                                            color: "#0d6efd",
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            setMoney(0);
                                            setPr(0);
                                          }}
                                        >
                                          Clear
                                        </button>
                                        <button
                                          style={{
                                            backgroundColor:
                                              themeColors["--bg-info"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            handleShowV();
                                          }}
                                        >
                                          Edit
                                        </button>

                                        <button
                                          style={{
                                            background:
                                              themeColors["--bg-danger"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            setbackActive(0);
                                            setSelectedBet(0);
                                            setlayActive(3);
                                            setMoney(0);
                                            setPr(0);
                                          }}
                                        >
                                          Reset
                                        </button>
                                        <button
                                          style={{
                                            background:
                                              themeColors["--bg-success"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => handleSubmit()}
                                        >
                                          Submit
                                        </button>
                                      </div>

                                      {/* <div
                                style={{
                                  display: "grid",
                                  padding: "5px",
                                  gridTemplateColumns: "repeat(2, 1fr)",
                                  gap: "8px",
                                }}
                              >
                              </div> */}
                                    </div>
                                  </>
                                </Offcanvas.Body>
                              </Offcanvas>
                            )}

                            {/* /Mini BookMaker */}

                            {/* Toss */}

                            {/* back */}
                            {selectedBet === 5 && isExpanded2 === 1 && (
                              <Offcanvas
                                show={show}
                                onHide={handleClose}
                                placement="top"
                                style={{
                                  height: "45vh",
                                  background: "transparent",
                                }}
                              >
                                <Offcanvas.Header
                                  closeButton
                                  style={{
                                    backgroundColor:
                                      themeColors["--bg-primary"],
                                    padding: "10px",
                                    color: themeColors["--text-primary"],
                                  }}
                                >
                                  <Offcanvas.Title className="my-0">
                                    Place Bet
                                  </Offcanvas.Title>
                                </Offcanvas.Header>
                                <Offcanvas.Body className="p-0">
                                  <>
                                    <div
                                      className="px-3"
                                      style={{
                                        backgroundColor: "#72bbef",
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        width: "100%",
                                      }}
                                    >
                                      <div
                                        style={{
                                          paddingTop: "5px",
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                        }}
                                      >
                                        <div className="text-dark">
                                          {runner}
                                        </div>
                                        <div className="text-dark">
                                          Profit:{" "}
                                          {(
                                            money *
                                            (selectedPrice - 1)
                                          ).toFixed(1)}
                                        </div>
                                      </div>
                                      <div
                                        className="row mx-1 py-2"
                                        style={{ backgroundColor: "#ffffff45" }}
                                      >
                                        <div className="col-lg-6 col-6 mb-0 px-1">
                                          <div>
                                            <h6 className="text-center my-0 text-dark">
                                              Odds
                                            </h6>
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "28px",
                                            }}
                                          >
                                            <button
                                              style={{
                                                backgroundColor:
                                                  "var(--bg-secondary)",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                width: "22px",
                                                border: "none",
                                                fontSize: "13px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "0px",
                                              }}
                                              onClick={() => handlelayChange(0)}
                                            >
                                              −
                                            </button>
                                            <input
                                              type="text"
                                              value={selectedPrice}
                                              onChange={(e) =>
                                                setSelectedPrice(e.target.value)
                                              }
                                              style={{
                                                backgroundColor: "#fff",
                                                color:
                                                  "var(--dark-theme-white-color)",
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "84px",
                                              }}
                                            />
                                            <button
                                              style={{
                                                backgroundColor:
                                                  "var(--bg-secondary)",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                width: "22px",
                                                border: "none",
                                                fontSize: "13px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "0px",
                                              }}
                                              onClick={() => handlelayChange(1)}
                                            >
                                              +
                                            </button>
                                          </div>
                                        </div>
                                        <div className="col-lg-6 col-6 mb-0 px-1">
                                          <div>
                                            <h6 className="text-center my-0 text-dark">
                                              Amount
                                            </h6>
                                          </div>

                                          <div
                                            style={{
                                              display: "flex",
                                              height: "28px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={money}
                                              onChange={(e) =>
                                                setMoney(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "1px solid black",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "32px",
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        style={{
                                          display: "grid",
                                          paddingLeft: "5px",
                                          paddingRight: "5px",
                                          gridTemplateColumns: "repeat(4, 1fr)",
                                          gap: "2px",
                                          marginBottom: "2px",
                                        }}
                                      >
                                        {gameButtons.map((btn) => (
                                          <button
                                            key={btn.id}
                                            className="homebet_setSm"
                                            style={{
                                              color:
                                                themeColors["--text-secondary"],
                                              padding: "5px 0",
                                              border: "none",
                                              fontWeight: "bold",
                                            }}
                                            onClick={() => setMoney(btn.value)}
                                          >
                                            + {btn.label}
                                          </button>
                                        ))}
                                      </div>

                                      <div
                                        style={{
                                          display: "grid",
                                          padding: "2px 5px 4px 5px",
                                          gridTemplateColumns: "repeat(4, 1fr)",
                                          marginBottom: "8px",
                                        }}
                                      >
                                        <button
                                          style={{
                                            backgroundColor: "transparent",
                                            color: "#0d6efd",
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            setMoney(0);
                                            setPr(0);
                                          }}
                                        >
                                          Clear
                                        </button>
                                        <button
                                          style={{
                                            backgroundColor:
                                              themeColors["--bg-info"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            handleShowV();
                                          }}
                                        >
                                          Edit
                                        </button>

                                        <button
                                          style={{
                                            background:
                                              themeColors["--bg-danger"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            setbackActive(0);
                                            setSelectedBet(0);
                                            setlayActive(3);
                                            setMoney(0);
                                            setPr(0);
                                          }}
                                        >
                                          Reset
                                        </button>
                                        <button
                                          style={{
                                            background:
                                              themeColors["--bg-success"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => handleSubmit()}
                                        >
                                          Submit
                                        </button>
                                      </div>
                                    </div>
                                  </>
                                </Offcanvas.Body>
                              </Offcanvas>
                            )}

                            {/* lay */}
                            {selectedBet === 6 && isExpanded2 === 1 && (
                              <Offcanvas
                                show={show}
                                onHide={handleClose}
                                placement="top"
                                style={{
                                  height: "45vh",
                                  background: "transparent",
                                }}
                              >
                                <Offcanvas.Header
                                  closeButton
                                  style={{
                                    backgroundColor:
                                      themeColors["--bg-primary"],
                                    padding: "10px",
                                    color: themeColors["--text-primary"],
                                  }}
                                >
                                  <Offcanvas.Title className="my-0">
                                    Place Bet
                                  </Offcanvas.Title>
                                </Offcanvas.Header>
                                <Offcanvas.Body className="p-0">
                                  <>
                                    <div
                                      className="px-3"
                                      style={{
                                        backgroundColor: "#faa9ba",
                                        color:
                                          themeColors[
                                            "--dark-theme-color-navbar"
                                          ],
                                        width: "100%",
                                      }}
                                    >
                                      <div
                                        style={{
                                          paddingTop: "5px",
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                        }}
                                      >
                                        <div className="text-dark">
                                          {runner}
                                        </div>
                                        <div className="text-dark">
                                          Profit:{" "}
                                          {(
                                            money *
                                            (selectedPrice - 1)
                                          ).toFixed(1)}
                                        </div>
                                      </div>
                                      <div
                                        className="row mx-1 py-2"
                                        style={{ backgroundColor: "#ffffff45" }}
                                      >
                                        <div className="col-lg-6 col-6 mb-0 px-1">
                                          <div>
                                            <h6 className="text-center my-0 text-dark">
                                              Odds
                                            </h6>
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              height: "28px",
                                            }}
                                          >
                                            <button
                                              style={{
                                                backgroundColor:
                                                  "var(--bg-secondary)",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                width: "22px",
                                                border: "none",
                                                fontSize: "13px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "0px",
                                              }}
                                              onClick={() => handlelayChange(0)}
                                            >
                                              −
                                            </button>
                                            <input
                                              type="text"
                                              value={selectedPrice}
                                              onChange={(e) =>
                                                setSelectedPrice(e.target.value)
                                              }
                                              style={{
                                                backgroundColor: "#fff",
                                                color:
                                                  "var(--dark-theme-white-color)",
                                                border: "none",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "84px",
                                              }}
                                            />
                                            <button
                                              style={{
                                                backgroundColor:
                                                  "var(--bg-secondary)",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                width: "22px",
                                                border: "none",
                                                fontSize: "13px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "0px",
                                              }}
                                              onClick={() => handlelayChange(1)}
                                            >
                                              +
                                            </button>
                                          </div>
                                        </div>
                                        <div className="col-lg-6 col-6 mb-0 px-1">
                                          <div>
                                            <h6 className="text-center my-0 text-dark">
                                              Amount
                                            </h6>
                                          </div>

                                          <div
                                            style={{
                                              display: "flex",
                                              height: "28px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              value={money}
                                              onChange={(e) =>
                                                setMoney(e.target.value)
                                              }
                                              style={{
                                                backgroundColor:
                                                  themeColors[
                                                    "--dark-theme-color-navbar"
                                                  ],
                                                color:
                                                  themeColors[
                                                    "--dark-theme-white-color"
                                                  ],
                                                border: "1px solid black",
                                                flex: 1,
                                                textAlign: "center",
                                                fontSize: "13px",
                                                width: "32px",
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        style={{
                                          display: "grid",
                                          paddingLeft: "5px",
                                          paddingRight: "5px",
                                          gridTemplateColumns: "repeat(5, 1fr)",
                                          gap: "2px",
                                          marginBottom: "2px",
                                        }}
                                      >
                                        {gameButtons.map((btn) => (
                                          <button
                                            key={btn.id}
                                            className="homebet_setSm"
                                            style={{
                                              color:
                                                themeColors["--text-secondary"],
                                              padding: "5px 0",
                                              border: "none",
                                              fontWeight: "bold",
                                            }}
                                            onClick={() => setMoney(btn.value)}
                                          >
                                            + {btn.label}
                                          </button>
                                        ))}
                                      </div>

                                      <div
                                        style={{
                                          display: "grid",
                                          padding: "2px 5px 4px 5px",
                                          gridTemplateColumns: "repeat(4, 1fr)",
                                          marginBottom: "8px",
                                        }}
                                      >
                                        <button
                                          style={{
                                            backgroundColor: "transparent",
                                            color: "#0d6efd",
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            setMoney(0);
                                            setPr(0);
                                          }}
                                        >
                                          Clear
                                        </button>
                                        <button
                                          style={{
                                            backgroundColor:
                                              themeColors["--bg-info"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            handleShowV();
                                          }}
                                        >
                                          Edit
                                        </button>

                                        <button
                                          style={{
                                            background:
                                              themeColors["--bg-danger"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            setbackActive(0);
                                            setSelectedBet(0);
                                            setlayActive(3);
                                            setMoney(0);
                                            setPr(0);
                                          }}
                                        >
                                          Reset
                                        </button>
                                        <button
                                          style={{
                                            background:
                                              themeColors["--bg-success"],
                                            color:
                                              themeColors[
                                                "--dark-theme-color-navbar"
                                              ],
                                            padding: "9px 0",
                                            border: "none",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => handleSubmit()}
                                        >
                                          Submit
                                        </button>
                                      </div>
                                    </div>
                                  </>
                                </Offcanvas.Body>
                              </Offcanvas>
                            )}

                            {/* /Toss */}

                            {/* Fancy Markets */}

                            {/* /Fancy Markets */}

                            {/* Session */}
                            {Array.isArray(session) &&
                            session.length > 0 &&
                            (newactive === 0 || newactive === 1) ? (
                              <div className="d-flex flex-column align-items-baseline w-100">
                                {isExpanded3 === 1 && (
                                  <div className="w-100">
                                    {session.map((item, index) => (
                                      <div key={index} className="w-100">
                                        {/* back */}
                                        {fancyBet === index &&
                                          selectedBet === 2 && (
                                            <Offcanvas
                                              show={show}
                                              onHide={handleClose}
                                              placement="top"
                                              style={{
                                                height: "45vh",
                                                background: "transparent",
                                              }}
                                            >
                                              <Offcanvas.Header
                                                closeButton
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-primary"],
                                                  padding: "10px",
                                                  color:
                                                    themeColors[
                                                      "--text-primary"
                                                    ],
                                                }}
                                              >
                                                <Offcanvas.Title className="my-0">
                                                  Place Bet
                                                </Offcanvas.Title>
                                              </Offcanvas.Header>
                                              <Offcanvas.Body className="p-0">
                                                <>
                                                  <div
                                                    className="px-3"
                                                    style={{
                                                      backgroundColor:
                                                        "#faa9ba",
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      width: "100%",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        paddingTop: "5px",
                                                        display: "flex",
                                                        justifyContent:
                                                          "space-between",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <div className="text-dark">
                                                        {selectFancy}
                                                      </div>
                                                      <div className="text-dark">
                                                        Profit:{" "}
                                                        {(
                                                          money *
                                                          (selectedPrice - 1)
                                                        ).toFixed(1)}
                                                      </div>
                                                    </div>
                                                    <div
                                                      className="row mx-1 py-2"
                                                      style={{
                                                        backgroundColor:
                                                          "#ffffff45",
                                                      }}
                                                    >
                                                      <div className="col-lg-6 col-6 mb-0 px-1">
                                                        <div>
                                                          <h6 className="text-center my-0 text-dark">
                                                            Odds
                                                          </h6>
                                                        </div>
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "28px",
                                                          }}
                                                        >
                                                          <button
                                                            style={{
                                                              backgroundColor:
                                                                "var(--bg-secondary)",
                                                              color:
                                                                "var(--dark-theme-color-navbar)",
                                                              width: "22px",
                                                              border: "none",
                                                              fontSize: "13px",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              justifyContent:
                                                                "center",
                                                              borderRadius:
                                                                "0px",
                                                            }}
                                                            onClick={() =>
                                                              handlefancyChange(
                                                                0
                                                              )
                                                            }
                                                          >
                                                            −
                                                          </button>
                                                          <input
                                                            type="text"
                                                            value={
                                                              selectedMarket
                                                            }
                                                            onChange={(e) =>
                                                              setSelectedMarket(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                "#fff",
                                                              color:
                                                                "var(--dark-theme-white-color)",
                                                              border: "none",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "13px",
                                                              width: "84px",
                                                            }}
                                                          />
                                                          <button
                                                            style={{
                                                              backgroundColor:
                                                                "var(--bg-secondary)",
                                                              color:
                                                                "var(--dark-theme-color-navbar)",
                                                              width: "22px",
                                                              border: "none",
                                                              fontSize: "13px",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              justifyContent:
                                                                "center",
                                                              borderRadius:
                                                                "0px",
                                                            }}
                                                            onClick={() =>
                                                              handlefancyChange(
                                                                1
                                                              )
                                                            }
                                                          >
                                                            +
                                                          </button>
                                                        </div>
                                                      </div>
                                                      <div className="col-lg-6 col-6 mb-0 px-1">
                                                        <div>
                                                          <h6 className="text-center my-0 text-dark">
                                                            Amount
                                                          </h6>
                                                        </div>

                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "28px",
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            value={money}
                                                            onChange={(e) =>
                                                              setMoney(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                themeColors[
                                                                  "--dark-theme-color-navbar"
                                                                ],
                                                              color:
                                                                themeColors[
                                                                  "--dark-theme-white-color"
                                                                ],
                                                              border:
                                                                "1px solid black",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "13px",
                                                              width: "32px",
                                                            }}
                                                          />
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div
                                                      style={{
                                                        display: "grid",
                                                        paddingLeft: "5px",
                                                        paddingRight: "5px",
                                                        gridTemplateColumns:
                                                          "repeat(4, 1fr)",
                                                        gap: "2px",
                                                        marginBottom: "2px",
                                                      }}
                                                    >
                                                      {gameButtons.map(
                                                        (btn) => (
                                                          <button
                                                            key={btn.id}
                                                            className="homebet_setSm"
                                                            style={{
                                                              color:
                                                                themeColors[
                                                                  "--text-secondary"
                                                                ],
                                                              padding: "5px 0",
                                                              border: "none",
                                                              fontWeight:
                                                                "bold",
                                                            }}
                                                            onClick={() =>
                                                              setMoney(
                                                                btn.value
                                                              )
                                                            }
                                                          >
                                                            + {btn.label}
                                                          </button>
                                                        )
                                                      )}
                                                    </div>

                                                    <div
                                                      style={{
                                                        display: "grid",
                                                        padding:
                                                          "2px 5px 4px 5px",
                                                        gridTemplateColumns:
                                                          "repeat(4, 1fr)",
                                                        marginBottom: "8px",
                                                      }}
                                                    >
                                                      <button
                                                        style={{
                                                          backgroundColor:
                                                            "transparent",
                                                          color: "#0d6efd",
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          setMoney(0);
                                                          setPr(0);
                                                        }}
                                                      >
                                                        Clear
                                                      </button>
                                                      <button
                                                        style={{
                                                          backgroundColor:
                                                            themeColors[
                                                              "--bg-info"
                                                            ],
                                                          color:
                                                            themeColors[
                                                              "--dark-theme-color-navbar"
                                                            ],
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          handleShowV();
                                                        }}
                                                      >
                                                        Edit
                                                      </button>

                                                      <button
                                                        style={{
                                                          background:
                                                            themeColors[
                                                              "--bg-danger"
                                                            ],
                                                          color:
                                                            themeColors[
                                                              "--dark-theme-color-navbar"
                                                            ],
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          setbackActive(0);
                                                          setSelectedBet(0);
                                                          setlayActive(3);
                                                          setMoney(0);
                                                          setPr(0);
                                                        }}
                                                      >
                                                        Reset
                                                      </button>
                                                      <button
                                                        style={{
                                                          background:
                                                            themeColors[
                                                              "--bg-success"
                                                            ],
                                                          color:
                                                            themeColors[
                                                              "--dark-theme-color-navbar"
                                                            ],
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          handleSubmit3();
                                                          setSelectedBet(0);
                                                        }}
                                                      >
                                                        Submit
                                                      </button>
                                                    </div>
                                                  </div>
                                                </>
                                              </Offcanvas.Body>
                                            </Offcanvas>
                                          )}

                                        {/* lay */}
                                        {fancyBet === index &&
                                          selectedBet === 1 && (
                                            <Offcanvas
                                              show={show}
                                              onHide={handleClose}
                                              placement="top"
                                              style={{
                                                height: "45vh",
                                                background: "transparent",
                                              }}
                                            >
                                              <Offcanvas.Header
                                                closeButton
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-primary"],
                                                  padding: "10px",
                                                  color:
                                                    themeColors[
                                                      "--text-primary"
                                                    ],
                                                }}
                                              >
                                                <Offcanvas.Title className="my-0">
                                                  Place Bet
                                                </Offcanvas.Title>
                                              </Offcanvas.Header>
                                              <Offcanvas.Body className="p-0">
                                                <>
                                                  <div
                                                    className="px-3"
                                                    style={{
                                                      backgroundColor:
                                                        "#72bbef",
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      width: "100%",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        paddingTop: "5px",
                                                        display: "flex",
                                                        justifyContent:
                                                          "space-between",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <div className="text-dark">
                                                        {selectFancy}
                                                      </div>
                                                      <div className="text-dark">
                                                        Profit:{" "}
                                                        {(
                                                          money *
                                                          (selectedPrice - 1)
                                                        ).toFixed(1)}
                                                      </div>
                                                    </div>
                                                    <div
                                                      className="row mx-1 py-2"
                                                      style={{
                                                        backgroundColor:
                                                          "#ffffff45",
                                                      }}
                                                    >
                                                      <div className="col-lg-6 col-6 mb-0 px-1">
                                                        <div>
                                                          <h6 className="text-center my-0 text-dark">
                                                            Odds
                                                          </h6>
                                                        </div>
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "28px",
                                                          }}
                                                        >
                                                          <button
                                                            style={{
                                                              backgroundColor:
                                                                "var(--bg-secondary)",
                                                              color:
                                                                "var(--dark-theme-color-navbar)",
                                                              width: "22px",
                                                              border: "none",
                                                              fontSize: "13px",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              justifyContent:
                                                                "center",
                                                              borderRadius:
                                                                "0px",
                                                            }}
                                                            onClick={() =>
                                                              handlefancyChange(
                                                                0
                                                              )
                                                            }
                                                          >
                                                            −
                                                          </button>
                                                          <input
                                                            type="text"
                                                            value={
                                                              selectedMarket
                                                            }
                                                            onChange={(e) =>
                                                              setSelectedMarket(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                "#fff",
                                                              color:
                                                                "var(--dark-theme-white-color)",
                                                              border: "none",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "13px",
                                                              width: "84px",
                                                            }}
                                                          />
                                                          <button
                                                            style={{
                                                              backgroundColor:
                                                                "var(--bg-secondary)",
                                                              color:
                                                                "var(--dark-theme-color-navbar)",
                                                              width: "22px",
                                                              border: "none",
                                                              fontSize: "13px",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              justifyContent:
                                                                "center",
                                                              borderRadius:
                                                                "0px",
                                                            }}
                                                            onClick={() =>
                                                              handlefancyChange(
                                                                1
                                                              )
                                                            }
                                                          >
                                                            +
                                                          </button>
                                                        </div>
                                                      </div>
                                                      <div className="col-lg-6 col-6 mb-0 px-1">
                                                        <div>
                                                          <h6 className="text-center my-0 text-dark">
                                                            Amount
                                                          </h6>
                                                        </div>

                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "28px",
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            value={money}
                                                            onChange={(e) =>
                                                              setMoney(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                themeColors[
                                                                  "--dark-theme-color-navbar"
                                                                ],
                                                              color:
                                                                themeColors[
                                                                  "--dark-theme-white-color"
                                                                ],
                                                              border:
                                                                "1px solid black",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "13px",
                                                              width: "32px",
                                                            }}
                                                          />
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div
                                                      style={{
                                                        display: "grid",
                                                        paddingLeft: "5px",
                                                        paddingRight: "5px",
                                                        gridTemplateColumns:
                                                          "repeat(5, 1fr)",
                                                        gap: "2px",
                                                        marginBottom: "2px",
                                                      }}
                                                    >
                                                      {gameButtons.map(
                                                        (btn) => (
                                                          <button
                                                            key={btn.id}
                                                            className="homebet_setSm"
                                                            style={{
                                                              color:
                                                                themeColors[
                                                                  "--text-secondary"
                                                                ],
                                                              padding: "5px 0",
                                                              border: "none",
                                                              fontWeight:
                                                                "bold",
                                                            }}
                                                            onClick={() =>
                                                              setMoney(
                                                                btn.value
                                                              )
                                                            }
                                                          >
                                                            + {btn.label}
                                                          </button>
                                                        )
                                                      )}
                                                    </div>

                                                    <div
                                                      style={{
                                                        display: "grid",
                                                        padding:
                                                          "2px 5px 4px 5px",
                                                        gridTemplateColumns:
                                                          "repeat(4, 1fr)",
                                                        marginBottom: "8px",
                                                      }}
                                                    >
                                                      <button
                                                        style={{
                                                          backgroundColor:
                                                            "transparent",
                                                          color: "#0d6efd",
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          setMoney(0);
                                                          setPr(0);
                                                        }}
                                                      >
                                                        Clear
                                                      </button>
                                                      <button
                                                        style={{
                                                          backgroundColor:
                                                            themeColors[
                                                              "--bg-info"
                                                            ],
                                                          color:
                                                            themeColors[
                                                              "--dark-theme-color-navbar"
                                                            ],
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          handleShowV();
                                                        }}
                                                      >
                                                        Edit
                                                      </button>

                                                      <button
                                                        style={{
                                                          background:
                                                            themeColors[
                                                              "--bg-danger"
                                                            ],
                                                          color:
                                                            themeColors[
                                                              "--dark-theme-color-navbar"
                                                            ],
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          setbackActive(0);
                                                          setSelectedBet(0);
                                                          setlayActive(3);
                                                          setMoney(0);
                                                          setPr(0);
                                                        }}
                                                      >
                                                        Reset
                                                      </button>
                                                      <button
                                                        style={{
                                                          background:
                                                            themeColors[
                                                              "--bg-success"
                                                            ],
                                                          color:
                                                            themeColors[
                                                              "--dark-theme-color-navbar"
                                                            ],
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          handleSubmit3();
                                                          setSelectedBet(0);
                                                        }}
                                                      >
                                                        Submit
                                                      </button>
                                                    </div>
                                                  </div>
                                                </>
                                              </Offcanvas.Body>
                                            </Offcanvas>
                                          )}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            ) : (
                              <p className="text-white"></p>
                            )}
                            {/* /Session */}

                            {/* WP Market */}
                            {Array.isArray(wpMarket) &&
                            wpMarket.length > 0 &&
                            (newactive === 0 || newactive === 2) ? (
                              <div className="align-items-baseline">
                                {isExpanded4 === 1 && (
                                  <div className="w-100">
                                    {wpMarket.map((item, index) => (
                                      <div key={index} className="w-100 mb-0">
                                        {/* back */}
                                        {fancymarket === index &&
                                          selectedBet === 10 && (
                                            <Offcanvas
                                              show={show}
                                              onHide={handleClose}
                                              placement="top"
                                              style={{
                                                height: "45vh",
                                                background: "transparent",
                                              }}
                                            >
                                              <Offcanvas.Header
                                                closeButton
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-primary"],
                                                  padding: "10px",
                                                  color:
                                                    themeColors[
                                                      "--text-primary"
                                                    ],
                                                }}
                                              >
                                                <Offcanvas.Title className="my-0">
                                                  Place Bet
                                                </Offcanvas.Title>
                                              </Offcanvas.Header>
                                              <Offcanvas.Body className="p-0">
                                                <>
                                                  <div
                                                    className="px-3"
                                                    style={{
                                                      backgroundColor:
                                                        "#faa9ba",
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      width: "100%",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        paddingTop: "5px",
                                                        display: "flex",
                                                        justifyContent:
                                                          "space-between",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <div className="text-dark">
                                                        {selectFancy}
                                                      </div>
                                                      <div className="text-dark">
                                                        Profit:{" "}
                                                        {(
                                                          money *
                                                          (selectedPrice - 1)
                                                        ).toFixed(1)}
                                                      </div>
                                                    </div>
                                                    <div
                                                      className="row mx-1 py-2"
                                                      style={{
                                                        backgroundColor:
                                                          "#ffffff45",
                                                      }}
                                                    >
                                                      <div className="col-lg-6 col-6 mb-0 px-1">
                                                        <div>
                                                          <h6 className="text-center my-0 text-dark">
                                                            Odds
                                                          </h6>
                                                        </div>
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "28px",
                                                          }}
                                                        >
                                                          <button
                                                            style={{
                                                              backgroundColor:
                                                                "var(--bg-secondary)",
                                                              color:
                                                                "var(--dark-theme-color-navbar)",
                                                              width: "22px",
                                                              border: "none",
                                                              fontSize: "13px",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              justifyContent:
                                                                "center",
                                                              borderRadius:
                                                                "0px",
                                                            }}
                                                            onClick={() =>
                                                              handlefancyChange(
                                                                0
                                                              )
                                                            }
                                                          >
                                                            −
                                                          </button>
                                                          <input
                                                            type="text"
                                                            value={
                                                              selectedMarket
                                                            }
                                                            onChange={(e) =>
                                                              setSelectedMarket(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                "#fff",
                                                              color:
                                                                "var(--dark-theme-white-color)",
                                                              border: "none",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "13px",
                                                              width: "84px",
                                                            }}
                                                          />
                                                          <button
                                                            style={{
                                                              backgroundColor:
                                                                "var(--bg-secondary)",
                                                              color:
                                                                "var(--dark-theme-color-navbar)",
                                                              width: "22px",
                                                              border: "none",
                                                              fontSize: "13px",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              justifyContent:
                                                                "center",
                                                              borderRadius:
                                                                "0px",
                                                            }}
                                                            onClick={() =>
                                                              handlefancyChange(
                                                                1
                                                              )
                                                            }
                                                          >
                                                            +
                                                          </button>
                                                        </div>
                                                      </div>
                                                      <div className="col-lg-6 col-6 mb-0 px-1">
                                                        <div>
                                                          <h6 className="text-center my-0 text-dark">
                                                            Amount
                                                          </h6>
                                                        </div>

                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "28px",
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            value={money}
                                                            onChange={(e) =>
                                                              setMoney(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                themeColors[
                                                                  "--dark-theme-color-navbar"
                                                                ],
                                                              color:
                                                                themeColors[
                                                                  "--dark-theme-white-color"
                                                                ],
                                                              border:
                                                                "1px solid black",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "13px",
                                                              width: "32px",
                                                            }}
                                                          />
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div
                                                      style={{
                                                        display: "grid",
                                                        paddingLeft: "5px",
                                                        paddingRight: "5px",
                                                        gridTemplateColumns:
                                                          "repeat(4, 1fr)",
                                                        gap: "2px",
                                                        marginBottom: "2px",
                                                      }}
                                                    >
                                                      {gameButtons.map(
                                                        (btn) => (
                                                          <button
                                                            key={btn.id}
                                                            className="homebet_setSm"
                                                            style={{
                                                              color:
                                                                themeColors[
                                                                  "--text-secondary"
                                                                ],
                                                              padding: "5px 0",
                                                              border: "none",
                                                              fontWeight:
                                                                "bold",
                                                            }}
                                                            onClick={() =>
                                                              setMoney(
                                                                btn.value
                                                              )
                                                            }
                                                          >
                                                            + {btn.label}
                                                          </button>
                                                        )
                                                      )}
                                                    </div>

                                                    <div
                                                      style={{
                                                        display: "grid",
                                                        padding:
                                                          "2px 5px 4px 5px",
                                                        gridTemplateColumns:
                                                          "repeat(4, 1fr)",
                                                        marginBottom: "8px",
                                                      }}
                                                    >
                                                      <button
                                                        style={{
                                                          backgroundColor:
                                                            "transparent",
                                                          color: "#0d6efd",
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          setMoney(0);
                                                          setPr(0);
                                                        }}
                                                      >
                                                        Clear
                                                      </button>
                                                      <button
                                                        style={{
                                                          backgroundColor:
                                                            themeColors[
                                                              "--bg-info"
                                                            ],
                                                          color:
                                                            themeColors[
                                                              "--dark-theme-color-navbar"
                                                            ],
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          handleShowV();
                                                        }}
                                                      >
                                                        Edit
                                                      </button>

                                                      <button
                                                        style={{
                                                          background:
                                                            themeColors[
                                                              "--bg-danger"
                                                            ],
                                                          color:
                                                            themeColors[
                                                              "--dark-theme-color-navbar"
                                                            ],
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          setbackActive(0);
                                                          setSelectedBet(0);
                                                          setlayActive(3);
                                                          setMoney(0);
                                                          setPr(0);
                                                        }}
                                                      >
                                                        Reset
                                                      </button>
                                                      <button
                                                        style={{
                                                          background:
                                                            themeColors[
                                                              "--bg-success"
                                                            ],
                                                          color:
                                                            themeColors[
                                                              "--dark-theme-color-navbar"
                                                            ],
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          handleSubmit3();
                                                          setSelectedBet(0);
                                                        }}
                                                      >
                                                        Submit
                                                      </button>
                                                    </div>
                                                  </div>
                                                </>
                                              </Offcanvas.Body>
                                            </Offcanvas>
                                          )}

                                        {/* lay */}
                                        {fancymarket === index &&
                                          selectedBet === 9 && (
                                            <Offcanvas
                                              show={show}
                                              onHide={handleClose}
                                              placement="top"
                                              style={{
                                                height: "45vh",
                                                background: "transparent",
                                              }}
                                            >
                                              <Offcanvas.Header
                                                closeButton
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-primary"],
                                                  padding: "10px",
                                                  color:
                                                    themeColors[
                                                      "--text-primary"
                                                    ],
                                                }}
                                              >
                                                <Offcanvas.Title className="my-0">
                                                  Place Bet
                                                </Offcanvas.Title>
                                              </Offcanvas.Header>
                                              <Offcanvas.Body className="p-0">
                                                <>
                                                  <div
                                                    className="px-3"
                                                    style={{
                                                      backgroundColor:
                                                        "#72bbef",
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      width: "100%",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        paddingTop: "5px",
                                                        display: "flex",
                                                        justifyContent:
                                                          "space-between",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <div className="text-dark">
                                                        {selectFancy}
                                                      </div>
                                                      <div className="text-dark">
                                                        Profit:{" "}
                                                        {(
                                                          money *
                                                          (selectedPrice - 1)
                                                        ).toFixed(1)}
                                                      </div>
                                                    </div>
                                                    <div
                                                      className="row mx-1 py-2"
                                                      style={{
                                                        backgroundColor:
                                                          "#ffffff45",
                                                      }}
                                                    >
                                                      <div className="col-lg-6 col-6 mb-0 px-1">
                                                        <div>
                                                          <h6 className="text-center my-0 text-dark">
                                                            Odds
                                                          </h6>
                                                        </div>
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "28px",
                                                          }}
                                                        >
                                                          <button
                                                            style={{
                                                              backgroundColor:
                                                                "var(--bg-secondary)",
                                                              color:
                                                                "var(--dark-theme-color-navbar)",
                                                              width: "22px",
                                                              border: "none",
                                                              fontSize: "13px",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              justifyContent:
                                                                "center",
                                                              borderRadius:
                                                                "0px",
                                                            }}
                                                            onClick={() =>
                                                              handlefancyChange(
                                                                0
                                                              )
                                                            }
                                                          >
                                                            −
                                                          </button>
                                                          <input
                                                            type="text"
                                                            value={
                                                              selectedMarket
                                                            }
                                                            onChange={(e) =>
                                                              setSelectedMarket(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                "#fff",
                                                              color:
                                                                "var(--dark-theme-white-color)",
                                                              border: "none",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "13px",
                                                              width: "84px",
                                                            }}
                                                          />
                                                          <button
                                                            style={{
                                                              backgroundColor:
                                                                "var(--bg-secondary)",
                                                              color:
                                                                "var(--dark-theme-color-navbar)",
                                                              width: "22px",
                                                              border: "none",
                                                              fontSize: "13px",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              justifyContent:
                                                                "center",
                                                              borderRadius:
                                                                "0px",
                                                            }}
                                                            onClick={() =>
                                                              handlefancyChange(
                                                                1
                                                              )
                                                            }
                                                          >
                                                            +
                                                          </button>
                                                        </div>
                                                      </div>
                                                      <div className="col-lg-6 col-6 mb-0 px-1">
                                                        <div>
                                                          <h6 className="text-center my-0 text-dark">
                                                            Amount
                                                          </h6>
                                                        </div>

                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "28px",
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            value={money}
                                                            onChange={(e) =>
                                                              setMoney(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                themeColors[
                                                                  "--dark-theme-color-navbar"
                                                                ],
                                                              color:
                                                                themeColors[
                                                                  "--dark-theme-white-color"
                                                                ],
                                                              border:
                                                                "1px solid black",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "13px",
                                                              width: "32px",
                                                            }}
                                                          />
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div
                                                      style={{
                                                        display: "grid",
                                                        paddingLeft: "5px",
                                                        paddingRight: "5px",
                                                        gridTemplateColumns:
                                                          "repeat(5, 1fr)",
                                                        gap: "2px",
                                                        marginBottom: "2px",
                                                      }}
                                                    >
                                                      {gameButtons.map(
                                                        (btn) => (
                                                          <button
                                                            key={btn.id}
                                                            className="homebet_setSm"
                                                            style={{
                                                              color:
                                                                themeColors[
                                                                  "--text-secondary"
                                                                ],
                                                              padding: "5px 0",
                                                              border: "none",
                                                              fontWeight:
                                                                "bold",
                                                            }}
                                                            onClick={() =>
                                                              setMoney(
                                                                btn.value
                                                              )
                                                            }
                                                          >
                                                            + {btn.label}
                                                          </button>
                                                        )
                                                      )}
                                                    </div>

                                                    <div
                                                      style={{
                                                        display: "grid",
                                                        padding:
                                                          "2px 5px 4px 5px",
                                                        gridTemplateColumns:
                                                          "repeat(4, 1fr)",
                                                        marginBottom: "8px",
                                                      }}
                                                    >
                                                      <button
                                                        style={{
                                                          backgroundColor:
                                                            "transparent",
                                                          color: "#0d6efd",
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          setMoney(0);
                                                          setPr(0);
                                                        }}
                                                      >
                                                        Clear
                                                      </button>
                                                      <button
                                                        style={{
                                                          backgroundColor:
                                                            themeColors[
                                                              "--bg-info"
                                                            ],
                                                          color:
                                                            themeColors[
                                                              "--dark-theme-color-navbar"
                                                            ],
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          handleShowV();
                                                        }}
                                                      >
                                                        Edit
                                                      </button>

                                                      <button
                                                        style={{
                                                          background:
                                                            themeColors[
                                                              "--bg-danger"
                                                            ],
                                                          color:
                                                            themeColors[
                                                              "--dark-theme-color-navbar"
                                                            ],
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          setbackActive(0);
                                                          setSelectedBet(0);
                                                          setlayActive(3);
                                                          setMoney(0);
                                                          setPr(0);
                                                        }}
                                                      >
                                                        Reset
                                                      </button>
                                                      <button
                                                        style={{
                                                          background:
                                                            themeColors[
                                                              "--bg-success"
                                                            ],
                                                          color:
                                                            themeColors[
                                                              "--dark-theme-color-navbar"
                                                            ],
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          handleSubmit3();
                                                          setSelectedBet(0);
                                                        }}
                                                      >
                                                        Submit
                                                      </button>
                                                    </div>
                                                  </div>
                                                </>
                                              </Offcanvas.Body>
                                            </Offcanvas>
                                          )}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            ) : (
                              <p className="text-white"></p>
                            )}
                            {/* /WP Market */}

                            {/* ODD/EVEN */}
                            {Array.isArray(oddEven) &&
                            oddEven.length > 0 &&
                            (newactive === 0 || newactive === 3) ? (
                              <div className="align-items-baseline w-100 mt-0">
                                {isExpanded6 === 1 && (
                                  <div className="w-100">
                                    {/* Map through wpMarket */}
                                    {oddEven.map((item, index) => (
                                      <div key={index} className="w-100">
                                        {/* back */}
                                        {fancyOdd === index &&
                                          selectedBet === 12 && (
                                            <Offcanvas
                                              show={show}
                                              onHide={handleClose}
                                              placement="top"
                                              style={{
                                                height: "45vh",
                                                background: "transparent",
                                              }}
                                            >
                                              <Offcanvas.Header
                                                closeButton
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-primary"],
                                                  padding: "10px",
                                                  color:
                                                    themeColors[
                                                      "--text-primary"
                                                    ],
                                                }}
                                              >
                                                <Offcanvas.Title className="my-0">
                                                  Place Bet
                                                </Offcanvas.Title>
                                              </Offcanvas.Header>
                                              <Offcanvas.Body className="p-0">
                                                <>
                                                  <div
                                                    className="px-3"
                                                    style={{
                                                      backgroundColor:
                                                        "#faa9ba",
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      width: "100%",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        paddingTop: "5px",
                                                        display: "flex",
                                                        justifyContent:
                                                          "space-between",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <div className="text-dark">
                                                        {selectFancy}
                                                      </div>
                                                      <div className="text-dark">
                                                        Profit:{" "}
                                                        {(
                                                          money *
                                                          (selectedPrice - 1)
                                                        ).toFixed(1)}
                                                      </div>
                                                    </div>
                                                    <div
                                                      className="row mx-1 py-2"
                                                      style={{
                                                        backgroundColor:
                                                          "#ffffff45",
                                                      }}
                                                    >
                                                      <div className="col-lg-6 col-6 mb-0 px-1">
                                                        <div>
                                                          <h6 className="text-center my-0 text-dark">
                                                            Odds
                                                          </h6>
                                                        </div>
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "28px",
                                                          }}
                                                        >
                                                          <button
                                                            style={{
                                                              backgroundColor:
                                                                "var(--bg-secondary)",
                                                              color:
                                                                "var(--dark-theme-color-navbar)",
                                                              width: "22px",
                                                              border: "none",
                                                              fontSize: "13px",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              justifyContent:
                                                                "center",
                                                              borderRadius:
                                                                "0px",
                                                            }}
                                                            onClick={() =>
                                                              handlefancyChange(
                                                                0
                                                              )
                                                            }
                                                          >
                                                            −
                                                          </button>
                                                          <input
                                                            type="text"
                                                            value={
                                                              selectedMarket
                                                            }
                                                            onChange={(e) =>
                                                              setSelectedMarket(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                "#fff",
                                                              color:
                                                                "var(--dark-theme-white-color)",
                                                              border: "none",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "13px",
                                                              width: "84px",
                                                            }}
                                                          />
                                                          <button
                                                            style={{
                                                              backgroundColor:
                                                                "var(--bg-secondary)",
                                                              color:
                                                                "var(--dark-theme-color-navbar)",
                                                              width: "22px",
                                                              border: "none",
                                                              fontSize: "13px",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              justifyContent:
                                                                "center",
                                                              borderRadius:
                                                                "0px",
                                                            }}
                                                            onClick={() =>
                                                              handlefancyChange(
                                                                1
                                                              )
                                                            }
                                                          >
                                                            +
                                                          </button>
                                                        </div>
                                                      </div>
                                                      <div className="col-lg-6 col-6 mb-0 px-1">
                                                        <div>
                                                          <h6 className="text-center my-0 text-dark">
                                                            Amount
                                                          </h6>
                                                        </div>

                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "28px",
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            value={money}
                                                            onChange={(e) =>
                                                              setMoney(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                themeColors[
                                                                  "--dark-theme-color-navbar"
                                                                ],
                                                              color:
                                                                themeColors[
                                                                  "--dark-theme-white-color"
                                                                ],
                                                              border:
                                                                "1px solid black",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "13px",
                                                              width: "32px",
                                                            }}
                                                          />
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div
                                                      style={{
                                                        display: "grid",
                                                        paddingLeft: "5px",
                                                        paddingRight: "5px",
                                                        gridTemplateColumns:
                                                          "repeat(4, 1fr)",
                                                        gap: "2px",
                                                        marginBottom: "2px",
                                                      }}
                                                    >
                                                      {gameButtons.map(
                                                        (btn) => (
                                                          <button
                                                            key={btn.id}
                                                            className="homebet_setSm"
                                                            style={{
                                                              color:
                                                                themeColors[
                                                                  "--text-secondary"
                                                                ],
                                                              padding: "5px 0",
                                                              border: "none",
                                                              fontWeight:
                                                                "bold",
                                                            }}
                                                            onClick={() =>
                                                              setMoney(
                                                                btn.value
                                                              )
                                                            }
                                                          >
                                                            + {btn.label}
                                                          </button>
                                                        )
                                                      )}
                                                    </div>

                                                    <div
                                                      style={{
                                                        display: "grid",
                                                        padding:
                                                          "2px 5px 4px 5px",
                                                        gridTemplateColumns:
                                                          "repeat(4, 1fr)",
                                                        marginBottom: "8px",
                                                      }}
                                                    >
                                                      <button
                                                        style={{
                                                          backgroundColor:
                                                            "transparent",
                                                          color: "#0d6efd",
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          setMoney(0);
                                                          setPr(0);
                                                        }}
                                                      >
                                                        Clear
                                                      </button>
                                                      <button
                                                        style={{
                                                          backgroundColor:
                                                            themeColors[
                                                              "--bg-info"
                                                            ],
                                                          color:
                                                            themeColors[
                                                              "--dark-theme-color-navbar"
                                                            ],
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          handleShowV();
                                                        }}
                                                      >
                                                        Edit
                                                      </button>

                                                      <button
                                                        style={{
                                                          background:
                                                            themeColors[
                                                              "--bg-danger"
                                                            ],
                                                          color:
                                                            themeColors[
                                                              "--dark-theme-color-navbar"
                                                            ],
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          setbackActive(0);
                                                          setSelectedBet(0);
                                                          setlayActive(3);
                                                          setMoney(0);
                                                          setPr(0);
                                                        }}
                                                      >
                                                        Reset
                                                      </button>
                                                      <button
                                                        style={{
                                                          background:
                                                            themeColors[
                                                              "--bg-success"
                                                            ],
                                                          color:
                                                            themeColors[
                                                              "--dark-theme-color-navbar"
                                                            ],
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          handleSubmit3();
                                                          setSelectedBet(0);
                                                        }}
                                                      >
                                                        Submit
                                                      </button>
                                                    </div>
                                                  </div>
                                                </>
                                              </Offcanvas.Body>
                                            </Offcanvas>
                                          )}

                                        {/* lay */}
                                        {fancyOdd === index &&
                                          selectedBet === 11 && (
                                            <Offcanvas
                                              show={show}
                                              onHide={handleClose}
                                              placement="top"
                                              style={{
                                                height: "45vh",
                                                background: "transparent",
                                              }}
                                            >
                                              <Offcanvas.Header
                                                closeButton
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-primary"],
                                                  padding: "10px",
                                                  color:
                                                    themeColors[
                                                      "--text-primary"
                                                    ],
                                                }}
                                              >
                                                <Offcanvas.Title className="my-0">
                                                  Place Bet
                                                </Offcanvas.Title>
                                              </Offcanvas.Header>
                                              <Offcanvas.Body className="p-0">
                                                <>
                                                  <div
                                                    className="px-3"
                                                    style={{
                                                      backgroundColor:
                                                        "#72bbef",
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      width: "100%",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        paddingTop: "5px",
                                                        display: "flex",
                                                        justifyContent:
                                                          "space-between",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <div className="text-dark">
                                                        {selectFancy}
                                                      </div>
                                                      <div className="text-dark">
                                                        Profit:{" "}
                                                        {(
                                                          money *
                                                          (selectedPrice - 1)
                                                        ).toFixed(1)}
                                                      </div>
                                                    </div>
                                                    <div
                                                      className="row mx-1 py-2"
                                                      style={{
                                                        backgroundColor:
                                                          "#ffffff45",
                                                      }}
                                                    >
                                                      <div className="col-lg-6 col-6 mb-0 px-1">
                                                        <div>
                                                          <h6 className="text-center my-0 text-dark">
                                                            Odds
                                                          </h6>
                                                        </div>
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "28px",
                                                          }}
                                                        >
                                                          <button
                                                            style={{
                                                              backgroundColor:
                                                                "var(--bg-secondary)",
                                                              color:
                                                                "var(--dark-theme-color-navbar)",
                                                              width: "22px",
                                                              border: "none",
                                                              fontSize: "13px",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              justifyContent:
                                                                "center",
                                                              borderRadius:
                                                                "0px",
                                                            }}
                                                            onClick={() =>
                                                              handlefancyChange(
                                                                0
                                                              )
                                                            }
                                                          >
                                                            −
                                                          </button>
                                                          <input
                                                            type="text"
                                                            value={
                                                              selectedMarket
                                                            }
                                                            onChange={(e) =>
                                                              setSelectedMarket(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                "#fff",
                                                              color:
                                                                "var(--dark-theme-white-color)",
                                                              border: "none",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "13px",
                                                              width: "84px",
                                                            }}
                                                          />
                                                          <button
                                                            style={{
                                                              backgroundColor:
                                                                "var(--bg-secondary)",
                                                              color:
                                                                "var(--dark-theme-color-navbar)",
                                                              width: "22px",
                                                              border: "none",
                                                              fontSize: "13px",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              justifyContent:
                                                                "center",
                                                              borderRadius:
                                                                "0px",
                                                            }}
                                                            onClick={() =>
                                                              handlefancyChange(
                                                                1
                                                              )
                                                            }
                                                          >
                                                            +
                                                          </button>
                                                        </div>
                                                      </div>
                                                      <div className="col-lg-6 col-6 mb-0 px-1">
                                                        <div>
                                                          <h6 className="text-center my-0 text-dark">
                                                            Amount
                                                          </h6>
                                                        </div>

                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "28px",
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            value={money}
                                                            onChange={(e) =>
                                                              setMoney(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                themeColors[
                                                                  "--dark-theme-color-navbar"
                                                                ],
                                                              color:
                                                                themeColors[
                                                                  "--dark-theme-white-color"
                                                                ],
                                                              border:
                                                                "1px solid black",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "13px",
                                                              width: "32px",
                                                            }}
                                                          />
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div
                                                      style={{
                                                        display: "grid",
                                                        paddingLeft: "5px",
                                                        paddingRight: "5px",
                                                        gridTemplateColumns:
                                                          "repeat(5, 1fr)",
                                                        gap: "2px",
                                                        marginBottom: "2px",
                                                      }}
                                                    >
                                                      {gameButtons.map(
                                                        (btn) => (
                                                          <button
                                                            key={btn.id}
                                                            className="homebet_setSm"
                                                            style={{
                                                              color:
                                                                themeColors[
                                                                  "--text-secondary"
                                                                ],
                                                              padding: "5px 0",
                                                              border: "none",
                                                              fontWeight:
                                                                "bold",
                                                            }}
                                                            onClick={() =>
                                                              setMoney(
                                                                btn.value
                                                              )
                                                            }
                                                          >
                                                            + {btn.label}
                                                          </button>
                                                        )
                                                      )}
                                                    </div>

                                                    <div
                                                      style={{
                                                        display: "grid",
                                                        padding:
                                                          "2px 5px 4px 5px",
                                                        gridTemplateColumns:
                                                          "repeat(4, 1fr)",
                                                        marginBottom: "8px",
                                                      }}
                                                    >
                                                      <button
                                                        style={{
                                                          backgroundColor:
                                                            "transparent",
                                                          color: "#0d6efd",
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          setMoney(0);
                                                          setPr(0);
                                                        }}
                                                      >
                                                        Clear
                                                      </button>
                                                      <button
                                                        style={{
                                                          backgroundColor:
                                                            themeColors[
                                                              "--bg-info"
                                                            ],
                                                          color:
                                                            themeColors[
                                                              "--dark-theme-color-navbar"
                                                            ],
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          handleShowV();
                                                        }}
                                                      >
                                                        Edit
                                                      </button>

                                                      <button
                                                        style={{
                                                          background:
                                                            themeColors[
                                                              "--bg-danger"
                                                            ],
                                                          color:
                                                            themeColors[
                                                              "--dark-theme-color-navbar"
                                                            ],
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          setbackActive(0);
                                                          setSelectedBet(0);
                                                          setlayActive(3);
                                                          setMoney(0);
                                                          setPr(0);
                                                        }}
                                                      >
                                                        Reset
                                                      </button>
                                                      <button
                                                        style={{
                                                          background:
                                                            themeColors[
                                                              "--bg-success"
                                                            ],
                                                          color:
                                                            themeColors[
                                                              "--dark-theme-color-navbar"
                                                            ],
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          handleSubmit3();
                                                          setSelectedBet(0);
                                                        }}
                                                      >
                                                        Submit
                                                      </button>
                                                    </div>
                                                  </div>
                                                </>
                                              </Offcanvas.Body>
                                            </Offcanvas>
                                          )}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            ) : (
                              <p className="text-white"></p>
                            )}
                            {/* /ODD/EVEN */}

                            {/* XTRA */}
                            {Array.isArray(fancy) &&
                            fancy.length > 0 &&
                            (newactive === 0 || newactive === 4) ? (
                              <div className="align-items-baseline w-100">
                                {isExpanded5 === 1 && (
                                  <div className="w-100">
                                    {/* Map through wp Market */}
                                    {fancy.map((item, index) => (
                                      <div key={index} className="w-100">
                                        {/* fancy betting back div */}
                                        {fancyXtra === index &&
                                          selectedBet === 14 && (
                                            <Offcanvas
                                              show={show}
                                              onHide={handleClose}
                                              placement="top"
                                              style={{
                                                height: "45vh",
                                                background: "transparent",
                                              }}
                                            >
                                              <Offcanvas.Header
                                                closeButton
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-primary"],
                                                  padding: "10px",
                                                  color:
                                                    themeColors[
                                                      "--text-primary"
                                                    ],
                                                }}
                                              >
                                                <Offcanvas.Title className="my-0">
                                                  Place Bet
                                                </Offcanvas.Title>
                                              </Offcanvas.Header>
                                              <Offcanvas.Body className="p-0">
                                                <>
                                                  <div
                                                    className="px-3"
                                                    style={{
                                                      backgroundColor:
                                                        "#faa9ba",
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      width: "100%",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        paddingTop: "5px",
                                                        display: "flex",
                                                        justifyContent:
                                                          "space-between",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <div className="text-dark">
                                                        {selectFancy}
                                                      </div>
                                                      <div className="text-dark">
                                                        Profit:{" "}
                                                        {(
                                                          money *
                                                          (selectedPrice - 1)
                                                        ).toFixed(1)}
                                                      </div>
                                                    </div>
                                                    <div
                                                      className="row mx-1 py-2"
                                                      style={{
                                                        backgroundColor:
                                                          "#ffffff45",
                                                      }}
                                                    >
                                                      <div className="col-lg-6 col-6 mb-0 px-1">
                                                        <div>
                                                          <h6 className="text-center my-0 text-dark">
                                                            Odds
                                                          </h6>
                                                        </div>
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "28px",
                                                          }}
                                                        >
                                                          <button
                                                            style={{
                                                              backgroundColor:
                                                                "var(--bg-secondary)",
                                                              color:
                                                                "var(--dark-theme-color-navbar)",
                                                              width: "22px",
                                                              border: "none",
                                                              fontSize: "13px",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              justifyContent:
                                                                "center",
                                                              borderRadius:
                                                                "0px",
                                                            }}
                                                            onClick={() =>
                                                              handlefancyChange(
                                                                0
                                                              )
                                                            }
                                                          >
                                                            −
                                                          </button>
                                                          <input
                                                            type="text"
                                                            value={
                                                              selectedMarket
                                                            }
                                                            onChange={(e) =>
                                                              setSelectedMarket(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                "#fff",
                                                              color:
                                                                "var(--dark-theme-white-color)",
                                                              border: "none",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "13px",
                                                              width: "84px",
                                                            }}
                                                          />
                                                          <button
                                                            style={{
                                                              backgroundColor:
                                                                "var(--bg-secondary)",
                                                              color:
                                                                "var(--dark-theme-color-navbar)",
                                                              width: "22px",
                                                              border: "none",
                                                              fontSize: "13px",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              justifyContent:
                                                                "center",
                                                              borderRadius:
                                                                "0px",
                                                            }}
                                                            onClick={() =>
                                                              handlefancyChange(
                                                                1
                                                              )
                                                            }
                                                          >
                                                            +
                                                          </button>
                                                        </div>
                                                      </div>
                                                      <div className="col-lg-6 col-6 mb-0 px-1">
                                                        <div>
                                                          <h6 className="text-center my-0 text-dark">
                                                            Amount
                                                          </h6>
                                                        </div>

                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "28px",
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            value={money}
                                                            onChange={(e) =>
                                                              setMoney(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                themeColors[
                                                                  "--dark-theme-color-navbar"
                                                                ],
                                                              color:
                                                                themeColors[
                                                                  "--dark-theme-white-color"
                                                                ],
                                                              border:
                                                                "1px solid black",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "13px",
                                                              width: "32px",
                                                            }}
                                                          />
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div
                                                      style={{
                                                        display: "grid",
                                                        paddingLeft: "5px",
                                                        paddingRight: "5px",
                                                        gridTemplateColumns:
                                                          "repeat(4, 1fr)",
                                                        gap: "2px",
                                                        marginBottom: "2px",
                                                      }}
                                                    >
                                                      {gameButtons.map(
                                                        (btn) => (
                                                          <button
                                                            key={btn.id}
                                                            className="homebet_setSm"
                                                            style={{
                                                              color:
                                                                themeColors[
                                                                  "--text-secondary"
                                                                ],
                                                              padding: "5px 0",
                                                              border: "none",
                                                              fontWeight:
                                                                "bold",
                                                            }}
                                                            onClick={() =>
                                                              setMoney(
                                                                btn.value
                                                              )
                                                            }
                                                          >
                                                            + {btn.label}
                                                          </button>
                                                        )
                                                      )}
                                                    </div>

                                                    <div
                                                      style={{
                                                        display: "grid",
                                                        padding:
                                                          "2px 5px 4px 5px",
                                                        gridTemplateColumns:
                                                          "repeat(4, 1fr)",
                                                        marginBottom: "8px",
                                                      }}
                                                    >
                                                      <button
                                                        style={{
                                                          backgroundColor:
                                                            "transparent",
                                                          color: "#0d6efd",
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          setMoney(0);
                                                          setPr(0);
                                                        }}
                                                      >
                                                        Clear
                                                      </button>
                                                      <button
                                                        style={{
                                                          backgroundColor:
                                                            themeColors[
                                                              "--bg-info"
                                                            ],
                                                          color:
                                                            themeColors[
                                                              "--dark-theme-color-navbar"
                                                            ],
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          handleShowV();
                                                        }}
                                                      >
                                                        Edit
                                                      </button>

                                                      <button
                                                        style={{
                                                          background:
                                                            themeColors[
                                                              "--bg-danger"
                                                            ],
                                                          color:
                                                            themeColors[
                                                              "--dark-theme-color-navbar"
                                                            ],
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          setbackActive(0);
                                                          setSelectedBet(0);
                                                          setlayActive(3);
                                                          setMoney(0);
                                                          setPr(0);
                                                        }}
                                                      >
                                                        Reset
                                                      </button>
                                                      <button
                                                        style={{
                                                          background:
                                                            themeColors[
                                                              "--bg-success"
                                                            ],
                                                          color:
                                                            themeColors[
                                                              "--dark-theme-color-navbar"
                                                            ],
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() =>
                                                          handleSubmit3()
                                                        }
                                                      >
                                                        Submit
                                                      </button>
                                                    </div>
                                                  </div>
                                                </>
                                              </Offcanvas.Body>
                                            </Offcanvas>
                                          )}

                                        {/* betting lay div */}
                                        {fancyXtra === index &&
                                          selectedBet === 13 && (
                                            <Offcanvas
                                              show={show}
                                              onHide={handleClose}
                                              placement="top"
                                              style={{
                                                height: "45vh",
                                                background: "transparent",
                                              }}
                                            >
                                              <Offcanvas.Header
                                                closeButton
                                                style={{
                                                  backgroundColor:
                                                    themeColors["--bg-primary"],
                                                  padding: "10px",
                                                  color:
                                                    themeColors[
                                                      "--text-primary"
                                                    ],
                                                }}
                                              >
                                                <Offcanvas.Title className="my-0">
                                                  Place Bet
                                                </Offcanvas.Title>
                                              </Offcanvas.Header>
                                              <Offcanvas.Body className="p-0">
                                                <>
                                                  <div
                                                    className="px-3"
                                                    style={{
                                                      backgroundColor:
                                                        "#72bbef",
                                                      color:
                                                        themeColors[
                                                          "--dark-theme-color-navbar"
                                                        ],
                                                      width: "100%",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        paddingTop: "5px",
                                                        display: "flex",
                                                        justifyContent:
                                                          "space-between",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <div className="text-dark">
                                                        {selectFancy}
                                                      </div>
                                                      <div className="text-dark">
                                                        Profit:{" "}
                                                        {(
                                                          money *
                                                          (selectedPrice - 1)
                                                        ).toFixed(1)}
                                                      </div>
                                                    </div>
                                                    <div
                                                      className="row mx-1 py-2"
                                                      style={{
                                                        backgroundColor:
                                                          "#ffffff45",
                                                      }}
                                                    >
                                                      <div className="col-lg-6 col-6 mb-0 px-1">
                                                        <div>
                                                          <h6 className="text-center my-0 text-dark">
                                                            Odds
                                                          </h6>
                                                        </div>
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "28px",
                                                          }}
                                                        >
                                                          <button
                                                            style={{
                                                              backgroundColor:
                                                                "var(--bg-secondary)",
                                                              color:
                                                                "var(--dark-theme-color-navbar)",
                                                              width: "22px",
                                                              border: "none",
                                                              fontSize: "13px",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              justifyContent:
                                                                "center",
                                                              borderRadius:
                                                                "0px",
                                                            }}
                                                            onClick={() =>
                                                              handlefancyChange(
                                                                0
                                                              )
                                                            }
                                                          >
                                                            −
                                                          </button>
                                                          <input
                                                            type="text"
                                                            value={
                                                              selectedMarket
                                                            }
                                                            onChange={(e) =>
                                                              setSelectedMarket(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                "#fff",
                                                              color:
                                                                "var(--dark-theme-white-color)",
                                                              border: "none",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "13px",
                                                              width: "84px",
                                                            }}
                                                          />
                                                          <button
                                                            style={{
                                                              backgroundColor:
                                                                "var(--bg-secondary)",
                                                              color:
                                                                "var(--dark-theme-color-navbar)",
                                                              width: "22px",
                                                              border: "none",
                                                              fontSize: "13px",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              justifyContent:
                                                                "center",
                                                              borderRadius:
                                                                "0px",
                                                            }}
                                                            onClick={() =>
                                                              handlefancyChange(
                                                                1
                                                              )
                                                            }
                                                          >
                                                            +
                                                          </button>
                                                        </div>
                                                      </div>
                                                      <div className="col-lg-6 col-6 mb-0 px-1">
                                                        <div>
                                                          <h6 className="text-center my-0 text-dark">
                                                            Amount
                                                          </h6>
                                                        </div>

                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            height: "28px",
                                                          }}
                                                        >
                                                          <input
                                                            type="text"
                                                            value={money}
                                                            onChange={(e) =>
                                                              setMoney(
                                                                e.target.value
                                                              )
                                                            }
                                                            style={{
                                                              backgroundColor:
                                                                themeColors[
                                                                  "--dark-theme-color-navbar"
                                                                ],
                                                              color:
                                                                themeColors[
                                                                  "--dark-theme-white-color"
                                                                ],
                                                              border:
                                                                "1px solid black",
                                                              flex: 1,
                                                              textAlign:
                                                                "center",
                                                              fontSize: "13px",
                                                              width: "32px",
                                                            }}
                                                          />
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div
                                                      style={{
                                                        display: "grid",
                                                        paddingLeft: "5px",
                                                        paddingRight: "5px",
                                                        gridTemplateColumns:
                                                          "repeat(5, 1fr)",
                                                        gap: "2px",
                                                        marginBottom: "2px",
                                                      }}
                                                    >
                                                      {gameButtons.map(
                                                        (btn) => (
                                                          <button
                                                            key={btn.id}
                                                            className="homebet_setSm"
                                                            style={{
                                                              color:
                                                                themeColors[
                                                                  "--text-secondary"
                                                                ],
                                                              padding: "5px 0",
                                                              border: "none",
                                                              fontWeight:
                                                                "bold",
                                                            }}
                                                            onClick={() =>
                                                              setMoney(
                                                                btn.value
                                                              )
                                                            }
                                                          >
                                                            + {btn.label}
                                                          </button>
                                                        )
                                                      )}
                                                    </div>

                                                    <div
                                                      style={{
                                                        display: "grid",
                                                        padding:
                                                          "2px 5px 4px 5px",
                                                        gridTemplateColumns:
                                                          "repeat(4, 1fr)",
                                                        marginBottom: "8px",
                                                      }}
                                                    >
                                                      <button
                                                        style={{
                                                          backgroundColor:
                                                            "transparent",
                                                          color: "#0d6efd",
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          setMoney(0);
                                                          setPr(0);
                                                        }}
                                                      >
                                                        Clear
                                                      </button>
                                                      <button
                                                        style={{
                                                          backgroundColor:
                                                            themeColors[
                                                              "--bg-info"
                                                            ],
                                                          color:
                                                            themeColors[
                                                              "--dark-theme-color-navbar"
                                                            ],
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          handleShowV();
                                                        }}
                                                      >
                                                        Edit
                                                      </button>

                                                      <button
                                                        style={{
                                                          background:
                                                            themeColors[
                                                              "--bg-danger"
                                                            ],
                                                          color:
                                                            themeColors[
                                                              "--dark-theme-color-navbar"
                                                            ],
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          setbackActive(0);
                                                          setSelectedBet(0);
                                                          setlayActive(3);
                                                          setMoney(0);
                                                          setPr(0);
                                                        }}
                                                      >
                                                        Reset
                                                      </button>
                                                      <button
                                                        style={{
                                                          background:
                                                            themeColors[
                                                              "--bg-success"
                                                            ],
                                                          color:
                                                            themeColors[
                                                              "--dark-theme-color-navbar"
                                                            ],
                                                          padding: "9px 0",
                                                          border: "none",
                                                          fontWeight: "bold",
                                                        }}
                                                        onClick={() => {
                                                          handleSubmit3();
                                                          setSelectedBet(0);
                                                        }}
                                                      >
                                                        Submit
                                                      </button>
                                                    </div>
                                                  </div>
                                                </>
                                              </Offcanvas.Body>
                                            </Offcanvas>
                                          )}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            ) : (
                              <p className="text-white"></p>
                            )}
                            {/* /XTRA */}
                          </div>
                        )}

                        <div
                          className="m-0 mt-1 px-2 py-1 bett"
                          style={{
                            background: themeColors["--bg-secondary"],
                            color: themeColors["--dark-theme-color"],
                          }}
                        >
                          My Bets
                        </div>

                        {/* <table
                          className=" border  w-100"
                          style={{ borderCollapse: "collapse" }}
                        >
                          <thead>
                            <div
                              style={{
                                color: "black",
                                fontFamily: "sans-serif",
                              }}
                              className="pl-1"
                            >
                              Unmatched bets
                            </div>
                            <tr>
                              <th className="text-dark">Runner Name</th>
                              <th className="text-dark">ODDS</th>
                              <th className="text-dark">Bet Amount</th>
                              <th className="text-dark">P/L</th>
                            </tr>
                          </thead>

                          <tbody>
                            {unmatch?.length > 0 ? (
                              unmatch?.map((bet, index) => (
                                <tr key={index}>
                                  <td>
                                    {bet.runnerName}&nbsp;({bet.type})
                                  </td>
                                  <td>{bet.betprice}</td>
                                  <td>{bet.betAmount}</td>
                                  <td>{bet.profit}</td>
                                </tr>
                              ))
                            ) : (
                              <tr></tr>
                            )}
                          </tbody>
                        </table> */}
                        <table
                          className="table  w-100"
                          style={{ borderCollapse: "collapse" }}
                        >
                          <thead>
                            {/* <div
                              style={{
                                color: "black",
                                fontFamily: "sans-serif",
                              }}
                              className="pl-1"
                            >
                              Matched bets
                            </div> */}
                            <tr
                              style={{
                                borderBottom:
                                  "1px solid var(--table-border) !important",
                              }}
                            >
                              <th className="headerColor">Matched Bet</th>
                              <th>ODDS</th>
                              <th>Bet Amount</th>
                              <th>P/L</th>
                            </tr>
                          </thead>

                          <tbody>
                            {/* Sports Bets */}
                            {betData?.length > 0 ? (
                              <>
                                <tr>
                                  <th
                                    colSpan={4}
                                    style={{
                                      background: "#000",
                                      color: "#fff",
                                    }}
                                  >
                                    Sports Bets
                                  </th>
                                </tr>
                                {betData.map((bet, index) => (
                                  <tr
                                    key={`sports-${index}`}
                                    style={{
                                      backgroundColor: "#72bbef",
                                      borderBottom:
                                        "1px solid var(--table-border) !important",
                                    }}
                                  >
                                    <td style={{ backgroundColor: "#72bbef" }}>
                                      {bet.runnerName} ({bet.type})
                                    </td>
                                    <td style={{ backgroundColor: "#72bbef" }}>
                                      {bet.betprice}
                                    </td>
                                    <td style={{ backgroundColor: "#72bbef" }}>
                                      {bet.deducted_amount}
                                    </td>
                                    <td style={{ backgroundColor: "#72bbef" }}>
                                      {bet.profit}
                                    </td>
                                  </tr>
                                ))}
                              </>
                            ) : (
                              <tr>
                                <td
                                  colSpan={4}
                                  style={{
                                    color:
                                      themeColors["--dark-theme-demoaccount"],
                                    textAlign: "center",
                                  }}
                                >
                                  No sports bet data
                                </td>
                              </tr>
                            )}

                            {/* Fancy Bets */}
                            {fancyBetData?.length > 0 ? (
                              <>
                                <tr>
                                  <th
                                    colSpan={4}
                                    style={{
                                      background: "#000",
                                      color: "#fff",
                                    }}
                                  >
                                    Fancy Bets
                                  </th>
                                </tr>
                                {fancyBetData.map((bet, index) => (
                                  <tr key={`fancy-${index}`}>
                                    <td>
                                      {bet.runnerName} ({bet.type})
                                    </td>
                                    <td>{bet.rate}</td>
                                    <td>{bet.betAmount}</td>
                                    <td>{bet.profit}</td>
                                  </tr>
                                ))}
                              </>
                            ) : (
                              <tr>
                                <td
                                  colSpan={4}
                                  style={{
                                    color:
                                      themeColors["--dark-theme-demoaccount"],
                                    textAlign: "center",
                                  }}
                                >
                                  No fancy bet data
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <GameButtons
                      showV={showV}
                      handleCloseV={handleCloseV}
                      onButtonsChange={handleButtonsChange}
                    />
                  </div>
                </div>
              </div>
              <MarqueeBottom onMenuClick={handleCanvasShow} />
            </div>
          </app-landing-page-new>
        </div>
      </app-root>
    </>
  );
};

export default Cricket;